var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/dayjs.min.js"(exports, module) {
    !(function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    })(exports, (function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, w = function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, O = function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = (function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = (function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          })(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, d2 = function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, (function(t3, r3) {
            return r3 || (function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            })(t3) || i2.replace(":", "");
          }));
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      })(), Y = _.prototype;
      return O.prototype = Y, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach((function(t2) {
        Y[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      })), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    }));
  }
});

// node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/utc.js
var require_utc = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/utc.js"(exports, module) {
    !(function(t, i) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_utc = i();
    })(exports, (function() {
      "use strict";
      var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
      return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t2) {
          var i2 = { date: t2, utc: true, args: arguments };
          return new f(i2);
        }, u.utc = function(i2) {
          var e2 = n(this.toDate(), { locale: this.$L, utc: true });
          return i2 ? e2.add(this.utcOffset(), t) : e2;
        }, u.local = function() {
          return n(this.toDate(), { locale: this.$L, utc: false });
        };
        var r = u.parse;
        u.parse = function(t2) {
          t2.utc && (this.$u = true), this.$utils().u(t2.$offset) || (this.$offset = t2.$offset), r.call(this, t2);
        };
        var o = u.init;
        u.init = function() {
          if (this.$u) {
            var t2 = this.$d;
            this.$y = t2.getUTCFullYear(), this.$M = t2.getUTCMonth(), this.$D = t2.getUTCDate(), this.$W = t2.getUTCDay(), this.$H = t2.getUTCHours(), this.$m = t2.getUTCMinutes(), this.$s = t2.getUTCSeconds(), this.$ms = t2.getUTCMilliseconds();
          } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s2, f2) {
          var n2 = this.$utils().u;
          if (n2(s2)) return this.$u ? 0 : n2(this.$offset) ? a.call(this) : this.$offset;
          if ("string" == typeof s2 && (s2 = (function(t2) {
            void 0 === t2 && (t2 = "");
            var s3 = t2.match(i);
            if (!s3) return null;
            var f3 = ("" + s3[0]).match(e) || ["-", 0, 0], n3 = f3[0], u3 = 60 * +f3[1] + +f3[2];
            return 0 === u3 ? 0 : "+" === n3 ? u3 : -u3;
          })(s2), null === s2)) return this;
          var u2 = Math.abs(s2) <= 16 ? 60 * s2 : s2;
          if (0 === u2) return this.utc(f2);
          var r2 = this.clone();
          if (f2) return r2.$offset = u2, r2.$u = false, r2;
          var o2 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (r2 = this.local().add(u2 + o2, t)).$offset = u2, r2.$x.$localOffset = o2, r2;
        };
        var h = u.format;
        u.format = function(t2) {
          var i2 = t2 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, i2);
        }, u.valueOf = function() {
          var t2 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t2;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t2) {
          return "s" === t2 && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t2, i2, e2) {
          if (t2 && this.$u === t2.$u) return c.call(this, t2, i2, e2);
          var s2 = this.local(), f2 = n(t2).local();
          return c.call(s2, f2, i2, e2);
        };
      };
    }));
  }
});

// node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/timezone.js
var require_timezone = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/timezone.js"(exports, module) {
    !(function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_timezone = e();
    })(exports, (function() {
      "use strict";
      var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, e = {};
      return function(n, i, o) {
        var r, a = function(t2, n2, i2) {
          void 0 === i2 && (i2 = {});
          var o2 = new Date(t2), r2 = (function(t3, n3) {
            void 0 === n3 && (n3 = {});
            var i3 = n3.timeZoneName || "short", o3 = t3 + "|" + i3, r3 = e[o3];
            return r3 || (r3 = new Intl.DateTimeFormat("en-US", { hour12: false, timeZone: t3, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: i3 }), e[o3] = r3), r3;
          })(n2, i2);
          return r2.formatToParts(o2);
        }, u = function(e2, n2) {
          for (var i2 = a(e2, n2), r2 = [], u2 = 0; u2 < i2.length; u2 += 1) {
            var f2 = i2[u2], s2 = f2.type, m = f2.value, c = t[s2];
            c >= 0 && (r2[c] = parseInt(m, 10));
          }
          var d = r2[3], l = 24 === d ? 0 : d, h = r2[0] + "-" + r2[1] + "-" + r2[2] + " " + l + ":" + r2[4] + ":" + r2[5] + ":000", v = +e2;
          return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t2, e2) {
          void 0 === t2 && (t2 = r);
          var n2, i2 = this.utcOffset(), a2 = this.toDate(), u2 = a2.toLocaleString("en-US", { timeZone: t2 }), f2 = Math.round((a2 - new Date(u2)) / 1e3 / 60), s2 = 15 * -Math.round(a2.getTimezoneOffset() / 15) - f2;
          if (!Number(s2)) n2 = this.utcOffset(0, e2);
          else if (n2 = o(u2, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(s2, true), e2) {
            var m = n2.utcOffset();
            n2 = n2.add(i2 - m, "minute");
          }
          return n2.$x.$timezone = t2, n2;
        }, f.offsetName = function(t2) {
          var e2 = this.$x.$timezone || o.tz.guess(), n2 = a(this.valueOf(), e2, { timeZoneName: t2 }).find((function(t3) {
            return "timezonename" === t3.type.toLowerCase();
          }));
          return n2 && n2.value;
        };
        var s = f.startOf;
        f.startOf = function(t2, e2) {
          if (!this.$x || !this.$x.$timezone) return s.call(this, t2, e2);
          var n2 = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return s.call(n2, t2, e2).tz(this.$x.$timezone, true);
        }, o.tz = function(t2, e2, n2) {
          var i2 = n2 && e2, a2 = n2 || e2 || r, f2 = u(+o(), a2);
          if ("string" != typeof t2) return o(t2).tz(a2);
          var s2 = (function(t3, e3, n3) {
            var i3 = t3 - 60 * e3 * 1e3, o2 = u(i3, n3);
            if (e3 === o2) return [i3, e3];
            var r2 = u(i3 -= 60 * (o2 - e3) * 1e3, n3);
            return o2 === r2 ? [i3, o2] : [t3 - 60 * Math.min(o2, r2) * 1e3, Math.max(o2, r2)];
          })(o.utc(t2, i2).valueOf(), f2, a2), m = s2[0], c = s2[1], d = o(m).utcOffset(c);
          return d.$x.$timezone = a2, d;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t2) {
          r = t2;
        };
      };
    }));
  }
});

// node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/isoWeek.js
var require_isoWeek = __commonJS({
  "node_modules/.pnpm/dayjs@1.11.21/node_modules/dayjs/plugin/isoWeek.js"(exports, module) {
    !(function(e, t) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isoWeek = t();
    })(exports, (function() {
      "use strict";
      var e = "day";
      return function(t, i, s) {
        var a = function(t2) {
          return t2.add(4 - t2.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
          return a(this).year();
        }, d.isoWeek = function(t2) {
          if (!this.$utils().u(t2)) return this.add(7 * (t2 - this.isoWeek()), e);
          var i2, d2, n2, o, r = a(this), u = (i2 = this.isoWeekYear(), d2 = this.$u, n2 = (d2 ? s.utc : s)().year(i2).startOf("year"), o = 4 - n2.isoWeekday(), n2.isoWeekday() > 4 && (o += 7), n2.add(o, e));
          return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e2) {
          return this.$utils().u(e2) ? this.day() || 7 : this.day(this.day() % 7 ? e2 : e2 - 7);
        };
        var n = d.startOf;
        d.startOf = function(e2, t2) {
          var i2 = this.$utils(), s2 = !!i2.u(t2) || t2;
          return "isoweek" === i2.p(e2) ? s2 ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e2, t2);
        };
      };
    }));
  }
});

// js/framework/logger.js
var STORAGE_KEY = "fluxon-log-enabled";
var enabled = false;
var depth = 0;
var causalityStack = [];
try {
  enabled = sessionStorage.getItem(STORAGE_KEY) === "true";
} catch {
}
function persist(value) {
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, "true");
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
  }
}
var logger = {
  get enabled() {
    return enabled;
  },
  enable() {
    enabled = true;
    persist(true);
    console.log("%cFluxon logging enabled", "font-weight: bold; color: #059669");
  },
  disable() {
    enabled = false;
    persist(false);
    console.log("%cFluxon logging disabled", "font-weight: bold; color: #dc2626");
  },
  log(category, component, message, ...extra) {
    if (!enabled) return;
    const indent = "  ".repeat(depth);
    console.log(`${indent}[${category}] ${component} ${message}`, ...extra);
  },
  cause(kind, name, fn) {
    if (!enabled) return fn();
    causalityStack.push({ kind, name });
    depth++;
    try {
      return fn();
    } finally {
      causalityStack.pop();
      depth--;
    }
  },
  // Deduped names of currently-active causes of the given kind. Used by effect logs to
  // show "← (signal-a, signal-b)" trailing on the line.
  causes(kind = "signal") {
    return [...new Set(causalityStack.filter((c) => c.kind === kind).map((c) => c.name))];
  },
  error(category, message) {
    console.error(`[${category}] ${message}`);
  },
  fmt(value) {
    if (value === null) return "null";
    if (value === void 0) return "undefined";
    if (typeof value === "string") {
      return value.length > 30 ? `"${value.slice(0, 30)}..."` : `"${value}"`;
    }
    if (typeof value === "number" || typeof value === "boolean") return String(value);
    if (value instanceof Element) {
      const tag = value.tagName?.toLowerCase() || "element";
      const part = value.dataset?.part;
      return part ? `<${tag} data-part="${part}">` : `<${tag}>`;
    }
    if (Array.isArray(value)) return `[${value.length}]`;
    if (typeof value === "object") return "{...}";
    return String(value);
  }
};
var logger_default = logger;

// js/framework/reactivity.js
var arraysShallowEqual = (a, b) => {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};
function createSignal(ctx, initialValue, options = {}) {
  if (typeof options === "string") options = { name: options };
  const { name = null, from = null, equals = Object.is } = options;
  let value = from ? from() : initialValue;
  let previousValue = void 0;
  const subscribers = /* @__PURE__ */ new Set();
  const componentPrefix = ctx.componentName;
  const write = (newValue, skipUpdatedEffects) => {
    if (equals(value, newValue)) return;
    previousValue = value;
    value = newValue;
    logger_default.log("signal", componentPrefix, `${name || "signal"} ${logger_default.fmt(previousValue)} \u2192 ${logger_default.fmt(newValue)}`);
    logger_default.cause("signal", name, () => {
      const skip = skipUpdatedEffects ? new Set(ctx.updatedEffects) : null;
      Array.from(subscribers).forEach((effect) => {
        if (skip?.has(effect)) return;
        effect.run();
      });
    });
  };
  const sig = {
    get value() {
      if (ctx.currentEffect?.deps) {
        subscribers.add(ctx.currentEffect);
        ctx.currentEffect.deps.add(sig);
      }
      return value;
    },
    set value(newValue) {
      write(newValue, false);
    },
    get previous() {
      return previousValue;
    },
    // Internal: effects call this from their cleanup to unsubscribe. Not part of the
    // public surface — components should never need to manipulate subscriptions directly.
    _unsubscribe(effect) {
      subscribers.delete(effect);
    }
  };
  if (from && ctx.fromSignals) {
    ctx.fromSignals.push({ refresh: () => write(from(), true) });
  }
  return sig;
}
function untrack(ctx, fn) {
  const prevEffect = ctx.currentEffect;
  const prevController = ctx.currentEffectController;
  ctx.currentEffect = null;
  ctx.currentEffectController = null;
  try {
    return fn();
  } finally {
    ctx.currentEffect = prevEffect;
    ctx.currentEffectController = prevController;
  }
}
function createEffect(ctx, name, fn, options = {}) {
  const { onUpdated = false } = options;
  const componentPrefix = ctx.componentName;
  let isRunning = false;
  let effectController = null;
  const unsubscribeAll = () => {
    reaction.deps.forEach((dep) => dep._unsubscribe?.(reaction));
    reaction.deps.clear();
  };
  const reaction = {
    name,
    deps: /* @__PURE__ */ new Set(),
    destroyed: false,
    run() {
      if (reaction.destroyed || isRunning) return;
      isRunning = true;
      if (logger_default.enabled) {
        const triggers = logger_default.causes("signal");
        const tail = triggers.length ? ` (\u2190 ${triggers.join(", ")})` : "";
        logger_default.log("effect", componentPrefix, `${name || "effect"}${tail}`);
      }
      unsubscribeAll();
      if (effectController) effectController.abort();
      effectController = new AbortController();
      const prevEffect = ctx.currentEffect;
      const prevEffectController = ctx.currentEffectController;
      ctx.currentEffect = reaction;
      ctx.currentEffectController = effectController;
      try {
        const cleanup = fn();
        if (typeof cleanup === "function") {
          effectController.signal.addEventListener("abort", cleanup, { once: true });
        }
      } catch (error) {
        logger_default.error("effect", `${name} failed: ${error.message}`);
      } finally {
        ctx.currentEffect = prevEffect;
        ctx.currentEffectController = prevEffectController;
        isRunning = false;
      }
    },
    destroy() {
      reaction.destroyed = true;
      logger_default.log("cleanup", componentPrefix, `${name} destroyed`);
      if (effectController) {
        effectController.abort();
        effectController = null;
      }
      unsubscribeAll();
    }
  };
  if (onUpdated) {
    ctx.updatedEffects.push(reaction);
  }
  ctx.controller.signal.addEventListener("abort", () => {
    reaction.destroy();
    if (onUpdated) {
      const idx = ctx.updatedEffects.indexOf(reaction);
      if (idx !== -1) ctx.updatedEffects.splice(idx, 1);
    }
  });
  reaction.run();
  return () => reaction.destroy();
}
function createComputed(ctx, name, fn) {
  const result = createSignal(ctx, void 0, `computed:${name}`);
  createEffect(ctx, name, () => {
    result.value = fn();
  });
  return {
    get value() {
      return result.value;
    }
  };
}
function createOnChange(ctx, signal, callbacks) {
  const { enter, exit } = callbacks;
  let initialized = false;
  let hasEnteredOnce = Boolean(signal.value);
  let currentAbortController = null;
  const cancelPending = () => {
    if (currentAbortController) {
      currentAbortController.abort();
      currentAbortController = null;
    }
  };
  createEffect(ctx, "onChange", async () => {
    const isActive = Boolean(signal.value);
    if (!initialized) {
      initialized = true;
      return;
    }
    cancelPending();
    const controller = new AbortController();
    currentAbortController = controller;
    const { signal: abortSignal } = controller;
    try {
      if (isActive && enter) {
        hasEnteredOnce = true;
        await untrack(ctx, () => enter(abortSignal));
      } else if (!isActive && exit && hasEnteredOnce) {
        await untrack(ctx, () => exit(abortSignal));
      }
    } catch (error) {
      if (error.name !== "AbortError") logger_default.error("onChange", `failed: ${error.message}`);
    }
    if (currentAbortController === controller) currentAbortController = null;
  });
  ctx.controller.signal.addEventListener("abort", cancelPending);
}

// js/framework/dom.js
function isDisabled(el) {
  if (!el) return false;
  return el.hasAttribute("disabled") || el.hasAttribute("data-disabled") || el.getAttribute("aria-disabled") === "true";
}
function focusFieldOnInvalid(env, { control, field }) {
  env.effect(
    "native-validation",
    () => {
      const el = control();
      if (!el) return;
      env.on(el, "invalid", (event) => {
        event.preventDefault();
        if (el.form && firstInvalidControl(el.form) !== el) return;
        field()?.focus({ focusVisible: true });
      });
    },
    { onUpdated: true }
  );
}
function firstInvalidControl(form) {
  return Array.from(form.elements).find((el) => el.willValidate && !el.validity.valid) ?? null;
}
function updateAttributes(element, attributes) {
  if (!element || !attributes) return;
  for (const [attr, value] of Object.entries(attributes)) {
    let next;
    if (typeof value === "boolean" && attr.startsWith("aria-")) {
      next = value ? "true" : "false";
    } else if (value === false || value === null || value === void 0) {
      next = null;
    } else if (value === true) {
      next = attr.startsWith("data-") ? "true" : "";
    } else {
      next = String(value);
    }
    if (next === null) {
      if (element.hasAttribute(attr)) element.removeAttribute(attr);
    } else if (element.getAttribute(attr) !== next) {
      element.setAttribute(attr, next);
    }
  }
}
function createParts(ctx, element, schema) {
  const normalize = (config) => typeof config === "string" ? { selector: config, multiple: false, required: false } : { multiple: false, required: false, ...config };
  const queryElements = (cfg) => {
    const elements = element.querySelectorAll(cfg.selector);
    return cfg.multiple ? Array.from(elements) : elements[0] || null;
  };
  const parts = { root: element };
  for (const [name, raw] of Object.entries(schema)) {
    const cfg = normalize(raw);
    const value = queryElements(cfg);
    if (cfg.required && (value === null || Array.isArray(value) && value.length === 0)) {
      throw new Error(`Required part "${name}" not found`);
    }
    Object.defineProperty(parts, name, {
      get: () => queryElements(cfg),
      enumerable: true
    });
  }
  return parts;
}
function createConfig(ctx, element, schema) {
  const config = {};
  const toKebab = (str) => str.replace(/([A-Z])/g, "-$1").toLowerCase();
  const attributeMap = /* @__PURE__ */ new Map();
  const parseValue = (value, def) => {
    if (value === null || value === void 0) return def.default;
    switch (def.type) {
      case "string":
        return value || def.default;
      case "number": {
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? def.default : parsed;
      }
      case "boolean":
        return value !== "false";
      case "enum":
        return def.values?.includes(value) ? value : def.default;
      case "json":
        try {
          return JSON.parse(value);
        } catch {
          return def.default ?? null;
        }
      default:
        return value || def.default;
    }
  };
  for (const [key, def] of Object.entries(schema)) {
    const dataKey = toKebab(key);
    const attrName = `data-${dataKey}`;
    const dataValue = element.getAttribute(attrName);
    let initialValue = parseValue(dataValue, def);
    if (def.validate && !def.validate(initialValue)) {
      initialValue = def.default;
    }
    const signal = createSignal(ctx, initialValue, `config.${key}`);
    attributeMap.set(attrName, { signal, def });
    config[key] = signal;
  }
  const handleMutations = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "attributes") continue;
      const mapping = attributeMap.get(mutation.attributeName);
      if (!mapping) continue;
      const newStringValue = element.getAttribute(mutation.attributeName);
      let newValue = parseValue(newStringValue, mapping.def);
      if (mapping.def.validate && !mapping.def.validate(newValue)) {
        newValue = mapping.def.default;
      }
      if (!Object.is(mapping.signal.value, newValue)) {
        mapping.signal.value = newValue;
      }
    }
  };
  const observer = new MutationObserver(handleMutations);
  observer.observe(element, {
    attributes: true,
    attributeFilter: Array.from(attributeMap.keys())
  });
  const flush = () => handleMutations(observer.takeRecords());
  ctx.configFlushers.push(flush);
  ctx.controller.signal.addEventListener("abort", () => {
    observer.disconnect();
    const i = ctx.configFlushers.indexOf(flush);
    if (i !== -1) ctx.configFlushers.splice(i, 1);
  });
  return config;
}

// js/framework/events.js
function addEventListenerWithCleanup(ctx, target, event, handler, options = {}) {
  const eventOptions = {
    ...options,
    signal: options.signal || ctx.currentEffectController?.signal || ctx.controller.signal
  };
  target.addEventListener(event, handler, eventOptions);
}
function bindEvent(ctx, target, event, handler, options = {}) {
  if (!target) return;
  const { delegate, ...listenerOptions } = options;
  const componentName = ctx.componentName;
  const wrappedHandler = (e) => {
    let logTarget = target;
    let delegateTarget = null;
    if (delegate) {
      delegateTarget = e.target.closest(delegate);
      if (!delegateTarget || !target.contains(delegateTarget)) return;
      logTarget = delegateTarget;
    }
    const targetName = logTarget.tagName?.toLowerCase() || "element";
    const eventLabel = `${targetName}.${event}`;
    logger_default.log("event", componentName, delegate ? `${eventLabel} (delegate: ${delegate})` : eventLabel);
    logger_default.cause("event", eventLabel, () => {
      if (delegate) handler(e, delegateTarget);
      else handler(e);
    });
  };
  addEventListenerWithCleanup(ctx, target, event, wrappedHandler, listenerOptions);
}
function bindKeyboard(ctx, target, key, handler, options = {}) {
  if (!target) return;
  const { preventDefault = true, stopPropagation = false, event = "keydown" } = options;
  const componentName = ctx.componentName;
  const keyHandler = (e) => {
    const matches = Array.isArray(key) ? key.includes(e.key) || key.includes(e.code) : e.key === key || e.code === key;
    if (matches) {
      const targetName = target.tagName?.toLowerCase() || "element";
      const eventLabel = `${targetName}.${event}(${e.key})`;
      logger_default.log("event", componentName, eventLabel);
      logger_default.cause("event", eventLabel, () => {
        if (preventDefault) e.preventDefault();
        if (stopPropagation) e.stopPropagation();
        handler(e);
      });
    }
  };
  addEventListenerWithCleanup(ctx, target, event, keyHandler, options);
}
var outsideObservers = /* @__PURE__ */ new Set();
var outsideListenersInstalled = false;
var witnessedClick = null;
var forEachObserver = (fn) => {
  if (outsideObservers.size === 0) return;
  for (const observer of [...outsideObservers]) {
    if (!outsideObservers.has(observer)) continue;
    try {
      fn(observer);
    } catch (error) {
      logger_default.error("outside-interaction", `observer failed: ${error.message}`);
    }
  }
};
var resolveInsideSet = (inside) => {
  const value = typeof inside === "function" ? inside() : inside;
  return Array.isArray(value) ? value : [value];
};
function installOutsideListeners() {
  if (outsideListenersInstalled) return;
  outsideListenersInstalled = true;
  document.addEventListener("pointerdown", (e) => {
    forEachObserver((observer) => {
      observer.pressedInside = observer.contains(e.target);
      observer.releasedInside = false;
    });
  }, true);
  document.addEventListener("pointerup", (e) => {
    forEachObserver((observer) => {
      observer.releasedInside = observer.contains(e.target);
    });
  }, true);
  document.addEventListener("click", (e) => {
    witnessedClick = e;
    const fromPointer = e.detail > 0;
    forEachObserver((observer) => {
      observer.subscribedDuringGesture = false;
      observer.wasInside = fromPointer && (observer.pressedInside || observer.releasedInside) || observer.contains(e.target);
      observer.pressedInside = false;
      observer.releasedInside = false;
    });
  }, true);
  document.addEventListener("click", (e) => {
    if (witnessedClick !== e) return;
    try {
      forEachObserver((observer) => {
        if (observer.subscribedDuringGesture) return;
        if (observer.wasInside) return;
        if (observer.exempt && observer.exempt(e)) return;
        observer.onOutside(e);
      });
    } finally {
      witnessedClick = null;
      for (const observer of outsideObservers) observer.subscribedDuringGesture = false;
    }
  }, false);
}
function observeOutsideInteraction({ contains, exempt, onOutside }) {
  installOutsideListeners();
  const observer = {
    contains,
    exempt,
    onOutside,
    pressedInside: false,
    releasedInside: false,
    wasInside: false,
    // True when we subscribe midway through a click dispatch — capture at document has
    // already passed, so this gesture's containment was never recorded for us.
    subscribedDuringGesture: witnessedClick !== null
  };
  outsideObservers.add(observer);
  return { observer, stop: () => outsideObservers.delete(observer) };
}
function bindClickOutside(ctx, element, handler, options = {}) {
  if (!element) return;
  const { exempt, signal } = options;
  const { stop } = observeOutsideInteraction({
    contains: (target) => resolveInsideSet(element).some((el) => el?.contains(target)),
    exempt,
    onOutside: handler
  });
  const abortSignal = signal || ctx.currentEffectController?.signal || ctx.controller.signal;
  if (abortSignal.aborted) stop();
  else abortSignal.addEventListener("abort", stop);
}
function isImeComposing(event) {
  return event.isComposing || event.keyCode === 229 || event.which === 229;
}
function emitEvent(ctx, element, eventName, detail = {}) {
  const componentName = ctx.componentName;
  const fullEventName = `fluxon:${componentName.toLowerCase()}:${eventName}`;
  logger_default.log("emit", componentName, `\u2192 ${eventName}`);
  const event = new CustomEvent(fullEventName, {
    detail: { id: element.id || null, ...detail },
    bubbles: true,
    composed: true
  });
  element.dispatchEvent(event);
  return event;
}
function emitNativeEvent(ctx, element, events = ["change"]) {
  if (!element || ctx.updating) return;
  for (const type of events) {
    element.dispatchEvent(new Event(type, { bubbles: true }));
  }
}

// js/framework/timers.js
function schedule(ctx, kind, name, fn, request, cancel) {
  const key = `${kind}:${name}`;
  const existing = ctx.timers.get(key);
  if (existing) cancel(existing);
  const id = request(() => {
    ctx.timers.delete(key);
    if (ctx.controller.signal.aborted) return;
    try {
      fn();
    } catch (error) {
      logger_default.error(kind, `${name} failed: ${error.message}`);
    }
  });
  ctx.timers.set(key, id);
  return id;
}
function cancelByKind(ctx, kind, name, cancel) {
  const key = `${kind}:${name}`;
  const id = ctx.timers.get(key);
  if (id != null) {
    cancel(id);
    ctx.timers.delete(key);
  }
}
function createTimeout(ctx, name, fn, ms) {
  return schedule(ctx, "timeout", name, fn, (cb) => setTimeout(cb, ms), clearTimeout);
}
function cancelTimeout(ctx, name) {
  cancelByKind(ctx, "timeout", name, clearTimeout);
}
function createRaf(ctx, name, fn) {
  return schedule(ctx, "raf", name, fn, requestAnimationFrame, cancelAnimationFrame);
}
function cancelRaf(ctx, name) {
  cancelByKind(ctx, "raf", name, cancelAnimationFrame);
}
function cleanupAllTimers(ctx) {
  for (const [key, id] of ctx.timers) {
    if (key.startsWith("timeout:")) clearTimeout(id);
    else if (key.startsWith("raf:")) cancelAnimationFrame(id);
  }
  ctx.timers.clear();
}

// js/framework/lv.js
function createLvNamespace(ctx, element, hook18) {
  return {
    el: element,
    pushEvent(event, payload, onReply) {
      return onReply === void 0 ? hook18.pushEvent?.(event, payload) : hook18.pushEvent?.(event, payload, onReply);
    },
    pushEventTo(target, event, payload, onReply) {
      return onReply === void 0 ? hook18.pushEventTo?.(target, event, payload) : hook18.pushEventTo?.(target, event, payload, onReply);
    },
    handleEvent(event, callback) {
      const ref = hook18.handleEvent?.(event, callback);
      if (ref != null) {
        ctx.controller.signal.addEventListener("abort", () => {
          hook18.removeHandleEvent?.(ref);
        });
      }
      return ref;
    },
    removeHandleEvent(ref) {
      return hook18.removeHandleEvent?.(ref);
    },
    // Execute a JS command encoded by Phoenix.LiveView.JS. Returns silently if the encoded
    // payload is empty — common case for `data-on-open`/`data-on-close` when the server
    // hasn't set them.
    execJS(target, encoded) {
      if (!encoded) return;
      hook18.liveSocket?.execJS?.(target, encoded);
    },
    upload(name, files) {
      return hook18.upload?.(name, files);
    },
    uploadTo(target, name, files) {
      return hook18.uploadTo?.(target, name, files);
    },
    // The attribute LiveView reads for a binding, e.g. binding("change") → "phx-change". Apps can
    // change the prefix on their LiveSocket; outside LiveView (tests, dead views) it's the default.
    binding(kind) {
      return hook18.liveSocket?.binding?.(kind) ?? `phx-${kind}`;
    }
  };
}

// js/framework/component.js
var componentRegistry = /* @__PURE__ */ new WeakMap();
function getComponentByElement(element) {
  if (!element) return null;
  return componentRegistry.get(element) || null;
}
var resyncRegistry = /* @__PURE__ */ new WeakMap();
function resyncAfterPatch(element) {
  const root = element.closest?.("[phx-hook]");
  const resync = root && resyncRegistry.get(root);
  if (!resync) return;
  resync.pending = true;
  if (resync.queued) return;
  resync.queued = true;
  queueMicrotask(() => {
    resync.queued = false;
    if (resync.pending) resync.run();
  });
}
function createContext(componentName) {
  return {
    componentName,
    controller: new AbortController(),
    currentEffect: null,
    currentEffectController: null,
    // { refresh: () => void } entries for every signal({ from }) — re-evaluated in order
    // at the top of updated(). Their writer skips updatedEffects so those only fire once
    // (in the second pass below, via ctx.updatedEffects).
    fromSignals: [],
    // Effects registered with { onUpdated: true } — force-run in registration order
    // after fromSignals refresh.
    updatedEffects: [],
    // True while executing a server-driven pass: initial mount hydration (setup) and every
    // LiveView updated(). Read via env.isServerUpdate(); used by env.emitNative() to
    // suppress echoing server-originated value writes back as native change events.
    updating: false,
    // Synchronous drains for every config MutationObserver (see dom.js createConfig). The
    // observer normally delivers server-patched attribute changes on a microtask AFTER
    // mounted()/updated() returns — with ctx.updating already false, letting a config-driven
    // value-sync escape the echo guard. We drain them at the end of each pass, still inside
    // the guard, so those effect re-runs stay server-driven.
    configFlushers: [],
    timers: /* @__PURE__ */ new Map()
  };
}
function flushConfig(ctx) {
  for (const flush of ctx.configFlushers) flush();
}
function runUpdatedPass(ctx) {
  const prevUpdating = ctx.updating;
  ctx.updating = true;
  try {
    ctx.fromSignals.forEach(({ refresh }) => refresh());
    ctx.updatedEffects.forEach((e) => {
      if (!e.destroyed) e.run();
    });
    flushConfig(ctx);
  } finally {
    ctx.updating = prevUpdating;
  }
}
function createEnv(ctx, element, hook18) {
  return {
    // Component name as passed to defineComponent. Lowercased prefix used in `fluxon:*`
    // event names. Exposed so utilities like ui/overlay-controls can build event names
    // without taking the component name as a parameter.
    componentName: ctx.componentName,
    // Reactivity. effect accepts an options object: { onUpdated?: boolean } to also
    // force-run the effect after every LV updated() callback (in addition to
    // signal-change re-runs). Use { onUpdated: true } for code that must re-apply DOM
    // state morphdom strips (inline styles, listeners on replaced elements).
    signal: (initial, options) => createSignal(ctx, initial, options),
    effect: (name, fn, options) => createEffect(ctx, name, fn, options),
    computed: (name, fn) => createComputed(ctx, name, fn),
    onChange: (sig, callbacks) => createOnChange(ctx, sig, callbacks),
    untrack: (fn) => untrack(ctx, fn),
    // True while the code currently running was driven by the server — mount hydration or a
    // LiveView updated() — rather than a user gesture. Lets a component avoid echoing a
    // server-originated value back to the server. See emitNative and ctx.updating.
    isServerUpdate: () => ctx.updating,
    // DOM
    parts: (el, schema) => createParts(ctx, el || element, schema),
    config: (el, schema) => createConfig(ctx, el || element, schema),
    attrs: (el, attributes) => updateAttributes(el, attributes),
    // Events
    on: (target, event, handler, options) => bindEvent(ctx, target, event, handler, options),
    onClickOutside: (el, handler, options) => bindClickOutside(ctx, el, handler, options),
    onKey: (target, key, handler, options) => bindKeyboard(ctx, target, key, handler, options),
    emit: (eventName, detail) => emitEvent(ctx, element, eventName, detail),
    // Dispatch bubbling native form events (default ["change"]) to drive phx-change/
    // phx-input — suppressed during a server-driven pass so server-originated writes never
    // echo back as phx-change (prevents the change-event feedback loop).
    emitNative: (el, events) => emitNativeEvent(ctx, el, events),
    // Timers
    timeout: Object.assign((name, fn, ms) => createTimeout(ctx, name, fn, ms), {
      cancel: (name) => cancelTimeout(ctx, name),
      raf: Object.assign((name, fn) => createRaf(ctx, name, fn), {
        cancel: (name) => cancelRaf(ctx, name)
      })
    }),
    // LiveView seam
    lv: createLvNamespace(ctx, element, hook18),
    // AbortSignal exposed for ui/* utilities (floating, focusTrap, transition)
    // that accept a `signal` option for auto-cleanup on component destroy. Intentionally
    // NOT named `signal` to avoid colliding with the signal() factory.
    abortSignal: ctx.controller.signal,
    // Register a function to run when the component destroys. Sugar over
    // abortSignal.addEventListener("abort", fn). Useful for module-scoped cleanups (e.g.
    // removing the component from a singleton registry like Dialog's stacker).
    cleanup: (fn) => ctx.controller.signal.addEventListener("abort", fn)
  };
}
function defineComponent(name, setup, options = {}) {
  const hook18 = {
    mounted() {
      const ctx = createContext(name);
      const env = createEnv(ctx, this.el, this);
      logger_default.log("component", name, "mounted", this.el);
      const prevUpdating = ctx.updating;
      ctx.updating = true;
      let api;
      try {
        api = setup(this.el, env) || {};
        flushConfig(ctx);
      } finally {
        ctx.updating = prevUpdating;
      }
      this._fluxon = { ctx, env, api, name };
      if (this.el) {
        componentRegistry.set(this.el, api);
        resyncRegistry.set(this.el, {
          pending: false,
          queued: false,
          run: () => {
            if (!ctx.controller.signal.aborted) runUpdatedPass(ctx);
          }
        });
      }
    },
    updated() {
      const resync = this.el && resyncRegistry.get(this.el);
      if (resync) resync.pending = false;
      runUpdatedPass(this._fluxon.ctx);
    },
    destroyed() {
      const { ctx } = this._fluxon;
      logger_default.log("component", name, "destroyed");
      if (this.el) {
        componentRegistry.delete(this.el);
        resyncRegistry.delete(this.el);
      }
      cleanupAllTimers(ctx);
      ctx.controller.abort();
    }
  };
  if (typeof options.reconnected === "function") {
    hook18.reconnected = function() {
      options.reconnected.call(this, this._fluxon?.api);
    };
  }
  hook18.mount = function(element, mockHook = null) {
    const fakeHook = mockHook || { el: element };
    hook18.mounted.call(fakeHook);
    const api = fakeHook._fluxon.api;
    attachTestMethod(api, "destroy", () => hook18.destroyed.call(fakeHook));
    attachTestMethod(api, "refresh", () => hook18.updated.call(fakeHook));
    return api;
  };
  return hook18;
}
function attachTestMethod(api, name, value) {
  if (Object.prototype.hasOwnProperty.call(api, name)) return;
  Object.defineProperty(api, name, { value, enumerable: false, configurable: true });
}

// node_modules/.pnpm/@floating-ui+utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
var lrPlacement = ["left", "right"];
var rlPlacement = ["right", "left"];
var tbPlacement = ["top", "bottom"];
var btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  const side = getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

// node_modules/.pnpm/@floating-ui+core@1.7.5/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating: floating2
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating2.width / 2;
  const commonY = reference.y + reference.height / 2 - floating2.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating2[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating2.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating2.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var MAX_RESET_COUNT = 50;
var computePosition = async (reference, floating2, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const platformWithDetectOverflow = platform2.detectOverflow ? platform2 : {
    ...platform2,
    detectOverflow
  };
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating2));
  let rects = await platform2.getElementRects({
    reference,
    floating: floating2,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating: floating2
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData[name] = {
      ...middlewareData[name],
      ...data
    };
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating: floating2,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
var arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset3 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset3 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset3,
        centerOffset: center - offset3 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getBoundingRect(rects) {
  const minX = min(...rects.map((rect) => rect.left));
  const minY = min(...rects.map((rect) => rect.top));
  const maxX = max(...rects.map((rect) => rect.right));
  const maxY = max(...rects.map((rect) => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map((rect) => rectToClientRect(getBoundingRect(rect)));
}
var inline = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "inline",
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform: platform2,
        strategy
      } = state;
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from(await (platform2.getClientRects == null ? void 0 : platform2.getClientRects(elements.reference)) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect2() {
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          return clientRects.find((rect) => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === "y") {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === "top";
            const top2 = firstRect.top;
            const bottom2 = lastRect.bottom;
            const left2 = isTop ? firstRect.left : lastRect.left;
            const right2 = isTop ? firstRect.right : lastRect.right;
            const width2 = right2 - left2;
            const height2 = bottom2 - top2;
            return {
              top: top2,
              bottom: bottom2,
              left: left2,
              right: right2,
              width: width2,
              height: height2,
              x: left2,
              y: top2
            };
          }
          const isLeftSide = getSide(placement) === "left";
          const maxRight = max(...clientRects.map((rect) => rect.right));
          const minLeft = min(...clientRects.map((rect) => rect.left));
          const measureRects = clientRects.filter((rect) => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform2.getElementRects({
        reference: {
          getBoundingClientRect: getBoundingClientRect2
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};
var originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
var shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement,
        platform: platform2
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
var limitShift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset3 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset3, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
var size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await platform2.detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

// node_modules/.pnpm/@floating-ui+utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement(element) {
  return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
  try {
    if (element.matches(":popover-open")) {
      return true;
    }
  } catch (_e) {
  }
  try {
    return element.matches(":modal");
  } catch (_e) {
    return false;
  }
}
var willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var containRe = /paint|layout|strict|content/;
var isNotNone = (value) => !!value && value !== "none";
var isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css = isElement(elementOrCss) ? getComputedStyle2(elementOrCss) : elementOrCss;
  return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || "") || containRe.test(css.contain || "");
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// node_modules/.pnpm/@floating-ui+dom@1.7.6/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css = getComputedStyle2(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
var SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === "absolute" || currentContainingBlockComputedStyle.position === "fixed") || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
  let top = firstRect.top;
  let right = firstRect.right;
  let bottom = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
    top = max(rect.top, top);
    right = min(rect.right, right);
    bottom = min(rect.bottom, bottom);
    left = max(rect.left, left);
  }
  return {
    width: right - left,
    height: bottom - top,
    x: left,
    y: top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle2(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle2(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating2, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...floating2 ? getOverflowAncestors(floating2) : []] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating2) {
        resizeObserver.unobserve(floating2);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating2);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating2) {
      resizeObserver.observe(floating2);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var offset2 = offset;
var shift2 = shift;
var flip2 = flip;
var size2 = size;
var arrow2 = arrow;
var inline2 = inline;
var limitShift2 = limitShift;
var computePosition2 = (reference, floating2, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating2, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

// js/ui/floating.js
var VIEWPORT_PADDING = 8;
var PANEL_GAP = 6;
var BUBBLE_GAP = 8;
var MIN_PANEL_HEIGHT = 150;
function panelMiddleware(options = {}) {
  const {
    gap = PANEL_GAP,
    minHeight = MIN_PANEL_HEIGHT,
    matchAnchorWidth = true,
    clampWidth = false,
    hugContent = false,
    flipOptions = {},
    extra = []
  } = options;
  let caps = null;
  const pxCap = (value) => {
    if (typeof value !== "string" || !value.endsWith("px")) return Infinity;
    const px = parseFloat(value);
    return Number.isFinite(px) ? px : Infinity;
  };
  const readCaps = (panel) => {
    panel.style.removeProperty("max-height");
    if (clampWidth) panel.style.removeProperty("max-width");
    const declared = getComputedStyle(panel);
    return {
      height: pxCap(declared.maxHeight),
      width: clampWidth ? pxCap(declared.maxWidth) : Infinity
    };
  };
  const middleware = [
    offset2(gap),
    // size() runs BEFORE flip() deliberately. It clamps the panel to the space available on
    // the current side, and floating-ui restarts the middleware chain with re-measured rects
    // whenever apply() changes the panel's size (size returns reset: { rects: true }), so
    // flip() always evaluates the clamped height and only flips once the clamp would fall
    // below minHeight. Ordering size() last would instead have flip() judge the panel's full
    // natural height and abandon the placement whenever the whole list doesn't fit below, even
    // with ample room to shrink in place -- see ui/test/floating-presets.test.js.
    size2({
      padding: VIEWPORT_PADDING,
      apply({ elements, rects, availableHeight, availableWidth }) {
        const panel = elements.floating;
        if (caps === null) caps = readCaps(panel);
        if (matchAnchorWidth) panel.style.minWidth = `${rects.reference.width}px`;
        if (hugContent) panel.style.width = "max-content";
        const fitted = Math.max(minHeight, Math.floor(availableHeight) - 1);
        panel.style.maxHeight = `${Math.min(caps.height, fitted)}px`;
        if (clampWidth) {
          panel.style.maxWidth = `${Math.min(caps.width, Math.floor(availableWidth) - 1)}px`;
        }
      }
    }),
    flip2({ padding: VIEWPORT_PADDING, fallbackAxisSideDirection: "start", ...flipOptions }),
    shift2({ padding: VIEWPORT_PADDING, limiter: limitShift2() }),
    ...extra
  ];
  return { middleware, invalidateCap: () => caps = null };
}
function bubbleMiddleware({ gap = BUBBLE_GAP, extra = [] } = {}) {
  return [
    inline2(),
    offset2(gap),
    flip2({ padding: VIEWPORT_PADDING }),
    shift2({ padding: VIEWPORT_PADDING, limiter: limitShift2() }),
    ...extra
  ];
}
function floating(anchor, target, options = {}) {
  const resolve = (value) => typeof value === "function" ? value() : value;
  let cleanup = null;
  let isActive = false;
  const config = {
    placement: options.placement || "bottom-start",
    strategy: options.strategy || "fixed",
    offset: options.offset ?? BUBBLE_GAP,
    padding: options.padding ?? VIEWPORT_PADDING,
    matchWidth: options.matchWidth ?? false,
    middleware: options.middleware || null
  };
  const stopAutoUpdate = () => {
    if (cleanup) {
      cleanup();
      cleanup = null;
    }
  };
  const updatePosition = async () => {
    const anchorEl = resolve(anchor);
    const targetEl = resolve(target);
    if (!isActive || !anchorEl || !targetEl) return;
    const middleware = config.middleware || [
      offset2(config.offset),
      flip2({ fallbackAxisSideDirection: "start", padding: config.padding }),
      shift2({ padding: config.padding, limiter: limitShift2() })
    ];
    const { x, y, placement, middlewareData } = await computePosition2(anchorEl, targetEl, {
      placement: config.placement,
      strategy: config.strategy,
      middleware
    });
    Object.assign(targetEl.style, {
      position: config.strategy,
      left: `${x}px`,
      top: `${y}px`
    });
    if (config.matchWidth && !config.middleware) {
      targetEl.style.minWidth = `${anchorEl.offsetWidth}px`;
    }
    if (options.onPlacement) options.onPlacement(placement, middlewareData);
  };
  const startAutoUpdate = () => {
    if (cleanup) return;
    const anchorEl = resolve(anchor);
    const targetEl = resolve(target);
    if (anchorEl && targetEl && typeof ResizeObserver !== "undefined") {
      cleanup = autoUpdate(anchorEl, targetEl, updatePosition, {
        ancestorScroll: true,
        ancestorResize: true,
        elementResize: true,
        layoutShift: true,
        animationFrame: false
      });
    }
  };
  const attach = async () => {
    isActive = true;
    await updatePosition();
    startAutoUpdate();
  };
  const detach = async () => {
    if (!isActive) return;
    isActive = false;
    stopAutoUpdate();
    const targetEl = resolve(target);
    if (targetEl) Object.assign(targetEl.style, { position: "", left: "", top: "" });
  };
  if (options.signal) {
    options.signal.addEventListener("abort", stopAutoUpdate);
  }
  return { attach, detach, update: updatePosition, stopTracking: stopAutoUpdate, config };
}

// js/ui/dismiss-stack.js
var layers = [];
var escapeInstalled = false;
var arbitratedEvent = null;
var toastGesture = null;
var trackToastGestures = () => {
  if (toastGesture) return;
  toastGesture = observeOutsideInteraction({
    contains: (node) => !!node?.closest?.('[data-part="toaster"]'),
    // Nothing to dismiss — the layers' own observers drive the walk; this one is read for
    // `wasInside` and never acts on its own.
    onOutside: () => {
    }
  });
};
var untrackToastGestures = () => {
  toastGesture?.stop();
  toastGesture = null;
};
var toastConsumesEscape = (event) => event.target?.closest?.('[data-part="toaster"]')?.dataset.escapeDismissible === "true";
function installEscape() {
  if (escapeInstalled) return;
  escapeInstalled = true;
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (layers.length === 0) return;
    if (isImeComposing(event)) return;
    if (toastConsumesEscape(event)) return;
    for (const layer of [...layers].reverse()) {
      if (!layers.includes(layer)) continue;
      layer.onDismiss("escape", event);
      if (!layer.consumes("escape")) continue;
      event.preventDefault();
      break;
    }
  }, true);
}
function arbitrate(event) {
  if (arbitratedEvent === event) return;
  arbitratedEvent = event;
  queueMicrotask(() => {
    arbitratedEvent = null;
  });
  if (toastGesture?.observer.wasInside) return;
  let dismissedAny = false;
  for (const layer of [...layers].reverse()) {
    if (!layers.includes(layer)) continue;
    if (layer.observer.subscribedDuringGesture) continue;
    if (!layer.consumes("outside")) {
      if (!layer.observer.wasInside) layer.onDismiss("outside", event);
      continue;
    }
    if (layer.observer.wasInside) break;
    if (layer.modal && dismissedAny) break;
    layer.onDismiss("outside", event);
    if (!layer.open.value) dismissedAny = true;
    if (layer.modal) break;
  }
}
function dismissable(env, options) {
  const {
    open,
    contains,
    consumes = () => true,
    modal = false,
    dismissOnOutside = true,
    refocusOnEscape,
    onDismiss
  } = options;
  const dismiss = (reason, event) => {
    if (reason === "outside" && !dismissOnOutside) return;
    if (onDismiss) return onDismiss(reason, event);
    open.value = false;
    if (reason === "escape") refocusOnEscape?.()?.focus();
  };
  let layer = null;
  const remove = () => {
    if (!layer) return;
    layer.stop();
    const index = layers.indexOf(layer);
    if (index !== -1) layers.splice(index, 1);
    layer = null;
    if (layers.length === 0) untrackToastGestures();
  };
  const add = () => {
    if (layer) return;
    installEscape();
    trackToastGestures();
    const { observer, stop } = observeOutsideInteraction({
      contains,
      onOutside: arbitrate
    });
    layer = { open, consumes, modal, onDismiss: dismiss, observer, stop };
    layers.push(layer);
  };
  env.effect("dismissable", () => {
    if (open.value) add();
    else remove();
  });
  env.cleanup(remove);
}

// node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/errors.mjs
var invariant = () => {
};
if (typeof process !== "undefined" && false) {
  warning = (check, message, errorCode) => {
    if (!check && typeof console !== "undefined") {
      console.warn(formatErrorMessage(message, errorCode));
    }
  };
  invariant = (check, message, errorCode) => {
    if (!check) {
      throw new Error(formatErrorMessage(message, errorCode));
    }
  };
}

// node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/memo.mjs
// @__NO_SIDE_EFFECTS__
function memo(callback) {
  let result;
  return () => {
    if (result === void 0)
      result = callback();
    return result;
  };
}

// node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/noop.mjs
var noop = /* @__NO_SIDE_EFFECTS__ */ (any) => any;

// node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/time-conversion.mjs
var secondsToMilliseconds = /* @__NO_SIDE_EFFECTS__ */ (seconds) => seconds * 1e3;
var millisecondsToSeconds = /* @__NO_SIDE_EFFECTS__ */ (milliseconds) => milliseconds / 1e3;

// node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/easing/utils/is-bezier-definition.mjs
var isBezierDefinition = /* @__NO_SIDE_EFFECTS__ */ (easing) => Array.isArray(easing) && typeof easing[0] === "number";

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/utils/linear.mjs
var generateLinearEasing = (easing, duration, resolution = 10) => {
  let points = "";
  const numPoints = Math.max(Math.round(duration / resolution), 2);
  for (let i = 0; i < numPoints; i++) {
    points += Math.round(easing(i / (numPoints - 1)) * 1e4) / 1e4 + ", ";
  }
  return `linear(${points.substring(0, points.length - 2)})`;
};

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/keyframes/get-final.mjs
var isNotNull = (value) => value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe, speed = 1) {
  const resolvedKeyframes = keyframes.filter(isNotNull);
  const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
  const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === void 0 ? resolvedKeyframes[index] : finalKeyframe;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/utils/WithPromise.mjs
var WithPromise = class {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((resolve) => {
      this.resolve = resolve;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(onResolve, onReject) {
    return this.finished.then(onResolve, onReject);
  }
};

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/keyframes/utils/fill-wildcards.mjs
function fillWildcards(keyframes) {
  for (let i = 1; i < keyframes.length; i++) {
    keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
  }
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/render/dom/is-css-var.mjs
var isCSSVar = (name) => name.startsWith("--");

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/render/dom/style-set.mjs
function setStyle(element, name, value) {
  isCSSVar(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/utils/supports/flags.mjs
var supportsFlags = {};

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/utils/supports/memo.mjs
function memoSupports(callback, supportsFlag) {
  const memoized = memo(callback);
  return () => supportsFlags[supportsFlag] ?? memoized();
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/utils/supports/scroll-timeline.mjs
var supportsScrollTimeline = /* @__PURE__ */ memoSupports(() => window.ScrollTimeline !== void 0, "scrollTimeline");

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/utils/supports/linear-easing.mjs
var supportsLinearEasing = /* @__PURE__ */ memoSupports(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch (e) {
    return false;
  }
  return true;
}, "linearEasing");

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/easing/cubic-bezier.mjs
var cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/easing/supported.mjs
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/easing/map-easing.mjs
function mapEasingToNativeEasing(easing, duration) {
  if (!easing) {
    return void 0;
  } else if (typeof easing === "function") {
    return supportsLinearEasing() ? generateLinearEasing(easing, duration) : "ease-out";
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut);
  } else {
    return supportedWaapiEasing[easing];
  }
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/start-waapi-animation.mjs
function startWaapiAnimation(element, valueName, keyframes, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease = "easeOut", times } = {}, pseudoElement = void 0) {
  const keyframeOptions = {
    [valueName]: keyframes
  };
  if (times)
    keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease, duration);
  if (Array.isArray(easing))
    keyframeOptions.easing = easing;
  const options = {
    delay,
    duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  };
  if (pseudoElement)
    options.pseudoElement = pseudoElement;
  return element.animate(keyframeOptions, options);
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/generators/utils/is-generator.mjs
function isGenerator(type) {
  return typeof type === "function" && "applyToOptions" in type;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/utils/apply-generator.mjs
function applyGeneratorOptions({ type, ...options }) {
  if (isGenerator(type) && supportsLinearEasing()) {
    return type.applyToOptions(options);
  } else {
    options.duration ?? (options.duration = 300);
    options.ease ?? (options.ease = "easeOut");
  }
  return options;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/NativeAnimation.mjs
var NativeAnimation = class extends WithPromise {
  constructor(options) {
    super();
    this.finishedTime = null;
    this.isStopped = false;
    this.manualStartTime = null;
    if (!options)
      return;
    const { element, name, keyframes, pseudoElement, allowFlatten = false, finalKeyframe, onComplete } = options;
    this.isPseudoElement = Boolean(pseudoElement);
    this.allowFlatten = allowFlatten;
    this.options = options;
    invariant(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const transition2 = applyGeneratorOptions(options);
    this.animation = startWaapiAnimation(element, name, keyframes, transition2, pseudoElement);
    if (transition2.autoplay === false) {
      this.animation.pause();
    }
    this.animation.onfinish = () => {
      this.finishedTime = this.time;
      if (!pseudoElement) {
        const keyframe = getFinalKeyframe(keyframes, this.options, finalKeyframe, this.speed);
        if (this.updateMotionValue) {
          this.updateMotionValue(keyframe);
        }
        setStyle(element, name, keyframe);
        this.animation.cancel();
      }
      onComplete?.();
      this.notifyFinished();
    };
  }
  play() {
    if (this.isStopped)
      return;
    this.manualStartTime = null;
    this.animation.play();
    if (this.state === "finished") {
      this.updateFinished();
    }
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch (e) {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = true;
    const { state } = this;
    if (state === "idle" || state === "finished") {
      return;
    }
    if (this.updateMotionValue) {
      this.updateMotionValue();
    } else {
      this.commitStyles();
    }
    if (!this.isPseudoElement)
      this.cancel();
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const element = this.options?.element;
    if (!this.isPseudoElement && element?.isConnected) {
      this.animation.commitStyles?.();
    }
  }
  get duration() {
    const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
    return millisecondsToSeconds(Number(duration));
  }
  get iterationDuration() {
    const { delay = 0 } = this.options || {};
    return this.duration + millisecondsToSeconds(delay);
  }
  get time() {
    return millisecondsToSeconds(Number(this.animation.currentTime) || 0);
  }
  set time(newTime) {
    const wasFinished = this.finishedTime !== null;
    this.manualStartTime = null;
    this.finishedTime = null;
    this.animation.currentTime = secondsToMilliseconds(newTime);
    if (wasFinished) {
      this.animation.pause();
    }
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(newSpeed) {
    if (newSpeed < 0)
      this.finishedTime = null;
    this.animation.playbackRate = newSpeed;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(newStartTime) {
    this.manualStartTime = this.animation.startTime = newStartTime;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline, rangeStart, rangeEnd, observe }) {
    if (this.allowFlatten) {
      this.animation.effect?.updateTiming({ easing: "linear" });
    }
    this.animation.onfinish = null;
    if (timeline && supportsScrollTimeline()) {
      this.animation.timeline = timeline;
      if (rangeStart)
        this.animation.rangeStart = rangeStart;
      if (rangeEnd)
        this.animation.rangeEnd = rangeEnd;
      return noop;
    } else {
      return observe(this);
    }
  }
};

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/GroupAnimation.mjs
var GroupAnimation = class {
  constructor(animations) {
    this.stop = () => this.runAll("stop");
    this.animations = animations.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((animation) => animation.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(propName) {
    return this.animations[0][propName];
  }
  setAll(propName, newValue) {
    for (let i = 0; i < this.animations.length; i++) {
      this.animations[i][propName] = newValue;
    }
  }
  attachTimeline(timeline) {
    const subscriptions = this.animations.map((animation) => animation.attachTimeline(timeline));
    return () => {
      subscriptions.forEach((cancel, i) => {
        cancel && cancel();
        this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(time) {
    this.setAll("time", time);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(speed) {
    this.setAll("speed", speed);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return getMax(this.animations, "duration");
  }
  get iterationDuration() {
    return getMax(this.animations, "iterationDuration");
  }
  runAll(methodName) {
    this.animations.forEach((controls) => controls[methodName]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
};
function getMax(animations, propName) {
  let max2 = 0;
  for (let i = 0; i < animations.length; i++) {
    const value = animations[i][propName];
    if (value !== null && value > max2) {
      max2 = value;
    }
  }
  return max2;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/GroupAnimationWithThen.mjs
var GroupAnimationWithThen = class extends GroupAnimation {
  then(onResolve, _onReject) {
    return this.finished.finally(onResolve).then(() => {
    });
  }
};

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/utils/active-animations.mjs
var animationMaps = /* @__PURE__ */ new WeakMap();
var animationMapKey = (name, pseudoElement = "") => `${name}:${pseudoElement}`;
function getAnimationMap(element) {
  let map = animationMaps.get(element);
  if (!map) {
    map = /* @__PURE__ */ new Map();
    animationMaps.set(element, map);
  }
  return map;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/utils/resolve-transition.mjs
function resolveTransition(transition2, parentTransition) {
  if (transition2?.inherit && parentTransition) {
    const { inherit: _, ...rest } = transition2;
    return { ...parentTransition, ...rest };
  }
  return transition2;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/utils/get-value-transition.mjs
function getValueTransition(transition2, key) {
  const valueTransition = transition2?.[key] ?? transition2?.["default"] ?? transition2;
  if (valueTransition !== transition2) {
    return resolveTransition(valueTransition, transition2);
  }
  return valueTransition;
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/utils/border-radius.mjs
var cornerRadiusProps = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/waapi/utils/px-values.mjs
var pxValues = /* @__PURE__ */ new Set([
  // Border props
  "borderWidth",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRadius",
  ...cornerRadiusProps,
  // Positioning props
  "width",
  "maxWidth",
  "height",
  "maxHeight",
  "top",
  "right",
  "bottom",
  "left",
  "inset",
  "insetBlock",
  "insetBlockStart",
  "insetBlockEnd",
  "insetInline",
  "insetInlineStart",
  "insetInlineEnd",
  // Spacing props
  "padding",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "paddingBlock",
  "paddingBlockStart",
  "paddingBlockEnd",
  "paddingInline",
  "paddingInlineStart",
  "paddingInlineEnd",
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginBlock",
  "marginBlockStart",
  "marginBlockEnd",
  "marginInline",
  "marginInlineStart",
  "marginInlineEnd",
  // Typography
  "fontSize",
  // Misc
  "backgroundPositionX",
  "backgroundPositionY"
]);

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/animation/keyframes/utils/apply-px-defaults.mjs
function applyPxDefaults(keyframes, name) {
  for (let i = 0; i < keyframes.length; i++) {
    if (typeof keyframes[i] === "number" && pxValues.has(name)) {
      keyframes[i] = keyframes[i] + "px";
    }
  }
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/utils/resolve-elements.mjs
function resolveElements(elementOrSelector, scope, selectorCache) {
  if (elementOrSelector == null) {
    return [];
  }
  if (elementOrSelector instanceof EventTarget) {
    return [elementOrSelector];
  } else if (typeof elementOrSelector === "string") {
    let root = document;
    if (scope) {
      root = scope.current;
    }
    const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
    return elements ? Array.from(elements) : [];
  }
  return Array.from(elementOrSelector).filter((element) => element != null);
}

// node_modules/.pnpm/motion-dom@12.42.2/node_modules/motion-dom/dist/es/render/dom/style-computed.mjs
function getComputedStyle3(element, name) {
  const computedStyle = window.getComputedStyle(element);
  return isCSSVar(name) ? computedStyle.getPropertyValue(name) : computedStyle[name];
}

// node_modules/.pnpm/framer-motion@12.42.2/node_modules/framer-motion/dist/es/animation/animators/waapi/animate-elements.mjs
function animateElements(elementOrSelector, keyframes, options, scope) {
  if (elementOrSelector == null) {
    return [];
  }
  const elements = resolveElements(elementOrSelector, scope);
  const numElements = elements.length;
  invariant(Boolean(numElements), "No valid elements provided.", "no-valid-elements");
  const animationDefinitions = [];
  for (let i = 0; i < numElements; i++) {
    const element = elements[i];
    const elementTransition = { ...options };
    if (typeof elementTransition.delay === "function") {
      elementTransition.delay = elementTransition.delay(i, numElements);
    }
    for (const valueName in keyframes) {
      let valueKeyframes = keyframes[valueName];
      if (!Array.isArray(valueKeyframes)) {
        valueKeyframes = [valueKeyframes];
      }
      const valueOptions = {
        ...getValueTransition(elementTransition, valueName)
      };
      valueOptions.duration && (valueOptions.duration = secondsToMilliseconds(valueOptions.duration));
      valueOptions.delay && (valueOptions.delay = secondsToMilliseconds(valueOptions.delay));
      const map = getAnimationMap(element);
      const key = animationMapKey(valueName, valueOptions.pseudoElement || "");
      const currentAnimation = map.get(key);
      currentAnimation && currentAnimation.stop();
      animationDefinitions.push({
        map,
        key,
        unresolvedKeyframes: valueKeyframes,
        options: {
          ...valueOptions,
          element,
          name: valueName,
          allowFlatten: !elementTransition.type && !elementTransition.ease
        }
      });
    }
  }
  for (let i = 0; i < animationDefinitions.length; i++) {
    const { unresolvedKeyframes, options: animationOptions } = animationDefinitions[i];
    const { element, name, pseudoElement } = animationOptions;
    if (!pseudoElement && unresolvedKeyframes[0] === null) {
      unresolvedKeyframes[0] = getComputedStyle3(element, name);
    }
    fillWildcards(unresolvedKeyframes);
    applyPxDefaults(unresolvedKeyframes, name);
    if (!pseudoElement && unresolvedKeyframes.length < 2) {
      unresolvedKeyframes.unshift(getComputedStyle3(element, name));
    }
    animationOptions.keyframes = unresolvedKeyframes;
  }
  const animations = [];
  for (let i = 0; i < animationDefinitions.length; i++) {
    const { map, key, options: animationOptions } = animationDefinitions[i];
    const animation = new NativeAnimation(animationOptions);
    map.set(key, animation);
    animation.finished.finally(() => map.delete(key));
    animations.push(animation);
  }
  return animations;
}

// node_modules/.pnpm/framer-motion@12.42.2/node_modules/framer-motion/dist/es/animation/animators/waapi/animate-style.mjs
var createScopedWaapiAnimate = (scope) => {
  function scopedAnimate(elementOrSelector, keyframes, options) {
    return new GroupAnimationWithThen(animateElements(elementOrSelector, keyframes, options, scope));
  }
  return scopedAnimate;
};
var animateMini = /* @__PURE__ */ createScopedWaapiAnimate();

// js/ui/transition.js
function transition(element, options = {}) {
  const resolve = (value) => typeof value === "function" ? value() : value;
  const config = {
    in: { opacity: [0, 1] },
    out: { opacity: [1, 0] },
    duration: 0.1,
    easing: "ease-out",
    ...options
  };
  let currentAnimation = null;
  const cancelCurrent = () => {
    if (currentAnimation?.cancel) {
      currentAnimation.cancel();
      currentAnimation = null;
    }
  };
  const reducedMotion = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const run = async (keyframes) => {
    const el = resolve(element);
    cancelCurrent();
    const duration = resolve(config.duration);
    if (!el) return;
    try {
      currentAnimation = animateMini(el, keyframes, {
        duration: reducedMotion() ? 0 : duration,
        easing: config.easing
      });
      await currentAnimation.finished;
    } catch {
    } finally {
      currentAnimation = null;
    }
  };
  if (options.signal) {
    options.signal.addEventListener("abort", cancelCurrent);
  }
  return {
    in: () => run(resolve(config.in)),
    out: () => run(resolve(config.out)),
    cancel: cancelCurrent
  };
}
function slideFromPlacement(getPlacement, distance = 6) {
  const axis = (dir) => {
    const side = (getPlacement() || "").split("-")[0];
    const from = dir === "in" ? distance : 0;
    const to = dir === "in" ? 0 : distance;
    switch (side) {
      case "top":
        return { y: [from, to] };
      case "bottom":
        return { y: [-from, -to] };
      case "left":
        return { x: [from, to] };
      case "right":
        return { x: [-from, -to] };
      default:
        return {};
    }
  };
  return {
    in: () => ({ opacity: [0, 1], ...axis("in") }),
    out: () => ({ opacity: [1, 0], ...axis("out") })
  };
}
function clearTransitionResidue(el) {
  if (!el) return;
  el.style.translate = "";
  el.style.transform = "";
  el.style.scale = "";
  el.style.opacity = "";
}

// js/ui/overlay.js
function overlay(env, options) {
  const {
    anchor,
    // () => HTMLElement
    panel,
    // () => HTMLElement
    open,
    // signal<boolean>
    placement = "bottom-start",
    strategy = "fixed",
    offset: offsetValue = 8,
    middleware,
    matchWidth = false,
    closeOnOutsideClick = false,
    // dismiss when a gesture lands outside anchor + panel
    onDismiss,
    // (reason, event) => void — replaces close-and-refocus
    refocusOnEscape,
    // () => HTMLElement — Escape returns focus here
    consumes,
    // (reason) => boolean — see dismissable()
    inside,
    // () => an extra node that counts as inside the panel
    duration = 0.15,
    easing = "ease-out",
    transitionKeyframes,
    // { in, out } — overrides the default slide
    onPlacement,
    onBeforeOpen,
    // sync, before any DOM/animation work
    onShow,
    // sync, after panel.hidden=false, before transition.in
    onOpen,
    // async, after transition.in completes
    onBeforeClose,
    // sync, before transition.out starts
    onClose
    // async, after panel.hidden=true
  } = options;
  let resolvedPlacement = placement;
  const popper = floating(anchor, panel, {
    placement,
    strategy,
    offset: offsetValue,
    middleware,
    matchWidth,
    onPlacement: (p, md) => {
      resolvedPlacement = p;
      if (onPlacement) onPlacement(p, md);
    },
    signal: env.abortSignal
  });
  const keyframes = transitionKeyframes || slideFromPlacement(() => resolvedPlacement);
  const anim = transition(panel, {
    ...keyframes,
    duration,
    easing,
    signal: env.abortSignal
  });
  const setHidden = (hidden) => {
    const el = panel();
    if (el) el.hidden = hidden;
  };
  env.onChange(open, {
    async enter() {
      if (onBeforeOpen) onBeforeOpen();
      setHidden(false);
      if (onShow) onShow();
      await popper.attach();
      await anim.in();
      clearTransitionResidue(panel());
      if (onOpen) await onOpen();
    },
    async exit() {
      if (onBeforeClose) onBeforeClose();
      popper.stopTracking();
      await anim.out();
      setHidden(true);
      await popper.detach();
      clearTransitionResidue(panel());
      if (onClose) await onClose();
    }
  });
  dismissable(env, {
    open,
    contains: (node) => !!panel()?.contains(node) || !!anchor()?.contains(node) || !!inside?.()?.contains(node),
    dismissOnOutside: closeOnOutsideClick,
    consumes,
    refocusOnEscape,
    onDismiss
  });
  env.effect("overlay-reapply", () => {
    if (!open.value) return;
    setHidden(false);
    popper.update();
  }, { onUpdated: true });
  return {
    floating: popper,
    transition: anim,
    reposition: () => popper.update(),
    get placement() {
      return resolvedPlacement;
    }
  };
}

// js/ui/overlay-controls.js
function overlayControls(env, element, openSignalOrHandlers) {
  const handlers = isSignalLike(openSignalOrHandlers) ? {
    open: () => {
      openSignalOrHandlers.value = true;
    },
    close: () => {
      openSignalOrHandlers.value = false;
    },
    toggle: () => {
      openSignalOrHandlers.value = !openSignalOrHandlers.value;
    }
  } : openSignalOrHandlers;
  const name = env.componentName.toLowerCase();
  const commands = ["open", "close", "toggle"];
  for (const cmd of commands) {
    env.on(element, `fluxon:${name}:${cmd}`, (event) => {
      if (event.target === element) handlers[cmd]();
    });
  }
  const matchesId = (detail) => {
    if (!element.id || !detail || detail.id == null) return false;
    return String(detail.id).replace(/^#/, "") === element.id;
  };
  for (const cmd of commands) {
    env.on(window, `phx:fluxon:${name}:${cmd}`, (event) => {
      if (matchesId(event.detail)) handlers[cmd]();
    });
  }
  env.on(element, `fluxon:${name}:opened`, () => env.lv.execJS(element, element.dataset.onOpen));
  env.on(element, `fluxon:${name}:closed`, () => env.lv.execJS(element, element.dataset.onClose));
}
function isSignalLike(value) {
  return value != null && typeof value === "object" && "value" in value && typeof value.open !== "function";
}

// js/components/tooltip/tooltip.js
var WARMUP_COOLDOWN_MS = 500;
var HIDE_GRACE_MS = 100;
var FADE_S = 0.15;
var HANDOFF_FADE_S = 0.06;
var warmupByDoc = /* @__PURE__ */ new WeakMap();
function getWarmupState(doc) {
  let state = warmupByDoc.get(doc);
  if (state) return state;
  state = {
    isWarmedUp: false,
    activeCount: 0,
    cooldownTimer: null,
    current: null
  };
  state.notifyShow = () => {
    state.activeCount++;
    state.isWarmedUp = true;
    if (state.cooldownTimer) {
      clearTimeout(state.cooldownTimer);
      state.cooldownTimer = null;
    }
  };
  state.notifyHide = () => {
    state.activeCount = Math.max(0, state.activeCount - 1);
    if (state.activeCount === 0) {
      state.cooldownTimer = setTimeout(() => {
        state.isWarmedUp = false;
        state.cooldownTimer = null;
      }, WARMUP_COOLDOWN_MS);
    }
  };
  state.setCurrent = (entry) => {
    const previous = state.current;
    state.current = entry;
    if (previous && previous !== entry) previous.preempt();
  };
  state.releaseCurrent = (entry) => {
    if (state.current === entry) state.current = null;
  };
  state.reset = () => {
    if (state.cooldownTimer) clearTimeout(state.cooldownTimer);
    state.isWarmedUp = false;
    state.activeCount = 0;
    state.cooldownTimer = null;
    state.current = null;
  };
  warmupByDoc.set(doc, state);
  return state;
}
var hook = defineComponent("tooltip", (element, env) => {
  const cfg = env.config(element, {
    placement: { type: "enum", values: ["top", "bottom", "left", "right"], default: "top" },
    delay: { type: "number", default: 200 },
    target: { type: "string", default: null }
  });
  let externalTarget = null;
  if (cfg.target.value) {
    externalTarget = document.querySelector(cfg.target.value);
    if (!externalTarget) {
      throw new Error(`Tooltip target "${cfg.target.value}" not found`);
    }
  }
  const parts = env.parts(element, {
    trigger: { selector: ":first-child", required: !cfg.target.value },
    tooltip: { selector: '[data-part="tooltip"]', required: true },
    arrow: { selector: '[data-part="arrow"]', required: false }
  });
  const effectiveTrigger = () => externalTarget || parts.trigger;
  const warmup = getWarmupState(element.ownerDocument);
  const isVisible = env.signal(false, "isVisible");
  const isHovered = env.signal(false, "isHovered");
  const isFocused = env.signal(false, "isFocused");
  const shouldShow = env.computed("shouldShow", () => isHovered.value || isFocused.value);
  function requestShow() {
    isHovered.value = true;
  }
  function requestHide() {
    isHovered.value = false;
    isFocused.value = false;
  }
  function requestToggle() {
    if (isHovered.value || isFocused.value) requestHide();
    else requestShow();
  }
  overlayControls(env, element, {
    open: requestShow,
    close: requestHide,
    toggle: requestToggle
  });
  let showTimeoutId = null;
  let hideTimeoutId = null;
  let participatesInWarmup = false;
  let instantPhase = false;
  const clearShowTimeout = () => {
    if (showTimeoutId) {
      clearTimeout(showTimeoutId);
      showTimeoutId = null;
    }
  };
  const clearHideTimeout = () => {
    if (hideTimeoutId) {
      clearTimeout(hideTimeoutId);
      hideTimeoutId = null;
    }
  };
  const entry = {
    preempt: () => {
      if (shouldShow.value) return;
      if (!isVisible.value) return;
      clearHideTimeout();
      instantPhase = true;
      isVisible.value = false;
    }
  };
  env.abortSignal.addEventListener("abort", () => {
    clearShowTimeout();
    clearHideTimeout();
    warmup.releaseCurrent(entry);
    if (participatesInWarmup) {
      warmup.notifyHide();
      participatesInWarmup = false;
    }
  });
  let resolvedPlacement = cfg.placement.value;
  const updateArrowPosition = (placement, arrowData) => {
    if (!parts.arrow || !arrowData) return;
    const { x: arrowX, y: arrowY } = arrowData;
    const staticSide = { top: "bottom", right: "left", bottom: "top", left: "right" }[placement.split("-")[0]];
    Object.assign(parts.arrow.style, {
      left: arrowX != null ? `${arrowX}px` : "",
      top: arrowY != null ? `${arrowY}px` : "",
      right: "",
      bottom: "",
      [staticSide]: "-4px"
    });
  };
  const middleware = bubbleMiddleware({
    extra: parts.arrow ? [arrow2(() => ({ element: parts.arrow }))] : []
  });
  const overlayApi = overlay(env, {
    anchor: effectiveTrigger,
    panel: () => parts.tooltip,
    open: isVisible,
    placement: cfg.placement.value,
    strategy: "fixed",
    middleware,
    // A tooltip is hover-driven, not something the user navigated into: it answers for no
    // gesture, so Escape dismisses it and still reaches whatever is underneath.
    consumes: () => false,
    onDismiss: () => {
      isHovered.value = false;
      isFocused.value = false;
    },
    // Read fresh on every in()/out(), and consumed as it's read so the flag can't leak
    // from an open into the matching close. A tooltip that opened warm still fades out
    // normally when nothing takes over from it.
    duration: () => {
      const instant = instantPhase;
      instantPhase = false;
      return instant ? HANDOFF_FADE_S : FADE_S;
    },
    easing: "ease-out",
    onPlacement: (placement, middlewareData) => {
      resolvedPlacement = placement;
      if (parts.arrow && middlewareData?.arrow) {
        updateArrowPosition(placement, middlewareData.arrow);
      }
    },
    onBeforeOpen: () => {
      instantPhase = warmup.isWarmedUp;
      warmup.setCurrent(entry);
      if (cfg.delay.value > 0) {
        participatesInWarmup = true;
        warmup.notifyShow();
      }
    },
    onOpen: () => env.emit("opened"),
    onClose: () => {
      warmup.releaseCurrent(entry);
      if (participatesInWarmup) {
        warmup.notifyHide();
        participatesInWarmup = false;
      }
      env.emit("closed");
    }
  });
  env.effect(
    "aria-describedby",
    () => {
      const trigger2 = effectiveTrigger();
      const panelId = parts.tooltip?.id;
      if (!trigger2 || !panelId) return;
      env.attrs(trigger2, { "aria-describedby": panelId });
    },
    { onUpdated: true }
  );
  env.effect("schedule-visibility", () => {
    if (shouldShow.value) {
      clearHideTimeout();
      clearShowTimeout();
      const delay = warmup.isWarmedUp ? 0 : cfg.delay.value;
      if (delay > 0) {
        showTimeoutId = setTimeout(() => {
          showTimeoutId = null;
          isVisible.value = true;
        }, delay);
      } else {
        isVisible.value = true;
      }
    } else {
      clearShowTimeout();
      clearHideTimeout();
      if (isVisible.value) {
        hideTimeoutId = setTimeout(() => {
          hideTimeoutId = null;
          isVisible.value = false;
        }, HIDE_GRACE_MS);
      }
    }
  });
  const hoverTarget = externalTarget || element;
  let lastPointerWasTouch = false;
  env.on(hoverTarget, "pointerenter", (e) => {
    lastPointerWasTouch = !!e.pointerType && e.pointerType !== "mouse";
  });
  env.on(hoverTarget, "mouseenter", () => {
    if (lastPointerWasTouch) return;
    isHovered.value = true;
  });
  env.on(hoverTarget, "mouseleave", () => {
    isHovered.value = false;
  });
  let focusFromPointer = false;
  const trigger = effectiveTrigger();
  env.on(trigger, "mousedown", () => {
    focusFromPointer = true;
  });
  env.on(trigger, "focus", () => {
    if (focusFromPointer) {
      focusFromPointer = false;
      return;
    }
    isFocused.value = true;
  });
  env.on(trigger, "blur", () => {
    focusFromPointer = false;
    isFocused.value = false;
  });
  env.on(parts.tooltip, "mouseenter", () => {
    isHovered.value = true;
  });
  env.on(parts.tooltip, "mouseleave", () => {
    isHovered.value = false;
  });
  env.on(window, "blur", () => {
    isHovered.value = false;
    isFocused.value = false;
  });
  return {
    get isOpen() {
      return isVisible.value;
    },
    open() {
      if (isVisible.value) return false;
      requestShow();
      return true;
    },
    close() {
      if (!isVisible.value) return false;
      requestHide();
      return true;
    },
    toggle() {
      requestToggle();
      return isVisible.value;
    },
    // Test-only introspection — exposes the resolved parts/config so tests can assert
    // on internal wiring without re-querying the DOM. Components should not rely on
    // this for runtime behavior.
    parts,
    config: cfg
  };
});

// js/components/utils/mobile.js
var appleIphone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var androidTablet = /Android/i;
var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var amazonTablet = /Silk/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i;
var otherBlackBerry = /BlackBerry/i;
var otherBlackBerry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i;
var isAppleTabletOnIos13 = (navigator2) => {
  return typeof navigator2 !== "undefined" && navigator2.platform === "MacIntel" && typeof navigator2.maxTouchPoints === "number" && navigator2.maxTouchPoints > 1 && typeof MSStream === "undefined";
};
function createMatch(userAgent) {
  return (regex) => regex.test(userAgent);
}
function isMobile(param) {
  let nav = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  if (!param && typeof navigator !== "undefined") {
    nav = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      maxTouchPoints: navigator.maxTouchPoints || 0
    };
  } else if (typeof param === "string") {
    nav.userAgent = param;
  } else if (param && param.userAgent) {
    nav = {
      userAgent: param.userAgent,
      platform: param.platform,
      maxTouchPoints: param.maxTouchPoints || 0
    };
  }
  let userAgent = nav.userAgent;
  let tmp = userAgent.split("[FBAN");
  if (typeof tmp[1] !== "undefined") {
    userAgent = tmp[0];
  }
  tmp = userAgent.split("Twitter");
  if (typeof tmp[1] !== "undefined") {
    userAgent = tmp[0];
  }
  const match = createMatch(userAgent);
  const result = {
    apple: {
      phone: match(appleIphone) && !match(windowsPhone),
      ipod: match(appleIpod),
      tablet: !match(appleIphone) && (match(appleTablet) || isAppleTabletOnIos13(nav)) && !match(windowsPhone),
      universal: match(appleUniversal),
      device: (match(appleIphone) || match(appleIpod) || match(appleTablet) || match(appleUniversal) || isAppleTabletOnIos13(nav)) && !match(windowsPhone)
    },
    amazon: {
      phone: match(amazonPhone),
      tablet: !match(amazonPhone) && match(amazonTablet),
      device: match(amazonPhone) || match(amazonTablet)
    },
    android: {
      phone: !match(windowsPhone) && match(amazonPhone) || !match(windowsPhone) && match(androidPhone),
      tablet: !match(windowsPhone) && !match(amazonPhone) && !match(androidPhone) && (match(amazonTablet) || match(androidTablet)),
      device: !match(windowsPhone) && (match(amazonPhone) || match(amazonTablet) || match(androidPhone) || match(androidTablet)) || match(/\bokhttp\b/i)
    },
    windows: {
      phone: match(windowsPhone),
      tablet: match(windowsTablet),
      device: match(windowsPhone) || match(windowsTablet)
    },
    other: {
      blackberry: match(otherBlackBerry),
      blackberry10: match(otherBlackBerry10),
      opera: match(otherOpera),
      firefox: match(otherFirefox),
      chrome: match(otherChrome),
      device: match(otherBlackBerry) || match(otherBlackBerry10) || match(otherOpera) || match(otherFirefox) || match(otherChrome)
    },
    any: false,
    phone: false,
    tablet: false
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

// js/components/popover/popover.js
var PLACEMENTS = [
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end",
  "right",
  "right-start",
  "right-end"
];
var hook2 = defineComponent("popover", (element, env) => {
  const cfg = env.config(element, {
    placement: { type: "enum", values: PLACEMENTS, default: "top" },
    target: { type: "string", default: null },
    openOnHover: { type: "boolean", default: false },
    openOnFocus: { type: "boolean", default: false },
    open: { type: "boolean", default: false }
  });
  const parts = env.parts(element, {
    popover: { selector: '[data-part="popover"]', required: true }
  });
  let triggerEl = null;
  if (cfg.target.value) {
    triggerEl = document.querySelector(cfg.target.value);
    if (!triggerEl) {
      throw new Error(`Popover target "${cfg.target.value}" not found`);
    }
  } else {
    triggerEl = element.firstElementChild;
  }
  const hoverEnabled = cfg.openOnHover.value && !isMobile(window.navigator).any && !cfg.target.value;
  const focusEnabled = cfg.openOnFocus.value && !cfg.target.value;
  const clickEnabled = !cfg.target.value && !focusEnabled;
  if (triggerEl) {
    if (parts.popover.id) {
      triggerEl.setAttribute("aria-controls", parts.popover.id);
    }
    if (!triggerEl.hasAttribute("aria-haspopup")) {
      triggerEl.setAttribute("aria-haspopup", "dialog");
    }
  }
  const open = env.signal(false, "open");
  env.effect("sync-from-config-open", () => {
    open.value = cfg.open.value;
  });
  env.effect("aria-expanded", () => {
    if (triggerEl) {
      env.attrs(triggerEl, { "aria-expanded": open.value });
    }
  }, { onUpdated: true });
  overlay(env, {
    anchor: () => triggerEl,
    panel: () => parts.popover,
    open,
    placement: cfg.placement.value,
    middleware: bubbleMiddleware(),
    duration: 0.15,
    easing: "ease-out",
    closeOnOutsideClick: true,
    // In target mode the trigger lives outside `element`, so nominate it as inside —
    // otherwise the click that opens the popover reads as a dismissal.
    inside: () => cfg.target.value ? triggerEl : null,
    // Focus mode ignores Escape — the popover follows focus, so blur closes it anyway. Two
    // separate things to say: it takes no action (onDismiss), and it does not swallow the
    // key on the way past (consumes). Both scoped to that one reason, so clicking away still
    // closes the popover and stops there, exactly as in click mode.
    consumes: (reason) => !(focusEnabled && reason === "escape"),
    onDismiss: (reason) => {
      if (focusEnabled && reason === "escape") return;
      open.value = false;
    },
    onBeforeClose: () => {
      if (parts.popover.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    },
    onOpen: () => env.emit("opened"),
    onClose: () => env.emit("closed")
  });
  if (clickEnabled && triggerEl) {
    env.on(element, "click", (event) => {
      if (parts.popover.contains(event.target)) return;
      open.value = !open.value;
    });
  }
  if (focusEnabled && triggerEl) {
    env.on(element, "focusin", () => {
      open.value = true;
    });
    env.on(element, "focusout", (event) => {
      if (!element.contains(event.relatedTarget)) {
        open.value = false;
      }
    });
  }
  if (hoverEnabled && triggerEl) {
    env.on(element, "mouseenter", () => {
      env.timeout.cancel("hover-close");
      open.value = true;
    });
    env.on(element, "mouseleave", () => {
      env.timeout("hover-close", () => {
        open.value = false;
      }, 100);
    });
    env.on(parts.popover, "mouseenter", () => {
      env.timeout.cancel("hover-close");
    });
    env.on(parts.popover, "mouseleave", () => {
      open.value = false;
    });
  }
  overlayControls(env, element, open);
  return {
    open: () => {
      if (open.value) return false;
      open.value = true;
      return true;
    },
    close: () => {
      if (!open.value) return false;
      open.value = false;
      return true;
    },
    toggle: () => {
      open.value = !open.value;
      return open.value;
    },
    get isOpen() {
      return open.value;
    }
  };
});

// js/components/tabs/tabs.js
var NAV_KEYS = ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp", "Home", "End"];
var hook3 = defineComponent("tabs", (element, env) => {
  const parts = env.parts(element, {
    tablist: { selector: '[data-part="tablist"]', required: true },
    panels: { selector: ':scope > [data-part="tabpanel"]', multiple: true }
  });
  const getTabs = () => Array.from(parts.tablist.querySelectorAll(':scope > [data-part="tab"]'));
  if (getTabs().length === 0) {
    throw new Error('Required part "tabs" not found');
  }
  const panelFor = (tab) => {
    const id = tab.dataset.panel;
    return id ? document.getElementById(id) : null;
  };
  const findActiveIndex = () => {
    const idx = getTabs().findIndex((tab) => tab.getAttribute("aria-selected") === "true");
    return idx === -1 ? 0 : idx;
  };
  const activeIndex = env.signal(0, {
    name: "activeIndex",
    from: findActiveIndex
  });
  env.effect("aria-links", () => {
    for (const tab of getTabs()) {
      const panel = panelFor(tab);
      if (!panel) {
        if (tab.getAttribute("aria-controls") === tab.dataset.panel) {
          tab.removeAttribute("aria-controls");
        }
        continue;
      }
      if (tab.getAttribute("aria-controls") !== panel.id) {
        tab.setAttribute("aria-controls", panel.id);
      }
      if (tab.id && panel.getAttribute("aria-labelledby") !== tab.id) {
        panel.setAttribute("aria-labelledby", tab.id);
      }
    }
  }, { onUpdated: true });
  let changedInitialized = false;
  env.effect("emit-changed", () => {
    const current = activeIndex.value;
    if (!changedInitialized) {
      changedInitialized = true;
      return;
    }
    env.emit("changed", { value: current, previousValue: activeIndex.previous });
  });
  env.effect("tab-state", () => {
    const tabs = getTabs();
    const active = activeIndex.value;
    tabs.forEach((tab, i) => {
      const isActive = i === active;
      const panel = panelFor(tab);
      if (isActive) {
        tab.setAttribute("aria-selected", "true");
        tab.setAttribute("data-active", "");
        tab.setAttribute("tabindex", "0");
        if (panel) {
          panel.hidden = false;
          panel.setAttribute("aria-hidden", "false");
        }
      } else {
        tab.setAttribute("aria-selected", "false");
        tab.removeAttribute("data-active");
        tab.setAttribute("tabindex", "-1");
        if (panel) {
          if (panel.contains(document.activeElement)) {
            document.activeElement.blur();
          }
          panel.hidden = true;
          panel.setAttribute("aria-hidden", "true");
        }
      }
    });
  });
  const findEnabled = (from, step) => {
    const tabs = getTabs();
    const count = tabs.length;
    if (count === 0) return -1;
    let i = from;
    for (let n = 0; n < count; n++) {
      i = (i + step + count) % count;
      if (!isDisabled(tabs[i])) return i;
    }
    return -1;
  };
  const findEnabledFromEdge = (start, step) => {
    const tabs = getTabs();
    const count = tabs.length;
    let i = start;
    for (let n = 0; n < count; n++) {
      if (i >= 0 && i < count && !isDisabled(tabs[i])) return i;
      i += step;
    }
    return -1;
  };
  const activate = (index) => {
    const tabs = getTabs();
    if (index < 0 || index >= tabs.length) return false;
    if (isDisabled(tabs[index])) return false;
    activeIndex.value = index;
    return true;
  };
  env.on(
    parts.tablist,
    "click",
    (event, tab) => {
      if (isDisabled(tab)) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      const idx = getTabs().indexOf(tab);
      if (idx !== -1) activate(idx);
    },
    { delegate: '[data-part="tab"]' }
  );
  env.on(parts.tablist, "keydown", (event) => {
    if (!NAV_KEYS.includes(event.key)) return;
    const tabs = getTabs();
    if (tabs.length === 0) return;
    event.preventDefault();
    const current = activeIndex.value;
    let target = -1;
    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        target = findEnabled(current, 1);
        break;
      case "ArrowLeft":
      case "ArrowUp":
        target = findEnabled(current, -1);
        break;
      case "Home":
        target = findEnabledFromEdge(0, 1);
        break;
      case "End":
        target = findEnabledFromEdge(tabs.length - 1, -1);
        break;
    }
    if (target === -1) return;
    if (target === current) {
      tabs[target].focus();
      return;
    }
    tabs[target].focus();
    tabs[target].click();
  });
  return {
    get activeIndex() {
      return activeIndex.value;
    },
    activate(index) {
      return activate(index);
    }
  };
});

// js/components/dropdown/dropdown.js
var hook4 = defineComponent("dropdown", (element, env) => {
  const config = env.config(element, {
    placement: {
      type: "enum",
      values: [
        "top",
        "bottom",
        "left",
        "right",
        "top-start",
        "bottom-start",
        "left-start",
        "right-start",
        "top-end",
        "bottom-end",
        "left-end",
        "right-end"
      ],
      default: "bottom-start"
    },
    openOnHover: { type: "boolean", default: false },
    hoverOpenDelay: { type: "number", default: 200 },
    hoverCloseDelay: { type: "number", default: 200 }
  });
  const open = env.signal(false, "open");
  const openMenus = env.signal([], "openMenus");
  const highlightState = env.signal(/* @__PURE__ */ new Map(), "highlightState");
  const isMouseMode = env.signal(false, "isMouseMode");
  overlayControls(env, element, open);
  const parts = env.parts(element, {
    toggle: { selector: '[data-part="toggle"]', required: true },
    menu: { selector: '[data-part="menu"]', required: true }
  });
  const NavigationDirection4 = {
    NEXT: "next",
    PREV: "prev",
    FIRST: "first",
    LAST: "last"
  };
  const KeyboardActions4 = {
    SELECT: "select",
    NAVIGATE_DOWN: "navigateDown",
    NAVIGATE_UP: "navigateUp",
    NAVIGATE_RIGHT: "navigateRight",
    NAVIGATE_LEFT: "navigateLeft",
    TAB: "tab"
  };
  const menuRegistry = {
    root: null,
    submenus: /* @__PURE__ */ new Map(),
    // panelId → MenuContext
    triggerToSubmenu: /* @__PURE__ */ new Map(),
    // triggerElement → MenuContext
    initialize() {
      this.root = this.createMenuContext(parts.menu, null, null, 0);
      const panels = element.querySelectorAll(':scope > [data-part="submenu-panel"]');
      panels.forEach((panel) => {
        const ctx = this.createMenuContext(panel, null, null, 0);
        this.submenus.set(panel.id, ctx);
      });
      this.buildRelationships(this.root, 0);
    },
    buildRelationships(parentCtx, depth2) {
      const triggers = parentCtx.panel.querySelectorAll(
        ':scope > [data-part="submenu-trigger"]'
      );
      triggers.forEach((trigger) => {
        const submenuId = trigger.dataset.submenu;
        const submenuCtx = this.submenus.get(submenuId);
        if (submenuCtx) {
          submenuCtx.trigger = trigger;
          submenuCtx.parent = parentCtx;
          submenuCtx.depth = depth2 + 1;
          this.triggerToSubmenu.set(trigger, submenuCtx);
          this.buildRelationships(submenuCtx, depth2 + 1);
        }
      });
    },
    createMenuContext(panel, trigger, parent, depth2) {
      return { panel, trigger, parent, depth: depth2, floating: null, transition: null };
    },
    getItemsForMenu(ctx) {
      if (!ctx?.panel) return [];
      return Array.from(
        ctx.panel.querySelectorAll(
          ':scope > [data-part="menuitem"], :scope > [data-part="submenu-trigger"]'
        )
      );
    },
    getContextByTrigger(trigger) {
      return this.triggerToSubmenu.get(trigger) || null;
    },
    isSubmenuTrigger(item) {
      return item?.getAttribute("data-part") === "submenu-trigger";
    }
  };
  const menuState = {
    openSubmenu(ctx) {
      if (!ctx) return;
      const currentChain = openMenus.value;
      const parentIndex = ctx.parent === menuRegistry.root ? -1 : currentChain.findIndex((m) => m === ctx.parent);
      const baseIndex = parentIndex + 1;
      openMenus.value = [...currentChain.slice(0, baseIndex), ctx];
    },
    closeSubmenu(ctx) {
      const currentChain = openMenus.value;
      const idx = currentChain.indexOf(ctx);
      if (idx === -1) return;
      openMenus.value = currentChain.slice(0, idx);
    },
    closeAllSubmenus() {
      openMenus.value = [];
    },
    isOpen(ctx) {
      return openMenus.value.includes(ctx);
    },
    get activeMenu() {
      return activeMenu.value;
    }
  };
  const items = {
    getIndex(ctx, item) {
      return menuRegistry.getItemsForMenu(ctx).indexOf(item);
    },
    getByIndex(ctx, index) {
      return menuRegistry.getItemsForMenu(ctx)[index] ?? null;
    }
  };
  const navigation = {
    navigate(direction) {
      const active = menuState.activeMenu;
      if (!active) return;
      const menuItems = menuRegistry.getItemsForMenu(active);
      if (!menuItems.length) return;
      const currentIdx = this.getCurrentIndex(active);
      const newIdx = this.calculateNewIndex(currentIdx, menuItems.length, direction, menuItems);
      if (newIdx !== null && newIdx !== currentIdx) {
        this.highlight(active, newIdx, false);
      }
    },
    getCurrentIndex(ctx) {
      return highlightState.value.get(ctx) ?? -1;
    },
    calculateNewIndex(currentIdx, totalCount, direction, allItems) {
      if (currentIdx === -1) {
        const isForward = direction === NavigationDirection4.NEXT || direction === NavigationDirection4.FIRST;
        return isForward ? this.findNextEnabled(-1, 1, allItems) : this.findNextEnabled(totalCount, -1, allItems);
      }
      switch (direction) {
        case NavigationDirection4.NEXT:
          return this.findNextEnabled(currentIdx, 1, allItems);
        case NavigationDirection4.PREV:
          return this.findNextEnabled(currentIdx, -1, allItems);
        case NavigationDirection4.FIRST:
          return this.findNextEnabled(-1, 1, allItems);
        case NavigationDirection4.LAST:
          return this.findNextEnabled(totalCount, -1, allItems);
        default:
          return currentIdx;
      }
    },
    findNextEnabled(startIdx, increment, allItems) {
      let idx = startIdx + increment;
      while (idx >= 0 && idx < allItems.length) {
        if (!isDisabled(allItems[idx])) return idx;
        idx += increment;
      }
      return startIdx === -1 ? null : startIdx;
    },
    _setHighlight(ctx, index, fromMouse) {
      const map = new Map(highlightState.value);
      map.set(ctx, index);
      highlightState.value = map;
      isMouseMode.value = fromMouse;
    },
    highlight(ctx, index, fromMouse = false) {
      this._setHighlight(ctx, index, fromMouse);
      if (!fromMouse && index >= 0) {
        items.getByIndex(ctx, index)?.scrollIntoView({ block: "nearest" });
      }
    },
    clearHighlight(ctx = null) {
      if (ctx) {
        const map = new Map(highlightState.value);
        map.delete(ctx);
        highlightState.value = map;
      } else {
        highlightState.value = /* @__PURE__ */ new Map();
      }
    },
    // ArrowRight or hover-enter on a submenu trigger.
    enterSubmenu() {
      const active = menuState.activeMenu;
      const index = highlightState.value.get(active);
      if (index === void 0) return false;
      const item = items.getByIndex(active, index);
      if (!item || !menuRegistry.isSubmenuTrigger(item)) return false;
      const ctx = menuRegistry.getContextByTrigger(item);
      if (!ctx) return false;
      menuState.openSubmenu(ctx);
      const submenuItems = menuRegistry.getItemsForMenu(ctx);
      const firstEnabled = this.findNextEnabled(-1, 1, submenuItems);
      if (firstEnabled !== null) {
        this.highlight(ctx, firstEnabled, false);
      }
      return true;
    },
    // ArrowLeft — exit current submenu back to parent.
    exitSubmenu() {
      const active = menuState.activeMenu;
      if (!active || active === menuRegistry.root) return false;
      menuState.closeSubmenu(active);
      this.clearHighlight(active);
      return true;
    }
  };
  const selection = {
    activate() {
      const active = menuState.activeMenu;
      const index = highlightState.value.get(active);
      if (index === void 0) return;
      const item = items.getByIndex(active, index);
      if (!item || isDisabled(item)) return;
      if (menuRegistry.isSubmenuTrigger(item)) {
        navigation.enterSubmenu();
        return;
      }
      if (item.tagName === "A") {
        window.location.href = item.href;
      } else {
        item.click();
      }
      open.value = false;
      parts.toggle.focus();
    }
  };
  const submenuHover = {
    pendingSubmenu: null,
    openTimer: null,
    OPEN_DELAY: 80,
    handleTriggerEnter(trigger, submenuCtx) {
      this.clearOpenTimer();
      const parentMenu = submenuCtx.parent || menuRegistry.root;
      const currentChain = openMenus.value;
      const siblingIndex = currentChain.findIndex((ctx) => ctx.parent === parentMenu);
      if (siblingIndex !== -1 && currentChain[siblingIndex] !== submenuCtx) {
        openMenus.value = currentChain.slice(0, siblingIndex);
      }
      this.pendingSubmenu = { trigger, ctx: submenuCtx };
      this.openTimer = setTimeout(() => {
        menuState.openSubmenu(submenuCtx);
        this.pendingSubmenu = null;
      }, this.OPEN_DELAY);
    },
    handleTriggerLeave(trigger) {
      if (this.pendingSubmenu?.trigger === trigger) {
        this.clearOpenTimer();
        this.pendingSubmenu = null;
      }
    },
    clearOpenTimer() {
      if (this.openTimer) {
        clearTimeout(this.openTimer);
        this.openTimer = null;
      }
    },
    cleanup() {
      this.clearOpenTimer();
      this.pendingSubmenu = null;
    }
  };
  const itemEvents = {
    closeChildSubmenus(ctx) {
      const currentChain = openMenus.value;
      const ctxIndex = currentChain.indexOf(ctx);
      if (ctxIndex !== -1 && ctxIndex < currentChain.length - 1) {
        openMenus.value = currentChain.slice(0, ctxIndex + 1);
      }
    },
    hasOpenChildSubmenus(ctx) {
      const ctxIndex = openMenus.value.indexOf(ctx);
      return ctxIndex !== -1 && ctxIndex < openMenus.value.length - 1;
    },
    setupForMenu(menuCtx, panel) {
      const isRoot = menuCtx === menuRegistry.root;
      env.on(
        panel,
        "mouseover",
        (e, target) => {
          const idx = items.getIndex(menuCtx, target);
          if (idx === -1 || isDisabled(target)) return;
          navigation.highlight(menuCtx, idx, true);
          if (!menuRegistry.isSubmenuTrigger(target)) {
            if (isRoot) {
              if (openMenus.value.length > 0) menuState.closeAllSubmenus();
            } else {
              this.closeChildSubmenus(menuCtx);
            }
          }
        },
        { delegate: '[data-part="menuitem"]' }
      );
      env.on(
        panel,
        "click",
        (e, target) => {
          const idx = items.getIndex(menuCtx, target);
          if (idx === -1 || isDisabled(target)) return;
          setTimeout(() => {
            open.value = false;
          }, 10);
        },
        { delegate: '[data-part="menuitem"]' }
      );
      env.on(panel, "mouseleave", () => {
        if (!isMouseMode.value) return;
        if (isRoot) {
          if (openMenus.value.length === 0) navigation.clearHighlight();
        } else {
          if (!this.hasOpenChildSubmenus(menuCtx)) navigation.clearHighlight(menuCtx);
        }
      });
      env.on(panel, "mouseover", (e) => {
        const isMenuItem = e.target.closest(
          '[data-part="menuitem"], [data-part="submenu-trigger"]'
        );
        if (isMenuItem || !isMouseMode.value) return;
        submenuHover.cleanup();
        if (highlightState.value.has(menuCtx)) navigation.clearHighlight(menuCtx);
        if (isRoot) {
          if (openMenus.value.length > 0) menuState.closeAllSubmenus();
        } else {
          this.closeChildSubmenus(menuCtx);
        }
      });
    }
  };
  const isComponentDisabled = () => parts.toggle?.disabled || isDisabled(parts.toggle);
  const hover = {
    timeoutId: null,
    clearTimeout() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    handleEnter() {
      if (!config.openOnHover.value) return;
      if (isComponentDisabled()) return;
      this.clearTimeout();
      if (!open.value) {
        this.timeoutId = setTimeout(() => {
          open.value = true;
        }, config.hoverOpenDelay.value);
      }
    },
    handleLeave() {
      if (!config.openOnHover.value) return;
      this.clearTimeout();
      this.timeoutId = setTimeout(() => {
        open.value = false;
      }, config.hoverCloseDelay.value);
    }
  };
  const keyboard = {
    getAction(key) {
      const keyMap = {
        Enter: KeyboardActions4.SELECT,
        " ": KeyboardActions4.SELECT,
        ArrowDown: KeyboardActions4.NAVIGATE_DOWN,
        ArrowUp: KeyboardActions4.NAVIGATE_UP,
        ArrowRight: KeyboardActions4.NAVIGATE_RIGHT,
        ArrowLeft: KeyboardActions4.NAVIGATE_LEFT,
        Tab: KeyboardActions4.TAB
      };
      return keyMap[key] || null;
    },
    handleAction(action) {
      const handlers = {
        [KeyboardActions4.SELECT]: () => this.handleSelect(),
        [KeyboardActions4.NAVIGATE_DOWN]: () => this.handleVerticalNavigation(true),
        [KeyboardActions4.NAVIGATE_UP]: () => this.handleVerticalNavigation(false),
        [KeyboardActions4.NAVIGATE_RIGHT]: () => navigation.enterSubmenu(),
        [KeyboardActions4.NAVIGATE_LEFT]: () => navigation.exitSubmenu(),
        [KeyboardActions4.TAB]: () => this.handleTab()
      };
      return handlers[action]?.();
    },
    handleSelect() {
      if (!open.value) {
        open.value = true;
        return;
      }
      const active = menuState.activeMenu;
      if (highlightState.value.has(active)) {
        selection.activate();
      } else {
        open.value = false;
      }
    },
    handleVerticalNavigation(isDown) {
      const wasOpen = open.value;
      if (!wasOpen) open.value = true;
      let direction;
      if (!wasOpen) direction = isDown ? NavigationDirection4.FIRST : NavigationDirection4.LAST;
      else direction = isDown ? NavigationDirection4.NEXT : NavigationDirection4.PREV;
      navigation.navigate(direction);
    },
    handleTab() {
      if (open.value) open.value = false;
    }
  };
  const submenuFloating = {
    ensureFloating(ctx) {
      if (ctx.floating) return ctx.floating;
      const placement = ctx.panel.dataset.placement || "right-start";
      ctx.panelMiddleware = panelMiddleware({
        gap: ({ placement: p }) => p.startsWith("bottom") || p.startsWith("top") ? { mainAxis: 4, crossAxis: 0 } : { mainAxis: -2, crossAxis: -6 },
        matchAnchorWidth: false,
        clampWidth: true,
        flipOptions: {
          fallbackPlacements: ["right-end", "left-start", "left-end", "bottom-start", "top-start"]
        }
      });
      ctx.floating = floating(ctx.trigger, ctx.panel, {
        placement,
        strategy: "fixed",
        middleware: ctx.panelMiddleware.middleware,
        signal: env.abortSignal
      });
      return ctx.floating;
    },
    ensureTransition(ctx) {
      if (ctx.transition) return ctx.transition;
      ctx.transition = transition(ctx.panel, {
        in: { opacity: [0, 1], transform: ["translateX(-4px)", "translateX(0)"] },
        out: { opacity: [1, 0], transform: ["translateX(0)", "translateX(-4px)"] },
        duration: 0.08,
        easing: "ease-out",
        signal: env.abortSignal
      });
      return ctx.transition;
    },
    async openSubmenu(ctx) {
      const popper2 = this.ensureFloating(ctx);
      const anim2 = this.ensureTransition(ctx);
      ctx.panel.hidden = false;
      ctx.panelMiddleware.invalidateCap();
      popper2.attach();
      await anim2.in();
    },
    async closeSubmenu(ctx) {
      if (!ctx.transition) return;
      await ctx.transition.out();
      ctx.panel.hidden = true;
      if (ctx.floating) ctx.floating.detach();
    }
  };
  let resolvedPlacement = config.placement.value;
  const menuPanel = panelMiddleware({ matchAnchorWidth: false });
  const popper = floating(parts.toggle, parts.menu, {
    placement: config.placement.value,
    strategy: "fixed",
    middleware: menuPanel.middleware,
    onPlacement: (placement) => {
      resolvedPlacement = placement;
    },
    signal: env.abortSignal
  });
  const anim = transition(parts.menu, {
    ...slideFromPlacement(() => resolvedPlacement),
    duration: 0.15,
    easing: "ease-out",
    signal: env.abortSignal
  });
  const rootMenu = {
    async open() {
      anim.cancel();
      parts.menu.hidden = false;
      menuPanel.invalidateCap();
      popper.attach();
      await anim.in();
      clearTransitionResidue(parts.menu);
      env.emit("opened");
    },
    async close() {
      if (parts.menu.hidden) return;
      anim.cancel();
      submenuHover.cleanup();
      hover.clearTimeout();
      openMenus.value = [];
      highlightState.value = /* @__PURE__ */ new Map();
      await anim.out();
      parts.menu.hidden = true;
      clearTransitionResidue(parts.menu);
      popper.detach();
      for (const ctx of menuRegistry.submenus.values()) {
        if (!ctx.panel.hidden) {
          ctx.panel.hidden = true;
          ctx.floating?.detach();
        }
      }
      env.emit("closed");
    }
  };
  menuRegistry.initialize();
  const activeMenu = env.computed("activeMenu", () => {
    const chain = openMenus.value;
    return chain.length > 0 ? chain[chain.length - 1] : menuRegistry.root;
  });
  env.onChange(open, {
    async enter() {
      await rootMenu.open();
    },
    async exit() {
      await rootMenu.close();
    }
  });
  env.effect("submenu-state", async () => {
    const currentlyOpen = new Set(openMenus.value);
    for (const ctx of openMenus.value) {
      if (!ctx.panel.hidden) continue;
      await submenuFloating.openSubmenu(ctx);
    }
    const toClose = [];
    for (const ctx of menuRegistry.submenus.values()) {
      if (currentlyOpen.has(ctx)) continue;
      if (ctx.panel.hidden) continue;
      toClose.push(submenuFloating.closeSubmenu(ctx));
    }
    await Promise.all(toClose);
  });
  env.effect("aria-expanded", () => {
    env.attrs(parts.toggle, {
      "aria-expanded": String(open.value),
      "data-active": open.value ? true : false
    });
  }, { onUpdated: true });
  env.effect("submenu-aria-expanded", () => {
    for (const ctx of menuRegistry.submenus.values()) {
      const isOpen = menuState.isOpen(ctx);
      env.attrs(ctx.trigger, { "aria-expanded": String(isOpen) });
    }
  }, { onUpdated: true });
  env.effect("aria-activedescendant", () => {
    env.attrs(parts.menu, { "aria-activedescendant": null });
    for (const ctx of menuRegistry.submenus.values()) {
      env.attrs(ctx.panel, { "aria-activedescendant": null });
    }
    const active = menuState.activeMenu;
    const index = highlightState.value.get(active);
    if (index !== void 0) {
      const item = items.getByIndex(active, index);
      if (item?.id && active.panel) {
        env.attrs(active.panel, { "aria-activedescendant": item.id });
      }
    }
  });
  env.effect("item-highlight", () => {
    const clearHighlights = (ctx) => {
      menuRegistry.getItemsForMenu(ctx).forEach((item) => {
        env.attrs(item, { "data-highlighted": false });
      });
    };
    clearHighlights(menuRegistry.root);
    for (const ctx of menuRegistry.submenus.values()) {
      clearHighlights(ctx);
    }
    for (const [menu, index] of highlightState.value) {
      const item = items.getByIndex(menu, index);
      if (item) env.attrs(item, { "data-highlighted": true });
    }
  });
  env.effect("item-setup", () => {
    const setupItems = (ctx) => {
      menuRegistry.getItemsForMenu(ctx).forEach((item) => {
        if (!item.hasAttribute("tabindex")) {
          env.attrs(item, { tabindex: "-1" });
        }
      });
    };
    setupItems(menuRegistry.root);
    for (const ctx of menuRegistry.submenus.values()) {
      setupItems(ctx);
    }
  }, { onUpdated: true });
  dismissable(env, {
    open,
    contains: (node) => element.contains(node),
    refocusOnEscape: () => parts.toggle
  });
  env.effect("hover-events", () => {
    if (!config.openOnHover.value) return;
    env.on(parts.toggle, "mouseenter", () => hover.handleEnter());
    env.on(parts.toggle, "mouseleave", () => hover.handleLeave());
    env.on(parts.menu, "mouseenter", () => hover.handleEnter());
    env.on(parts.menu, "mouseleave", () => hover.handleLeave());
    return () => hover.clearTimeout();
  });
  env.effect("submenu-trigger-events", () => {
    if (!open.value) return;
    for (const ctx of menuRegistry.submenus.values()) {
      if (!ctx.trigger) continue;
      env.on(ctx.trigger, "mouseenter", () => {
        submenuHover.handleTriggerEnter(ctx.trigger, ctx);
        const parentMenu = ctx.parent || menuRegistry.root;
        const parentItems = menuRegistry.getItemsForMenu(parentMenu);
        const triggerIndex = parentItems.indexOf(ctx.trigger);
        if (triggerIndex !== -1) {
          navigation.highlight(parentMenu, triggerIndex, true);
        }
      });
      env.on(ctx.trigger, "mouseleave", () => {
        submenuHover.handleTriggerLeave(ctx.trigger);
      });
      env.on(ctx.trigger, "click", (e) => {
        e.preventDefault();
        submenuHover.clearOpenTimer();
        submenuHover.pendingSubmenu = null;
        if (menuState.isOpen(ctx)) {
          menuState.closeSubmenu(ctx);
        } else {
          menuState.openSubmenu(ctx);
        }
      });
    }
    return () => submenuHover.cleanup();
  });
  env.on(parts.toggle, "click", (e) => {
    e.preventDefault();
    if (isComponentDisabled()) return;
    open.value = !open.value;
  });
  env.on(element, "keydown", (e) => {
    const action = keyboard.getAction(e.key);
    if (!action) return;
    if (action !== KeyboardActions4.TAB) {
      e.preventDefault();
    }
    if (action !== KeyboardActions4.TAB && !open.value && isComponentDisabled()) return;
    keyboard.handleAction(action);
  });
  itemEvents.setupForMenu(menuRegistry.root, parts.menu);
  for (const ctx of menuRegistry.submenus.values()) {
    itemEvents.setupForMenu(ctx, ctx.panel);
  }
  return {
    get isOpen() {
      return open.value;
    },
    open() {
      if (isComponentDisabled()) return false;
      if (open.value) return false;
      open.value = true;
      return true;
    },
    close() {
      if (!open.value) return false;
      open.value = false;
      return true;
    },
    toggle() {
      if (isComponentDisabled()) return open.value;
      open.value = !open.value;
      return open.value;
    }
  };
});

// js/ui/focus-trap.js
var FOCUSABLE_SELECTOR = [
  'a[href]:not([rel="ignore"])',
  "area[href]",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "iframe",
  '[tabindex]:not([tabindex="-1"]):not([aria-hidden="true"])'
].join(",");
var isTabbable = (el) => typeof el.checkVisibility !== "function" || el.checkVisibility({ visibilityProperty: true });
function focusTrap(element, options = {}) {
  const {
    initial = () => null,
    scrollLock = false,
    inertBackground = false,
    escape = () => false,
    manageFocus = true
  } = options;
  let active = false;
  let controller = null;
  let appliedInertElements = [];
  let savedBodyOverflow = null;
  let savedBodyPaddingRight = null;
  const queryFocusables = () => Array.from(element.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (el) => !el.hasAttribute("disabled") && el.getAttribute("tabindex") !== "-1" && isTabbable(el)
  );
  const focusInitial = () => {
    const target = initial?.();
    if (target && element.contains(target)) {
      target.focus({ preventScroll: true });
      return true;
    }
    const focusables = queryFocusables();
    if (focusables.length > 0) {
      focusables[0].focus({ preventScroll: true });
      return true;
    }
    return false;
  };
  const onKeyDown = (e) => {
    if (e.key !== "Tab") return;
    if (escape(e, e.target)) return;
    const focusables = queryFocusables();
    if (focusables.length === 0) {
      e.preventDefault();
      return;
    }
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const current = document.activeElement;
    const edge = e.shiftKey ? first : last;
    const wrapTo = e.shiftKey ? last : first;
    if (current === edge || current === element || !element.contains(current)) {
      e.preventDefault();
      wrapTo.focus({ preventScroll: true });
    }
  };
  const applyInert2 = () => {
    if (!inertBackground) return;
    let node = element;
    while (node && node !== document.body && node.parentElement) {
      const parent = node.parentElement;
      for (const sibling of parent.children) {
        if (sibling !== node && !sibling.hasAttribute("inert")) {
          sibling.setAttribute("inert", "");
          appliedInertElements.push(sibling);
        }
      }
      node = parent;
    }
  };
  const removeInert = () => {
    appliedInertElements.forEach((el) => el.removeAttribute("inert"));
    appliedInertElements = [];
  };
  const applyScrollLock = () => {
    if (!scrollLock) return;
    const body = document.body;
    savedBodyOverflow = body.style.overflow;
    savedBodyPaddingRight = body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      const currentPadding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
    }
    body.style.overflow = "hidden";
  };
  const removeScrollLock = () => {
    if (!scrollLock) return;
    const body = document.body;
    body.style.overflow = savedBodyOverflow ?? "";
    body.style.paddingRight = savedBodyPaddingRight ?? "";
    savedBodyOverflow = null;
    savedBodyPaddingRight = null;
  };
  const abortKeydown = () => {
    if (controller) {
      controller.abort();
      controller = null;
    }
  };
  const attachListener = () => {
    abortKeydown();
    controller = new AbortController();
    element.addEventListener("keydown", onKeyDown, { signal: controller.signal });
  };
  if (options.signal) {
    options.signal.addEventListener("abort", () => {
      if (active) {
        removeInert();
        removeScrollLock();
      }
      abortKeydown();
    });
  }
  return {
    activate() {
      if (active) return;
      active = true;
      applyScrollLock();
      applyInert2();
      attachListener();
      if (manageFocus) {
        Promise.resolve().then(() => {
          if (active) focusInitial();
        });
      }
    },
    deactivate() {
      if (!active) return;
      active = false;
      abortKeydown();
      removeInert();
      removeScrollLock();
    },
    get isActive() {
      return active;
    }
  };
}

// js/components/utils/scrollbar-helper.js
var ScrollbarHelper = class _ScrollbarHelper {
  static #instance = null;
  #element;
  #originalPadding = null;
  #originalOverflow = null;
  #referenceCount = 0;
  constructor() {
    if (_ScrollbarHelper.#instance) return _ScrollbarHelper.#instance;
    _ScrollbarHelper.#instance = this;
    this.#element = document.body;
  }
  hasScrollbarGutterStable() {
    const htmlElement = document.documentElement;
    const computedStyle = window.getComputedStyle(htmlElement);
    return computedStyle.scrollbarGutter === "stable";
  }
  getWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
  }
  hide() {
    this.#referenceCount++;
    if (this.#referenceCount > 1) {
      return;
    }
    if (this.hasScrollbarGutterStable()) {
      this.#originalOverflow = this.#element.style.overflow;
      this.#element.style.overflow = "hidden";
      return;
    }
    const scrollbarWidth = this.getWidth();
    if (scrollbarWidth === 0) {
      this.#originalOverflow = this.#element.style.overflow;
      this.#element.style.overflow = "hidden";
      return;
    }
    this.#originalPadding = this.#element.style.paddingRight;
    this.#originalOverflow = this.#element.style.overflow;
    const currentPadding = parseFloat(window.getComputedStyle(this.#element).paddingRight);
    this.#element.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
    this.#element.style.overflow = "hidden";
  }
  reset() {
    this.#referenceCount = Math.max(0, this.#referenceCount - 1);
    if (this.#referenceCount > 0) {
      return;
    }
    if (this.#originalPadding !== null) {
      this.#element.style.paddingRight = this.#originalPadding;
    }
    if (this.#originalOverflow !== null) {
      this.#element.style.overflow = this.#originalOverflow;
    }
    this.#originalPadding = null;
    this.#originalOverflow = null;
  }
  // Force reset the helper state (useful for testing or error recovery)
  forceReset() {
    this.#referenceCount = 0;
    if (this.#originalPadding !== null) {
      this.#element.style.paddingRight = this.#originalPadding;
    }
    if (this.#originalOverflow !== null) {
      this.#element.style.overflow = this.#originalOverflow;
    }
    this.#originalPadding = null;
    this.#originalOverflow = null;
  }
};

// js/components/dialog/stacker.js
var stack = [];
var scrollbarHelper = new ScrollbarHelper();
var scrollbarHidden = false;
var inertedElements = [];
function applyInert() {
  inertedElements.forEach((el) => el.removeAttribute("inert"));
  inertedElements = [];
  if (stack.length === 0) return;
  for (const dialog of stack) {
    let branch = dialog;
    while (branch && branch !== document.body && branch.parentElement) {
      const parent = branch.parentElement;
      for (const sibling of parent.children) {
        if (sibling === branch) continue;
        if (stack.some((el) => sibling === el || sibling.contains(el))) continue;
        if (parent === document.body && sibling.matches('[data-part="toaster"]')) continue;
        if (sibling.hasAttribute("inert")) continue;
        sibling.setAttribute("inert", "");
        inertedElements.push(sibling);
      }
      branch = parent;
    }
  }
}
var warnedAboutInertToaster = false;
function warnIfToasterGoesInert() {
  if (warnedAboutInertToaster) return;
  const toaster = document.querySelector('[data-part="toaster"]');
  if (!toaster || !inertedElements.some((el) => el.contains(toaster))) return;
  warnedAboutInertToaster = true;
  console.warn(
    "[Fluxon.Dialog] The <.toaster> sits in a part of the page that goes inert while a dialog is open, so toasts can't be read or dismissed until the dialog closes. Place <.toaster /> in the layout that renders your dialogs, or at the root of <body>."
  );
}
function applyState() {
  stack.forEach((el, index) => {
    el.dataset.stackState = index === stack.length - 1 ? "foreground" : "background";
    el.style.zIndex = String(1e3 + index * 10);
  });
  const shouldHide = stack.length > 0;
  if (shouldHide && !scrollbarHidden) {
    scrollbarHelper.hide();
    scrollbarHidden = true;
  } else if (!shouldHide && scrollbarHidden) {
    scrollbarHelper.reset();
    scrollbarHidden = false;
  }
  applyInert();
}
var stacker = {
  push(element) {
    if (stack.includes(element)) return;
    stack.push(element);
    applyState();
    warnIfToasterGoesInert();
  },
  remove(element) {
    const i = stack.indexOf(element);
    if (i === -1) return;
    stack.splice(i, 1);
    element.removeAttribute("data-stack-state");
    element.style.zIndex = "";
    applyState();
  },
  reapplyState() {
    stack.forEach((el, index) => {
      el.style.zIndex = String(1e3 + index * 10);
      el.dataset.stackState = index === stack.length - 1 ? "foreground" : "background";
    });
    applyInert();
  },
  __resetForTest() {
    stack.forEach((el) => {
      el.removeAttribute("data-stack-state");
      el.style.zIndex = "";
    });
    stack.length = 0;
    inertedElements.forEach((el) => el.removeAttribute("inert"));
    inertedElements = [];
    warnedAboutInertToaster = false;
    if (scrollbarHidden) {
      scrollbarHelper.forceReset();
      scrollbarHidden = false;
    }
  }
};

// js/components/dialog/dialog.js
var SCALE_KEYFRAMES = {
  in: { opacity: [0, 1], scale: [0.95, 1] },
  out: { opacity: [1, 0], scale: [1, 0.95] }
};
var SLIDE_KEYFRAMES = {
  // Edge-anchored modals slide in from their edge (subtle 5% offset + fade).
  "modal-top": { in: { opacity: [0, 1], translate: ["0 -5%", "0 0"] }, out: { opacity: [1, 0], translate: ["0 0", "0 -5%"] } },
  "modal-bottom": { in: { opacity: [0, 1], translate: ["0 5%", "0 0"] }, out: { opacity: [1, 0], translate: ["0 0", "0 5%"] } },
  "modal-left": { in: { opacity: [0, 1], translate: ["-5% 0", "0 0"] }, out: { opacity: [1, 0], translate: ["0 0", "-5% 0"] } },
  "modal-right": { in: { opacity: [0, 1], translate: ["5% 0", "0 0"] }, out: { opacity: [1, 0], translate: ["0 0", "5% 0"] } },
  // Sheets slide fully off-screen (full panel slide).
  "sheet-left": { in: { translate: ["-100% 0", "0 0"] }, out: { translate: ["0 0", "-100% 0"] } },
  "sheet-right": { in: { translate: ["100% 0", "0 0"] }, out: { translate: ["0 0", "100% 0"] } },
  "sheet-top": { in: { translate: ["0 -100%", "0 0"] }, out: { translate: ["0 0", "0 -100%"] } },
  "sheet-bottom": { in: { translate: ["0 100%", "0 0"] }, out: { translate: ["0 0", "0 100%"] } }
};
var BACKDROP_KEYFRAMES = {
  in: { opacity: [0, 1] },
  out: { opacity: [1, 0] }
};
var hook5 = defineComponent("dialog", (element, env) => {
  const cfg = env.config(element, {
    open: { type: "boolean", default: false },
    closeOnEsc: { type: "boolean", default: true },
    closeOnOutsideClick: { type: "boolean", default: true },
    preventClosing: { type: "boolean", default: false },
    placement: { type: "string", default: "center" },
    variant: { type: "enum", values: ["modal", "sheet"], default: "modal" },
    // Stack state is written by the stacker module, not by the server. The dialog reads
    // it to decide focus-trap activation.
    stackState: { type: "enum", values: ["foreground", "background"], default: "foreground" }
  });
  const parts = env.parts(element, {
    dialog: { selector: '[data-part="dialog"]', required: true },
    backdrop: { selector: '[data-part="backdrop"]', required: true },
    content: { selector: '[data-part="content"]', required: true }
  });
  const open = env.signal(false, "open");
  let lastFocusedElement = null;
  const isForeground = () => cfg.stackState.value === "foreground";
  const animationKey = `${cfg.variant.value}-${cfg.placement.value}`;
  const animationKeyframes = SLIDE_KEYFRAMES[animationKey] ?? SCALE_KEYFRAMES;
  const duration = cfg.variant.value === "sheet" ? 0.2 : 0.15;
  const transitionOpts = { duration, easing: "ease-out", signal: env.abortSignal };
  const dialogTransition = transition(parts.dialog, { ...animationKeyframes, ...transitionOpts });
  const backdropTransition = transition(parts.backdrop, { ...BACKDROP_KEYFRAMES, ...transitionOpts });
  const clearResidue = () => {
    Object.assign(parts.dialog.style, { opacity: "", scale: "", translate: "", transform: "" });
    parts.backdrop.style.opacity = "";
  };
  const focusInitial = () => {
    const autofocus = parts.dialog.querySelector("[autofocus]");
    (autofocus || parts.dialog).focus({ preventScroll: true });
  };
  env.onChange(open, {
    async enter(abortSignal) {
      element.hidden = false;
      lastFocusedElement = document.activeElement;
      stacker.push(element);
      await Promise.all([dialogTransition.in(), backdropTransition.in()]);
      clearResidue();
      if (!abortSignal?.aborted) focusInitial();
      env.emit("opened");
    },
    async exit() {
      await Promise.all([dialogTransition.out(), backdropTransition.out()]);
      element.hidden = true;
      clearResidue();
      const wasForeground = isForeground();
      stacker.remove(element);
      if (wasForeground) {
        lastFocusedElement?.focus?.({ preventScroll: true });
      }
      env.emit("closed");
    }
  });
  const trap = focusTrap(parts.dialog, { manageFocus: false, signal: env.abortSignal });
  env.effect("focus-trap", () => {
    if (open.value && isForeground()) trap.activate();
    else trap.deactivate();
  }, { onUpdated: true });
  dismissable(env, {
    open,
    modal: true,
    contains: (node) => !!parts.content?.contains(node),
    onDismiss: (reason) => {
      if (cfg.preventClosing.value) return;
      if (reason === "outside" && !cfg.closeOnOutsideClick.value) return;
      if (reason === "escape" && !cfg.closeOnEsc.value) return;
      open.value = false;
    }
  });
  env.effect("sync-open", () => {
    open.value = cfg.open.value;
  });
  overlayControls(env, element, open);
  env.effect("reapply-visuals", () => {
    if (!open.value) return;
    element.hidden = false;
    stacker.reapplyState();
  }, { onUpdated: true });
  env.cleanup(() => stacker.remove(element));
  return {
    open: () => {
      if (open.value) return false;
      open.value = true;
      return true;
    },
    close: () => {
      if (!open.value) return false;
      open.value = false;
      return true;
    },
    toggle: () => {
      open.value = !open.value;
      return open.value;
    },
    get isOpen() {
      return open.value;
    }
  };
});

// js/components/utils/native-selection.js
function renderedSelection(options) {
  return new Map(options.map((option) => [option.value, option.hasAttribute("selected")]));
}
function reportsSelection(select, changeBinding) {
  if (!select) return false;
  return select.closest(`[${changeBinding}]`) !== null || select.form?.hasAttribute(changeBinding) === true;
}
function restoreClientSelection({ options, rendered, previousRendered, previousValues, multiple }) {
  const changed = (option) => previousRendered.get(option.value) !== rendered.get(option.value);
  const wanted = (option) => {
    if (changed(option) && rendered.get(option.value)) return true;
    if (changed(option) && previousRendered.has(option.value)) return false;
    return previousValues.has(option.value);
  };
  if (multiple) {
    for (const option of options) {
      const want = wanted(option);
      if (option.selected !== want) option.selected = want;
    }
    return;
  }
  const chosen = options.find((option) => changed(option) && rendered.get(option.value)) ?? options.find(wanted);
  for (const option of options) {
    const want = option === chosen;
    if (option.selected !== want) option.selected = want;
  }
}

// js/components/select/select.js
var TYPEAHEAD_TIMEOUT = 350;
var NavigationDirection = {
  NEXT: "next",
  PREV: "prev",
  FIRST: "first",
  LAST: "last"
};
var KeyboardActions = {
  TOGGLE_OR_SELECT: "toggleOrSelect",
  SELECT: "select",
  NAVIGATE_DOWN: "navigateDown",
  NAVIGATE_UP: "navigateUp",
  HOME: "home",
  END: "end",
  TYPEAHEAD: "typeahead",
  BACKSPACE: "backspace"
};
var hook6 = defineComponent("select", (element, env) => {
  const config = env.config(element, {
    searchable: { type: "boolean", default: false },
    multiple: { type: "boolean", default: false },
    maxSelections: { type: "number", default: Infinity },
    noResultsText: { type: "string", default: "No results found for %{query}." },
    clearable: { type: "boolean", default: false },
    onSearch: { type: "string", default: null },
    debounceMs: { type: "number", default: 300 },
    searchThreshold: { type: "number", default: 0 }
  });
  const open = env.signal(false, "open");
  const highlighted = env.signal(-1, "highlighted");
  const searchQuery = env.signal("", "searchQuery");
  const loading = env.signal(false, "loading");
  const parts = env.parts(element, {
    toggle: { selector: '[data-part="toggle"]', required: true },
    toggleLabel: { selector: '[data-part="toggle-label"]', required: false },
    searchInput: { selector: '[data-part="search-input"]', required: false },
    listbox: { selector: '[data-part="listbox"]', required: true },
    optionsList: { selector: '[data-part="options-list"]', required: true },
    clearButton: { selector: '[data-part="clear"]', required: false },
    emptyMessage: { selector: '[data-part="empty-message"]', required: true },
    loading: { selector: '[data-part="loading"]', required: true },
    select: { selector: '[data-part="select"]', required: true }
  });
  const formOptions = {
    getAll() {
      return Array.from(parts.select?.options || []).slice(1);
    },
    get(index) {
      return parts.select?.options[index + 1] ?? null;
    },
    getSelected() {
      return this.getAll().filter((opt) => opt.selected && opt.value !== "").map((opt) => ({ value: opt.value, label: opt.textContent }));
    },
    findSelectedIndex() {
      return this.getAll().findIndex((opt) => opt.selected);
    },
    hasSelection() {
      return this.getSelected().length > 0;
    },
    clearAll() {
      this.getAll().forEach((opt) => {
        opt.selected = false;
      });
    },
    selectSingle(index) {
      this.getAll().forEach((opt, i) => {
        opt.selected = i === index;
      });
    },
    toggle(index) {
      const opt = this.get(index);
      if (opt) opt.selected = !opt.selected;
    },
    selectedCount() {
      return this.getAll().filter((opt) => opt.selected).length;
    },
    // After a LiveView patch, morphdom updates `selected` attributes but doesn't always
    // sync the matching property. Reset properties from attributes so reads see the
    // server's intent.
    syncPropertiesFromAttributes() {
      this.getAll().forEach((opt) => {
        const attrSelected = opt.hasAttribute("selected");
        if (opt.selected !== attrSelected) opt.selected = attrSelected;
      });
    }
  };
  let lastRendered = null;
  const selectedValues = env.signal(null, {
    name: "selectedValues",
    from: () => {
      const options = formOptions.getAll();
      const rendered = renderedSelection(options);
      if (lastRendered && reportsSelection(parts.select, env.lv.binding("change"))) {
        formOptions.syncPropertiesFromAttributes();
      } else if (lastRendered) {
        restoreClientSelection({
          options,
          rendered,
          previousRendered: lastRendered,
          previousValues: new Set(env.untrack(() => selectedValues.value) ?? []),
          multiple: config.multiple.value
        });
      }
      lastRendered = rendered;
      return formOptions.getSelected().map((opt) => opt.value);
    },
    equals: arraysShallowEqual
  });
  const getOptionElements = () => Array.from(element.querySelectorAll('[data-part="option"]'));
  const getAllOptions = () => {
    const native = formOptions.getAll();
    return getOptionElements().map((el, i) => {
      const formOpt = native[i] ?? null;
      return {
        el,
        value: el.dataset.value || formOpt?.value || el.textContent?.trim(),
        label: el.textContent?.trim() || "",
        selected: formOpt?.selected || false,
        visible: !el.hidden,
        disabled: isDisabled(el),
        index: i
      };
    });
  };
  const getVisibleOptions = () => getAllOptions().filter((opt) => opt.visible && !opt.disabled);
  const ui = {
    setLoading(isLoading) {
      loading.value = isLoading;
      if (parts.loading) parts.loading.hidden = !isLoading;
      if (parts.optionsList) parts.optionsList.hidden = isLoading;
      if (isLoading && parts.emptyMessage) parts.emptyMessage.hidden = true;
    },
    showEmpty(query) {
      if (!parts.emptyMessage) return;
      parts.emptyMessage.hidden = false;
      parts.emptyMessage.textContent = this.formatMessage(query);
      if (parts.optionsList) parts.optionsList.hidden = true;
    },
    showError(message) {
      if (!parts.emptyMessage) return;
      parts.emptyMessage.hidden = false;
      parts.emptyMessage.textContent = message;
      if (parts.optionsList) parts.optionsList.hidden = true;
    },
    updateForSearch(hasResults, query) {
      const showEmpty = !hasResults && !loading.value && !!query;
      if (parts.emptyMessage) {
        parts.emptyMessage.hidden = !showEmpty;
        if (showEmpty) parts.emptyMessage.textContent = this.formatMessage(query);
      }
      if (parts.optionsList) parts.optionsList.hidden = !hasResults || loading.value;
    },
    formatMessage(query) {
      return config.noResultsText.value.replace("%{query}", query);
    },
    scrollToOption(index, options = {}) {
      if (typeof options === "boolean") options = { scroll: options };
      const { scroll = true, centered = false } = options;
      if (!scroll || index < 0) return;
      const option = getAllOptions()[index];
      if (option?.el) {
        option.el.scrollIntoView({ block: centered ? "center" : "nearest" });
      }
    }
  };
  const selection = {
    select(index) {
      if (index === -1) return;
      const option = getAllOptions()[index];
      if (option?.disabled) return;
      if (config.multiple.value) {
        this.handleMultiple(index);
      } else {
        this.handleSingle(index);
      }
      this.finalize(index);
    },
    handleMultiple(index) {
      const formOpt = formOptions.get(index);
      const currentCount = formOptions.selectedCount();
      if (currentCount >= config.maxSelections.value && !formOpt?.selected) return;
      formOptions.toggle(index);
      env.attrs(parts.toggle, { "data-focused": true });
    },
    handleSingle(index) {
      const formOpt = formOptions.get(index);
      const isSelected = formOpt?.selected;
      if (config.clearable.value && isSelected) {
        formOptions.clearAll();
      } else {
        formOptions.selectSingle(index);
      }
      open.value = false;
      parts.toggle.focus();
      env.attrs(parts.toggle, { "data-focused": true });
    },
    selectByValue(value) {
      const options = getAllOptions();
      const option = options.find((opt) => opt.value === value);
      if (!option || option.disabled) return false;
      const index = option.index;
      if (config.multiple.value) {
        const formOpt = formOptions.get(index);
        if (formOpt?.selected) return false;
        if (formOptions.selectedCount() >= config.maxSelections.value) return false;
        formOptions.toggle(index);
      } else {
        formOptions.selectSingle(index);
      }
      this.finalize(index);
      return true;
    },
    deselectByValue(value) {
      const index = getAllOptions().findIndex((opt) => opt.value === value);
      if (index === -1) return false;
      const formOpt = formOptions.get(index);
      if (!formOpt?.selected) return false;
      if (config.multiple.value) {
        formOptions.toggle(index);
        this.finalize(index);
      } else {
        if (!config.clearable.value) return false;
        formOptions.clearAll();
        this.finalize(-1);
      }
      return true;
    },
    clearAll() {
      if (!config.clearable.value) return false;
      if (!formOptions.hasSelection()) return false;
      this.clear();
      return true;
    },
    finalize(index) {
      const currentValues = formOptions.getSelected().map((opt) => opt.value);
      selectedValues.value = currentValues;
      env.emit("changed", {
        value: config.multiple.value ? currentValues : currentValues[0] || null,
        previousValue: config.multiple.value ? selectedValues.previous || [] : (selectedValues.previous || [])[0] || null
      });
      env.emitNative(parts.select, ["change"]);
      highlighted.value = index;
    },
    clear(e) {
      e?.preventDefault();
      const previousValues = selectedValues.value;
      formOptions.clearAll();
      selectedValues.value = [];
      env.emit("changed", {
        value: config.multiple.value ? [] : null,
        previousValue: config.multiple.value ? previousValues : previousValues[0] || null
      });
      env.emitNative(parts.select, ["change"]);
      parts.toggle.focus();
    }
  };
  const navigation = {
    typeahead: { search: "" },
    navigate(direction) {
      const visible = getVisibleOptions();
      if (!visible.length) return;
      const currentVisibleIdx = this.getCurrentVisibleIndex(visible);
      const newVisibleIdx = this.calculateNewIndex(currentVisibleIdx, visible.length, direction);
      const newOptionIndex = visible[newVisibleIdx]?.index ?? -1;
      this.highlight(newOptionIndex);
    },
    getCurrentVisibleIndex(visible) {
      if (highlighted.value === -1) return -1;
      return visible.findIndex((opt) => opt.index === highlighted.value);
    },
    calculateNewIndex(currentIdx, visibleCount, direction) {
      if (currentIdx === -1) {
        const isForward = direction === NavigationDirection.NEXT || direction === NavigationDirection.FIRST;
        return isForward ? 0 : visibleCount - 1;
      }
      switch (direction) {
        case NavigationDirection.NEXT:
          return Math.min(currentIdx + 1, visibleCount - 1);
        case NavigationDirection.PREV:
          return Math.max(currentIdx - 1, 0);
        case NavigationDirection.FIRST:
          return 0;
        case NavigationDirection.LAST:
          return visibleCount - 1;
      }
    },
    highlight(optionIndex) {
      highlighted.value = optionIndex;
      ui.scrollToOption(optionIndex);
    },
    // Only match visible options — fixes the hidden-option highlight bug.
    handleTypeahead(key) {
      this.typeahead.search += key.toLowerCase();
      env.timeout("typeahead-clear", () => {
        this.typeahead.search = "";
      }, TYPEAHEAD_TIMEOUT);
      const match = getVisibleOptions().find(
        (opt) => opt.label.toLowerCase().startsWith(this.typeahead.search)
      );
      if (!match) return;
      if (open.value) {
        highlighted.value = match.index;
        ui.scrollToOption(match.index);
      } else {
        formOptions.selectSingle(match.index);
        selection.finalize(match.index);
      }
    }
  };
  const serverResults = {
    sent: 0,
    error: false,
    highlightPending: false,
    sync() {
      if (!config.onSearch.value || loading.value || this.error) return;
      const query = searchQuery.value;
      const options = getAllOptions();
      if (options.length === 0 && query) {
        ui.showEmpty(query);
      } else {
        if (parts.emptyMessage) parts.emptyMessage.hidden = true;
        if (parts.optionsList) parts.optionsList.hidden = false;
      }
      if (this.highlightPending && query && highlighted.value === -1) {
        const lower = query.toLowerCase();
        const match = options.find((o) => !o.disabled && o.label.toLowerCase().includes(lower));
        if (match) {
          highlighted.value = match.index;
          this.highlightPending = false;
        }
      }
    }
  };
  const search = {
    handleInput(value) {
      env.timeout.cancel("search");
      if (config.onSearch.value) {
        this.handleServerInput(value);
      } else {
        this.handleClientInput(value);
      }
    },
    handleClientInput(value) {
      if (value === "") {
        searchQuery.value = "";
        ui.setLoading(false);
        return;
      }
      if (value.length > 0 && value.length < config.searchThreshold.value) {
        searchQuery.value = "";
        return;
      }
      searchQuery.value = value;
    },
    handleServerInput(value) {
      highlighted.value = -1;
      serverResults.error = false;
      serverResults.highlightPending = value !== "";
      if (value === "") {
        searchQuery.value = "";
        ui.setLoading(true);
        env.timeout("search", () => this.triggerServer(""), config.debounceMs.value);
        return;
      }
      if (value.length > 0 && value.length < config.searchThreshold.value) {
        ui.setLoading(false);
        return;
      }
      searchQuery.value = value;
      ui.setLoading(true);
      env.timeout("search", () => this.triggerServer(value), config.debounceMs.value);
    },
    triggerServer(query) {
      const seq = ++serverResults.sent;
      env.emit("search", {
        query,
        id: parts.select?.id || element.id,
        callback: config.onSearch.value,
        onComplete: () => this.handleServerSuccess(seq),
        onError: () => this.handleServerError(seq)
      });
    },
    // A reply for an older search must not end the loading state of a newer one.
    handleServerSuccess(seq) {
      if (seq !== serverResults.sent) return;
      ui.setLoading(false);
      overlayApi.reposition();
      serverResults.sync();
    },
    handleServerError(seq) {
      if (seq !== serverResults.sent) return;
      serverResults.error = true;
      ui.setLoading(false);
      ui.showError("Error occurred while searching. Please try again.");
    },
    filterClient(query) {
      const lowerQuery = query.toLowerCase();
      let hasVisibleOptions = false;
      let firstVisibleIndex = -1;
      getAllOptions().forEach((opt) => {
        const matches = !lowerQuery || opt.label.toLowerCase().includes(lowerQuery);
        if (opt.el.hidden !== !matches) opt.el.hidden = !matches;
        if (matches && !opt.disabled) {
          hasVisibleOptions = true;
          if (firstVisibleIndex === -1) firstVisibleIndex = opt.index;
        }
      });
      ui.updateForSearch(hasVisibleOptions, query);
      if (query) highlighted.value = firstVisibleIndex;
    }
  };
  const keyboard = {
    getAction(key, ctrlKey, metaKey) {
      const isTypeaheadKey = key.length === 1 && !ctrlKey && !metaKey;
      const keyMap = {
        Enter: KeyboardActions.SELECT,
        " ": KeyboardActions.TOGGLE_OR_SELECT,
        ArrowDown: KeyboardActions.NAVIGATE_DOWN,
        ArrowUp: KeyboardActions.NAVIGATE_UP,
        Home: KeyboardActions.HOME,
        End: KeyboardActions.END,
        Backspace: KeyboardActions.BACKSPACE
      };
      return keyMap[key] || (isTypeaheadKey ? KeyboardActions.TYPEAHEAD : null);
    },
    handleAction(action, key) {
      const handlers = {
        [KeyboardActions.TOGGLE_OR_SELECT]: () => this.handleToggleOrSelect(),
        [KeyboardActions.SELECT]: () => this.handleSelect(),
        [KeyboardActions.NAVIGATE_DOWN]: () => this.handleNavigation(true),
        [KeyboardActions.NAVIGATE_UP]: () => this.handleNavigation(false),
        [KeyboardActions.HOME]: () => this.handleBoundary(NavigationDirection.FIRST),
        [KeyboardActions.END]: () => this.handleBoundary(NavigationDirection.LAST),
        [KeyboardActions.TYPEAHEAD]: () => navigation.handleTypeahead(key),
        [KeyboardActions.BACKSPACE]: () => this.handleBackspace()
      };
      handlers[action]?.();
    },
    handleToggleOrSelect() {
      if (!open.value) {
        open.value = true;
      } else if (highlighted.value !== -1) {
        selection.select(highlighted.value);
      }
    },
    handleSelect() {
      if (open.value && highlighted.value !== -1) {
        selection.select(highlighted.value);
      }
    },
    handleNavigation(isDown) {
      if (!open.value) {
        this.openAndHighlightInitial(isDown);
      } else {
        navigation.navigate(isDown ? NavigationDirection.NEXT : NavigationDirection.PREV);
      }
    },
    openAndHighlightInitial(isDown) {
      open.value = true;
      const selectedIdx = formOptions.findSelectedIndex();
      const selectedOption = selectedIdx >= 0 ? getAllOptions()[selectedIdx] : null;
      if (selectedOption && !selectedOption.disabled) {
        highlighted.value = selectedIdx;
      } else {
        const visible = getVisibleOptions();
        const fallback = isDown ? visible[0] : visible[visible.length - 1];
        highlighted.value = fallback?.index ?? -1;
      }
      ui.scrollToOption(highlighted.value);
    },
    handleBoundary(direction) {
      if (open.value) navigation.navigate(direction);
    },
    handleBackspace() {
      if (config.clearable.value && formOptions.hasSelection()) {
        selection.clear();
      }
    }
  };
  const getAnimationDuration = () => parseFloat(parts.listbox.dataset.animationDuration || 0.1);
  const getAnimationEasing = () => parts.listbox.dataset.animationEasing || "ease-out";
  overlayControls(env, element, open);
  const panel = panelMiddleware();
  const overlayApi = overlay(env, {
    anchor: () => parts.toggle,
    panel: () => parts.listbox,
    open,
    placement: "bottom-start",
    strategy: "fixed",
    middleware: panel.middleware,
    closeOnOutsideClick: true,
    refocusOnEscape: () => parts.toggle,
    duration: getAnimationDuration(),
    easing: getAnimationEasing(),
    onBeforeOpen: () => {
      panel.invalidateCap();
      env.attrs(parts.toggle, { "data-focused": true });
    },
    onShow: () => {
      const selectedIdx = formOptions.findSelectedIndex();
      if (selectedIdx !== -1) ui.scrollToOption(selectedIdx, { centered: true });
    },
    onOpen: () => {
      env.emit("opened");
      if (config.searchable.value && parts.searchInput) {
        parts.searchInput.focus();
      }
    },
    onBeforeClose: () => {
      if (document.activeElement !== parts.toggle) {
        env.attrs(parts.toggle, { "data-focused": false });
      }
    },
    onClose: () => {
      highlighted.value = -1;
      env.emit("closed");
    }
  });
  env.on(element, "fluxon:select:search", (event) => {
    env.lv.pushEventTo(
      element,
      event.detail.callback,
      { query: event.detail.query, id: event.detail.id },
      (reply) => {
        if (reply && reply.error) event.detail.onError?.();
        else event.detail.onComplete?.();
      }
    );
  });
  env.effect("aria-expanded", () => {
    env.attrs(parts.toggle, { "aria-expanded": String(open.value) });
    env.attrs(element, { "data-expanded": open.value });
  }, { onUpdated: true });
  env.effect("aria-activedescendant", () => {
    const highlightedOption = highlighted.value === -1 ? null : getAllOptions().find((opt) => opt.index === highlighted.value);
    const id = highlightedOption?.el?.id || null;
    const searchInput = config.searchable.value ? parts.searchInput : null;
    env.attrs(parts.toggle, { "aria-activedescendant": searchInput ? null : id });
    if (searchInput) env.attrs(searchInput, { "aria-activedescendant": id });
  }, { onUpdated: true });
  env.effect("option-selection", () => {
    const selected = new Set(selectedValues.value);
    getAllOptions().forEach((opt) => {
      const isSelected = selected.has(opt.value);
      env.attrs(opt.el, {
        "aria-selected": String(isSelected),
        "data-selected": isSelected
      });
    });
  }, { onUpdated: true });
  env.effect("option-highlight", () => {
    getOptionElements().forEach((el, index) => {
      env.attrs(el, { "data-highlighted": index === highlighted.value });
    });
  }, { onUpdated: true });
  env.effect("server-results", () => {
    env.untrack(() => serverResults.sync());
  }, { onUpdated: true });
  env.effect("auto-highlight", () => {
    if (!open.value || !parts.select) return;
    if (highlighted.value === -1) return;
    const options = getAllOptions();
    const currentHighlight = options.find((opt) => opt.index === highlighted.value);
    if (currentHighlight && !currentHighlight.el.hidden && !currentHighlight.disabled) return;
    const idx = formOptions.findSelectedIndex();
    if (idx !== -1) {
      const opt = options[idx];
      if (opt && !opt.disabled) {
        highlighted.value = idx;
      } else {
        const visible = getVisibleOptions();
        highlighted.value = visible[0]?.index ?? -1;
      }
    }
  }, { onUpdated: true });
  env.effect("toggle-label", () => {
    if (!parts.toggleLabel) return;
    const values = selectedValues.value;
    const span = parts.toggleLabel.firstElementChild;
    if (!span || span.tagName !== "SPAN" || span.hasAttribute("data-part")) return;
    const labels = values.map((v) => {
      const opt = formOptions.getAll().find((o) => o.value === v);
      return opt?.textContent || v;
    });
    span.textContent = labels.join(", ");
  }, { onUpdated: true });
  env.effect("toggle-label-items", () => {
    const selected = new Set(selectedValues.value);
    parts.toggleLabel?.querySelectorAll('[data-part="toggle-label-item"]').forEach((el) => {
      env.attrs(el, { "data-selected": selected.has(el.dataset.value) });
    });
  }, { onUpdated: true });
  env.effect("search-filter", () => {
    const query = searchQuery.value;
    if (!config.searchable.value) return;
    if (config.onSearch.value) return;
    if (getAllOptions().length === 0) return;
    search.filterClient(query);
  }, { onUpdated: true });
  env.effect("search-input-sync", () => {
    if (parts.searchInput) parts.searchInput.value = searchQuery.value;
  });
  env.effect("loading-indicator", () => {
    if (!parts.loading) return;
    parts.loading.hidden = !loading.value;
    env.attrs(parts.loading, { role: "status", "aria-live": "polite" });
  });
  env.effect("clear-button", () => {
    if (!config.clearable.value || !parts.clearButton) return;
    if (!parts.clearButton.hasAttribute("role")) {
      env.attrs(parts.clearButton, {
        role: "button",
        "aria-label": "Clear selection",
        tabindex: "0"
      });
    }
    parts.clearButton.hidden = selectedValues.value.length === 0;
  }, { onUpdated: true });
  env.effect("focusout-dismiss", () => {
    if (!open.value) return;
    env.on(element, "focusout", (e) => {
      if (!e.relatedTarget || !element.contains(e.relatedTarget)) {
        env.timeout.raf("focusout-check", () => {
          if (!element.contains(document.activeElement) && open.value) {
            open.value = false;
          }
        });
      }
    });
  });
  env.attrs(parts.toggle, { tabindex: "0" });
  const isComponentDisabled = () => parts.select?.disabled || isDisabled(parts.toggle);
  focusFieldOnInvalid(env, {
    control: () => parts.select,
    field: () => parts.toggle
  });
  env.on(parts.toggle, "click", (e) => {
    if (isComponentDisabled()) return;
    if (e.target.closest('[data-part="clear"]')) return;
    open.value = !open.value;
  });
  env.on(parts.toggle, "focus", () => {
    env.attrs(parts.toggle, { "data-focused": true });
  });
  env.on(parts.toggle, "blur", (e) => {
    if (!e.relatedTarget || !element.contains(e.relatedTarget)) {
      env.attrs(parts.toggle, { "data-focused": false });
    }
  });
  env.on(parts.toggle, "keydown", (e) => {
    if (isComponentDisabled()) return;
    const action = keyboard.getAction(e.key, e.ctrlKey, e.metaKey);
    if (action) {
      e.preventDefault();
      keyboard.handleAction(action, e.key);
    }
  });
  env.on(parts.listbox, "click", (e, target) => {
    if (!open.value) return;
    e.preventDefault();
    e.stopPropagation();
    const idx = getAllOptions().findIndex((opt) => opt.el === target);
    if (idx !== -1) selection.select(idx);
  }, { delegate: '[data-part="option"]' });
  env.on(parts.listbox, "mouseover", (e) => {
    if (!open.value) return;
    const optionEl = e.target.closest('[data-part="option"]');
    if (optionEl?.hidden) return;
    const index = optionEl && !isDisabled(optionEl) ? getOptionElements().indexOf(optionEl) : -1;
    if (index !== -1) {
      highlighted.value = index;
      ui.scrollToOption(index, false);
    } else {
      highlighted.value = -1;
    }
  });
  env.on(parts.listbox, "mouseleave", () => {
    if (!open.value) return;
    highlighted.value = -1;
  });
  env.effect("clear-button-events", () => {
    if (!config.clearable.value || !parts.clearButton) return;
    env.on(parts.toggle, "mousedown", (e) => {
      e.preventDefault();
      e.stopPropagation();
    }, { delegate: '[data-part="clear"]', capture: true });
    env.on(parts.toggle, "click", (e) => {
      selection.clear(e);
    }, { delegate: '[data-part="clear"]', capture: true });
    env.on(parts.toggle, "keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        selection.clear(e);
      }
    }, { delegate: '[data-part="clear"]' });
  }, { onUpdated: true });
  env.effect("search-input-events", () => {
    if (!config.searchable.value || !parts.searchInput) return;
    env.on(parts.searchInput, "input", (e) => {
      e.stopPropagation();
      search.handleInput(e.target.value.trim());
    });
    env.on(parts.searchInput, "change", (e) => e.stopPropagation());
    env.on(parts.searchInput, "keydown", (e) => {
      if (isImeComposing(e)) return;
      const action = keyboard.getAction(e.key, e.ctrlKey, e.metaKey);
      if (["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) {
        e.preventDefault();
        keyboard.handleAction(action, e.key);
      }
    });
  });
  return {
    get value() {
      const values = formOptions.getSelected().map((opt) => opt.value);
      return config.multiple.value ? values : values[0] || null;
    },
    select(value) {
      if (isComponentDisabled()) return false;
      return selection.selectByValue(value);
    },
    deselect(value) {
      if (isComponentDisabled()) return false;
      return selection.deselectByValue(value);
    },
    clear() {
      if (isComponentDisabled()) return false;
      return selection.clearAll();
    },
    get isOpen() {
      return open.value;
    },
    open() {
      if (isComponentDisabled()) return false;
      if (open.value) return false;
      open.value = true;
      return true;
    },
    close() {
      if (!open.value) return false;
      open.value = false;
      return true;
    },
    toggle() {
      if (isComponentDisabled()) return open.value;
      open.value = !open.value;
      return open.value;
    }
  };
});

// js/components/tags_input/tags_input.js
var TYPEAHEAD_TIMEOUT2 = 350;
var NavigationDirection2 = {
  NEXT: "next",
  PREV: "prev",
  FIRST: "first",
  LAST: "last"
};
var KeyboardActions2 = {
  SELECT: "select",
  TOGGLE_OR_SELECT: "toggleOrSelect",
  NAVIGATE_DOWN: "navigateDown",
  NAVIGATE_UP: "navigateUp",
  HOME: "home",
  END: "end",
  TYPEAHEAD: "typeahead",
  BACKSPACE: "backspace"
};
var hook7 = defineComponent("tagsinput", (element, env) => {
  const config = env.config(element, {
    typeable: { type: "boolean", default: false },
    searchable: { type: "boolean", default: false },
    creatable: { type: "boolean", default: false },
    clearable: { type: "boolean", default: false },
    maxSelections: { type: "number", default: Infinity },
    minSelections: { type: "number", default: 0 },
    searchNoResultsText: { type: "string", default: "No results found for %{query}." },
    onSearch: { type: "string", default: null },
    debounceMs: { type: "number", default: 300 },
    searchThreshold: { type: "number", default: 0 }
  });
  const open = env.signal(false, "open");
  const highlighted = env.signal(-1, "highlighted");
  const searchQuery = env.signal("", "searchQuery");
  const loading = env.signal(false, "loading");
  const focusedTagIndex = env.signal(-1, "focusedTagIndex");
  const highlightedTagIndex = env.signal(-1, "highlightedTagIndex");
  const parts = env.parts(element, {
    toggle: { selector: '[data-part="toggle"]', required: true },
    tagsArea: { selector: '[data-part="tags-area"]', required: true },
    tagTemplate: { selector: '[data-part="tag-template"]', required: true },
    tagLabelSources: { selector: '[data-part="tag-label-sources"]', required: false },
    input: { selector: '[data-part="input"]', required: false },
    searchInput: { selector: '[data-part="search-input"]', required: false },
    listbox: { selector: '[data-part="listbox"]', required: true },
    optionsList: { selector: '[data-part="options-list"]', required: true },
    clearButton: { selector: '[data-part="clear"]', required: false },
    emptyMessage: { selector: '[data-part="empty-message"]', required: true },
    loading: { selector: '[data-part="loading"]', required: true },
    select: { selector: '[data-part="select"]', required: true }
  });
  const comboboxEl = () => config.typeable.value && parts.input ? parts.input : parts.toggle;
  const formOptions = {
    getAll() {
      return Array.from(parts.select?.options || []).slice(1);
    },
    get(index) {
      return parts.select?.options[index + 1] ?? null;
    },
    getSelected() {
      return this.getAll().filter((opt) => opt.selected && opt.value !== "").map((opt) => ({ value: opt.value, label: opt.textContent }));
    },
    findByValue(value) {
      return this.getAll().find((opt) => opt.value === value);
    },
    hasSelection() {
      return this.getSelected().length > 0;
    },
    clearAll() {
      this.getAll().forEach((opt) => {
        opt.selected = false;
      });
    },
    toggle(index) {
      const opt = this.get(index);
      if (opt) opt.selected = !opt.selected;
    },
    selectByValue(value) {
      const opt = this.findByValue(value);
      if (opt) opt.selected = true;
    },
    deselectByValue(value) {
      const opt = this.findByValue(value);
      if (opt) opt.selected = false;
    },
    selectedCount() {
      return this.getAll().filter((opt) => opt.selected).length;
    }
  };
  let lastRendered = null;
  const selectedValues = env.signal(null, {
    name: "selectedValues",
    from: () => {
      const options = formOptions.getAll();
      const rendered = renderedSelection(options);
      if (lastRendered && !reportsSelection(parts.select, env.lv.binding("change"))) {
        restoreClientSelection({
          options,
          rendered,
          previousRendered: lastRendered,
          previousValues: new Set(env.untrack(() => selectedValues.value) ?? []),
          multiple: true
        });
      }
      lastRendered = rendered;
      return formOptions.getSelected().map((opt) => opt.value);
    },
    equals: arraysShallowEqual
  });
  const getOptionElements = () => Array.from(element.querySelectorAll('[data-part="option"]'));
  const getAllOptions = () => {
    const native = formOptions.getAll();
    return getOptionElements().map((el, i) => {
      const formOpt = native[i] ?? null;
      return {
        el,
        value: el.dataset.value || formOpt?.value || el.textContent?.trim(),
        label: el.dataset.label || el.textContent?.trim() || "",
        selected: formOpt?.selected || false,
        visible: !el.hidden,
        disabled: isDisabled(el),
        index: i
      };
    });
  };
  const getVisibleOptions = () => getAllOptions().filter((opt) => opt.visible && !opt.disabled);
  const ui = {
    scrollToOption(index, { centered = false } = {}) {
      if (index < 0) return;
      const opt = getAllOptions()[index];
      opt?.el?.scrollIntoView({ block: centered ? "center" : "nearest" });
    },
    setLoading(isLoading) {
      loading.value = isLoading;
      if (parts.loading) parts.loading.hidden = !isLoading;
      if (parts.optionsList) parts.optionsList.hidden = isLoading;
      if (isLoading && parts.emptyMessage) parts.emptyMessage.hidden = true;
    },
    showEmpty(query) {
      if (!parts.emptyMessage) return;
      parts.emptyMessage.hidden = false;
      parts.emptyMessage.textContent = this.formatMessage(query);
      if (parts.optionsList) parts.optionsList.hidden = true;
    },
    showError(message) {
      if (!parts.emptyMessage) return;
      parts.emptyMessage.hidden = false;
      parts.emptyMessage.textContent = message;
      if (parts.optionsList) parts.optionsList.hidden = true;
    },
    updateForSearch(hasResults, query) {
      const showEmpty = !hasResults && !loading.value && !!query;
      if (parts.emptyMessage) {
        parts.emptyMessage.hidden = !showEmpty;
        if (showEmpty) parts.emptyMessage.textContent = this.formatMessage(query);
      }
      if (parts.optionsList) {
        parts.optionsList.hidden = !hasResults || loading.value;
      }
    },
    formatMessage(query) {
      return config.searchNoResultsText.value.replace("%{query}", query);
    }
  };
  const serverResults = {
    sent: 0,
    error: false,
    highlightPending: false,
    sync() {
      if (!config.onSearch.value || loading.value || this.error) return;
      const query = searchQuery.value;
      const options = getAllOptions();
      if (options.length === 0 && query) {
        ui.showEmpty(query);
      } else {
        if (parts.emptyMessage) parts.emptyMessage.hidden = true;
        if (parts.optionsList) parts.optionsList.hidden = false;
      }
      if (this.highlightPending && query && highlighted.value === -1) {
        const lower = query.toLowerCase();
        const match = options.find((o) => !o.disabled && o.label.toLowerCase().includes(lower));
        if (match) {
          highlighted.value = match.index;
          this.highlightPending = false;
        }
      }
    }
  };
  const search = {
    handleInput(value) {
      env.timeout.cancel("search");
      highlighted.value = -1;
      if (config.onSearch.value) this.handleServerInput(value);
      else this.handleClientInput(value);
    },
    handleClientInput(value) {
      if (value === "") {
        searchQuery.value = "";
        ui.setLoading(false);
        return;
      }
      if (value.length > 0 && value.length < config.searchThreshold.value) {
        searchQuery.value = "";
        return;
      }
      searchQuery.value = value;
    },
    handleServerInput(value) {
      serverResults.error = false;
      serverResults.highlightPending = value !== "";
      if (value === "") {
        searchQuery.value = "";
        ui.setLoading(true);
        env.timeout("search", () => this.triggerServer(""), config.debounceMs.value);
        return;
      }
      if (value.length > 0 && value.length < config.searchThreshold.value) {
        ui.setLoading(false);
        return;
      }
      searchQuery.value = value;
      ui.setLoading(true);
      env.timeout("search", () => this.triggerServer(value), config.debounceMs.value);
    },
    triggerServer(query) {
      const seq = ++serverResults.sent;
      env.emit("search", {
        query,
        id: parts.select?.id || element.id,
        callback: config.onSearch.value,
        onComplete: () => this.handleServerSuccess(seq),
        onError: () => this.handleServerError(seq)
      });
    },
    // A reply for an older search must not end the loading state of a newer one.
    handleServerSuccess(seq) {
      if (seq !== serverResults.sent) return;
      ui.setLoading(false);
      overlayApi.reposition();
      serverResults.sync();
    },
    handleServerError(seq) {
      if (seq !== serverResults.sent) return;
      serverResults.error = true;
      ui.setLoading(false);
      ui.showError("Error occurred while searching. Please try again.");
    },
    filterClient(query) {
      const lowerQuery = query.toLowerCase();
      let hasVisibleOptions = false;
      let firstVisibleIndex = -1;
      getAllOptions().forEach((opt) => {
        const matches = !lowerQuery || opt.label.toLowerCase().includes(lowerQuery);
        if (opt.el.hidden !== !matches) opt.el.hidden = !matches;
        if (matches && !opt.disabled) {
          hasVisibleOptions = true;
          if (firstVisibleIndex === -1) firstVisibleIndex = opt.index;
        }
      });
      ui.updateForSearch(hasVisibleOptions, query);
      if (query) highlighted.value = firstVisibleIndex;
    }
  };
  function cloneTagFromTemplate({ value, label }) {
    const tpl = parts.tagTemplate;
    if (!tpl) return null;
    const fragment = tpl.content.cloneNode(true);
    const pill = fragment.querySelector('[data-part="tag"]');
    if (!pill) return null;
    pill.setAttribute("data-value", value);
    pill.setAttribute("data-label", label);
    const labelEl = pill.querySelector('[data-part="tag-label"]');
    if (labelEl) labelEl.textContent = label;
    const removeEl = pill.querySelector('[data-part="tag-remove"]');
    if (removeEl) removeEl.setAttribute("aria-label", `Remove ${label}`);
    return pill;
  }
  const renderedLabelSource = /* @__PURE__ */ new WeakMap();
  function cloneLabelSource(source) {
    const fragment = document.createDocumentFragment();
    source.childNodes.forEach((node) => fragment.appendChild(node.cloneNode(true)));
    fragment.querySelectorAll("[data-phx-id]").forEach((el) => el.removeAttribute("data-phx-id"));
    return fragment;
  }
  function syncTagLabel(tag) {
    const value = tag.dataset.value;
    const label = formOptions.findByValue(value)?.textContent.trim() || tag.dataset.label || value;
    const labelEl = tag.querySelector('[data-part="tag-label"]');
    const source = parts.tagLabelSources?.querySelector(
      `[data-part="tag-label-source"][data-value="${CSS.escape(value)}"]`
    );
    if (labelEl && source) {
      if (renderedLabelSource.get(labelEl) !== source.innerHTML) {
        labelEl.replaceChildren(cloneLabelSource(source));
        renderedLabelSource.set(labelEl, source.innerHTML);
      }
    } else if (labelEl && labelEl.textContent.trim() !== label) {
      labelEl.textContent = label;
    }
    env.attrs(tag, { "data-label": label });
    const removeEl = tag.querySelector('[data-part="tag-remove"]');
    if (removeEl) env.attrs(removeEl, { "aria-label": `Remove ${label}` });
  }
  function reconcileTags() {
    if (!parts.tagsArea) return;
    const desired = formOptions.getSelected();
    const desiredValues = new Set(desired.map((o) => o.value));
    const existing = Array.from(
      parts.tagsArea.querySelectorAll('[data-part="tag"]')
    );
    for (const tag of existing) {
      if (!desiredValues.has(tag.dataset.value)) tag.remove();
    }
    const existingValues = new Set(
      Array.from(parts.tagsArea.querySelectorAll('[data-part="tag"]')).map(
        (p) => p.dataset.value
      )
    );
    for (const opt of desired) {
      if (existingValues.has(opt.value)) continue;
      const tag = cloneTagFromTemplate(opt);
      if (!tag) continue;
      if (parts.input && parts.input.parentNode === parts.tagsArea) {
        parts.tagsArea.insertBefore(tag, parts.input);
      } else {
        parts.tagsArea.appendChild(tag);
      }
    }
    parts.tagsArea.querySelectorAll('[data-part="tag"]').forEach(syncTagLabel);
    applyMinRemoveGuard();
  }
  function applyMinRemoveGuard() {
    if (!parts.tagsArea) return;
    const count = formOptions.selectedCount();
    const atMin = count <= config.minSelections.value;
    parts.tagsArea.querySelectorAll('[data-part="tag-remove"]').forEach((btn) => {
      env.attrs(btn, {
        "data-disabled": atMin,
        "aria-disabled": String(atMin)
      });
    });
  }
  const selection = {
    select(index) {
      if (index === -1) return;
      const option = getAllOptions()[index];
      if (!option || option.disabled) return;
      const formOpt = formOptions.get(index);
      const isCurrentlySelected = formOpt?.selected;
      if (!isCurrentlySelected && formOptions.selectedCount() >= config.maxSelections.value) return;
      if (isCurrentlySelected && formOptions.selectedCount() <= config.minSelections.value) return;
      formOptions.toggle(index);
      env.attrs(parts.toggle, { "data-focused": true });
      this.finalize(index);
      if (config.typeable.value && parts.input) {
        parts.input.value = "";
        searchQuery.value = "";
        parts.input.focus();
      }
    },
    selectByValue(value) {
      const option = getAllOptions().find((o) => o.value === value);
      if (!option || option.disabled) return false;
      const formOpt = formOptions.get(option.index);
      if (formOpt?.selected) return false;
      if (formOptions.selectedCount() >= config.maxSelections.value) return false;
      formOptions.toggle(option.index);
      this.finalize(option.index);
      return true;
    },
    deselectByValue(value) {
      const option = getAllOptions().find((o) => o.value === value);
      if (!option) return false;
      const formOpt = formOptions.get(option.index);
      if (!formOpt?.selected) return false;
      if (formOptions.selectedCount() <= config.minSelections.value) return false;
      formOptions.toggle(option.index);
      this.finalize(option.index);
      return true;
    },
    removeByValue(value) {
      if (formOptions.selectedCount() <= config.minSelections.value) return false;
      const formOpt = formOptions.findByValue(value);
      if (!formOpt?.selected) return false;
      formOpt.selected = false;
      this.finalize(-1);
      return true;
    },
    // Creatable: commit a free-form typed value as a new tag. Appends a new
    // <option value={text} selected>{text}</option> to the hidden <select>; the server
    // form submission delivers it like any other tag and can slugify or reject.
    createTag(text) {
      const trimmed = text.trim();
      if (trimmed === "") return false;
      if (formOptions.selectedCount() >= config.maxSelections.value) return false;
      const lower = trimmed.toLowerCase();
      const selected = formOptions.getSelected();
      if (selected.some(
        (o) => o.label.toLowerCase() === lower || o.value.toLowerCase() === lower
      )) {
        return false;
      }
      const existing = formOptions.getAll().find(
        (o) => o.textContent.trim().toLowerCase() === lower || o.value.toLowerCase() === lower
      );
      if (existing) {
        if (!existing.selected) {
          existing.selected = true;
          this.finalize(-1);
        }
        if (parts.input) {
          parts.input.value = "";
          searchQuery.value = "";
        }
        return true;
      }
      const opt = document.createElement("option");
      opt.value = trimmed;
      opt.textContent = trimmed;
      opt.selected = true;
      parts.select.appendChild(opt);
      this.finalize(-1);
      if (parts.input) {
        parts.input.value = "";
        searchQuery.value = "";
      }
      return true;
    },
    clearAll() {
      if (!config.clearable.value) return false;
      if (!formOptions.hasSelection()) return false;
      if (config.minSelections.value > 0) return false;
      this.clear();
      return true;
    },
    clear(e) {
      e?.preventDefault();
      const previousValues = selectedValues.value;
      formOptions.clearAll();
      selectedValues.value = [];
      env.emit("changed", { value: [], previousValue: previousValues });
      env.emitNative(parts.select, ["change"]);
      const focusEl = config.typeable.value && parts.input ? parts.input : parts.toggle;
      focusEl.focus();
    },
    finalize(index) {
      const currentValues = formOptions.getSelected().map((opt) => opt.value);
      const previousValues = selectedValues.value;
      selectedValues.value = currentValues;
      env.emit("changed", {
        value: currentValues,
        previousValue: previousValues
      });
      env.emitNative(parts.select, ["change"]);
      highlighted.value = index;
    }
  };
  const navigation = {
    typeahead: { search: "" },
    navigate(direction) {
      const visible = getVisibleOptions();
      if (!visible.length) return;
      const currentVisibleIdx = this.getCurrentVisibleIndex(visible);
      const newVisibleIdx = this.calculateNewIndex(currentVisibleIdx, visible.length, direction);
      const newOptionIndex = visible[newVisibleIdx]?.index ?? -1;
      this.highlight(newOptionIndex);
    },
    getCurrentVisibleIndex(visible) {
      if (highlighted.value === -1) return -1;
      return visible.findIndex((opt) => opt.index === highlighted.value);
    },
    calculateNewIndex(currentIdx, visibleCount, direction) {
      if (currentIdx === -1) {
        const isForward = direction === NavigationDirection2.NEXT || direction === NavigationDirection2.FIRST;
        return isForward ? 0 : visibleCount - 1;
      }
      switch (direction) {
        case NavigationDirection2.NEXT:
          return Math.min(currentIdx + 1, visibleCount - 1);
        case NavigationDirection2.PREV:
          return Math.max(currentIdx - 1, 0);
        case NavigationDirection2.FIRST:
          return 0;
        case NavigationDirection2.LAST:
          return visibleCount - 1;
      }
    },
    highlight(optionIndex) {
      highlighted.value = optionIndex;
      ui.scrollToOption(optionIndex);
    },
    handleTypeahead(key) {
      this.typeahead.search += key.toLowerCase();
      env.timeout(
        "typeahead-clear",
        () => {
          this.typeahead.search = "";
        },
        TYPEAHEAD_TIMEOUT2
      );
      const match = getVisibleOptions().find(
        (opt) => opt.label.toLowerCase().startsWith(this.typeahead.search)
      );
      if (!match) return;
      if (open.value) {
        highlighted.value = match.index;
        ui.scrollToOption(match.index);
      }
    }
  };
  const keyboard = {
    getAction(key, ctrlKey, metaKey) {
      const isTypeaheadKey = key.length === 1 && !ctrlKey && !metaKey;
      const keyMap = {
        Enter: KeyboardActions2.SELECT,
        " ": KeyboardActions2.TOGGLE_OR_SELECT,
        ArrowDown: KeyboardActions2.NAVIGATE_DOWN,
        ArrowUp: KeyboardActions2.NAVIGATE_UP,
        Home: KeyboardActions2.HOME,
        End: KeyboardActions2.END,
        Backspace: KeyboardActions2.BACKSPACE
      };
      return keyMap[key] || (isTypeaheadKey ? KeyboardActions2.TYPEAHEAD : null);
    },
    handleAction(action, key) {
      const handlers = {
        [KeyboardActions2.SELECT]: () => this.handleSelect(),
        [KeyboardActions2.TOGGLE_OR_SELECT]: () => this.handleToggleOrSelect(),
        [KeyboardActions2.NAVIGATE_DOWN]: () => this.handleNavigation(true),
        [KeyboardActions2.NAVIGATE_UP]: () => this.handleNavigation(false),
        [KeyboardActions2.HOME]: () => this.handleBoundary(NavigationDirection2.FIRST),
        [KeyboardActions2.END]: () => this.handleBoundary(NavigationDirection2.LAST),
        [KeyboardActions2.TYPEAHEAD]: () => navigation.handleTypeahead(key),
        [KeyboardActions2.BACKSPACE]: () => this.handleBackspace()
      };
      handlers[action]?.();
    },
    handleSelect() {
      if (open.value && highlighted.value !== -1) {
        selection.select(highlighted.value);
      }
    },
    handleToggleOrSelect() {
      if (!open.value) {
        open.value = true;
      } else if (highlighted.value !== -1) {
        selection.select(highlighted.value);
      }
    },
    handleNavigation(isDown) {
      if (!open.value) {
        this.openAndHighlightInitial(isDown);
      } else {
        navigation.navigate(isDown ? NavigationDirection2.NEXT : NavigationDirection2.PREV);
      }
    },
    openAndHighlightInitial(isDown) {
      open.value = true;
      const visible = getVisibleOptions();
      const target = isDown ? visible[0] : visible[visible.length - 1];
      highlighted.value = target?.index ?? -1;
      ui.scrollToOption(highlighted.value);
    },
    handleBoundary(direction) {
      if (open.value) navigation.navigate(direction);
    },
    handleBackspace() {
      const selected = formOptions.getSelected();
      if (!selected.length) return;
      const last = selected[selected.length - 1];
      const removed = selection.removeByValue(last.value);
      if (!removed) return;
      const remaining = formOptions.getSelected();
      if (remaining.length === 0) {
        highlightedTagIndex.value = -1;
        return;
      }
      const newLast = remaining[remaining.length - 1];
      highlightedTagIndex.value = remaining.length - 1;
      const optionIdx = getAllOptions().findIndex((o) => o.value === newLast.value);
      if (optionIdx !== -1) highlighted.value = optionIdx;
    }
  };
  const isComponentDisabled = () => parts.select?.disabled || parts.toggle?.getAttribute("aria-disabled") === "true";
  overlayControls(env, element, open);
  const panel = panelMiddleware();
  const overlayApi = overlay(env, {
    anchor: () => parts.toggle,
    panel: () => parts.listbox,
    open,
    placement: "bottom-start",
    strategy: "fixed",
    middleware: panel.middleware,
    closeOnOutsideClick: true,
    // Whichever control the user is driving owns focus in typeable mode.
    refocusOnEscape: () => config.typeable.value && parts.input ? parts.input : parts.toggle,
    duration: 0.15,
    easing: "ease-out",
    onBeforeOpen: () => {
      if (isComponentDisabled()) {
        open.value = false;
        return;
      }
      panel.invalidateCap();
      env.attrs(parts.toggle, { "data-focused": true });
    },
    onShow: () => {
      const typed = parts.input?.value.trim() ?? "";
      if (typed !== "" && typed.length >= config.searchThreshold.value) return;
      const firstSelected = formOptions.getSelected()[0];
      if (!firstSelected) return;
      const idx = getAllOptions().findIndex((opt) => opt.value === firstSelected.value);
      if (idx !== -1) ui.scrollToOption(idx, { centered: true });
    },
    onOpen: () => {
      env.emit("opened");
      if (config.typeable.value && parts.input) {
        if (document.activeElement !== parts.input) parts.input.focus();
      } else if (config.searchable.value && parts.searchInput) {
        parts.searchInput.focus();
      }
    },
    onBeforeClose: () => {
      if (document.activeElement !== parts.toggle && document.activeElement !== parts.input) {
        env.attrs(parts.toggle, { "data-focused": false });
      }
    },
    onClose: () => {
      highlighted.value = -1;
      env.emit("closed");
    }
  });
  env.on(element, "fluxon:tagsinput:search", (event) => {
    env.lv.pushEventTo(
      element,
      event.detail.callback,
      { query: event.detail.query, id: event.detail.id },
      (reply) => {
        if (reply && reply.error) event.detail.onError?.();
        else event.detail.onComplete?.();
      }
    );
  });
  env.effect("aria-expanded", () => {
    env.attrs(comboboxEl(), { "aria-expanded": String(open.value) });
    env.attrs(element, { "data-expanded": open.value });
  }, { onUpdated: true });
  focusFieldOnInvalid(env, {
    control: () => parts.select,
    field: comboboxEl
  });
  env.effect("aria-activedescendant", () => {
    const highlightedOption = highlighted.value === -1 ? null : getAllOptions().find((opt) => opt.index === highlighted.value);
    const id = highlightedOption?.el?.id || null;
    const searchInput = config.searchable.value && !config.typeable.value ? parts.searchInput : null;
    const owner = searchInput || comboboxEl();
    for (const el of [parts.toggle, parts.input, parts.searchInput]) {
      if (el) env.attrs(el, { "aria-activedescendant": el === owner ? id : null });
    }
  }, { onUpdated: true });
  env.effect("option-selection", () => {
    const selected = new Set(selectedValues.value);
    getAllOptions().forEach((opt) => {
      const isSelected = selected.has(opt.value);
      env.attrs(opt.el, {
        "aria-selected": String(isSelected),
        "data-selected": isSelected
      });
    });
  }, { onUpdated: true });
  env.effect("option-highlight", () => {
    getOptionElements().forEach((el, index) => {
      env.attrs(el, { "data-highlighted": index === highlighted.value });
    });
  }, { onUpdated: true });
  env.effect("server-results", () => {
    env.untrack(() => serverResults.sync());
  }, { onUpdated: true });
  env.effect("auto-highlight", () => {
    if (!open.value || !parts.select) return;
    if (highlighted.value === -1) return;
    const options = getAllOptions();
    const currentHighlight = options.find((opt) => opt.index === highlighted.value);
    if (currentHighlight && !currentHighlight.el.hidden && !currentHighlight.disabled) return;
    const visible = getVisibleOptions();
    highlighted.value = visible[0]?.index ?? -1;
  }, { onUpdated: true });
  const getTagElements = () => Array.from(parts.tagsArea?.querySelectorAll('[data-part="tag"]') || []);
  env.effect("tags-render", () => {
    void selectedValues.value;
    reconcileTags();
  }, { onUpdated: true });
  env.effect("tag-highlight-sync", () => {
    const show = focusedTagIndex.value === -1;
    const hi = show ? highlightedTagIndex.value : -1;
    getTagElements().forEach((tag, i) => {
      env.attrs(tag, { "data-highlighted": i === hi });
    });
  }, { onUpdated: true });
  env.effect("clear-button", () => {
    if (!config.clearable.value || !parts.clearButton) return;
    parts.clearButton.hidden = selectedValues.value.length === 0 || config.minSelections.value > 0;
  }, { onUpdated: true });
  env.effect("search-filter", () => {
    const query = searchQuery.value;
    if (!config.searchable.value && !config.typeable.value) return;
    if (config.onSearch.value) return;
    if (getAllOptions().length === 0) return;
    search.filterClient(query);
  }, { onUpdated: true });
  env.effect("search-input-sync", () => {
    if (parts.searchInput) parts.searchInput.value = searchQuery.value;
  });
  env.effect("loading-indicator", () => {
    if (!parts.loading) return;
    parts.loading.hidden = !loading.value;
    env.attrs(parts.loading, { role: "status", "aria-live": "polite" });
  });
  env.effect("search-input-events", () => {
    if (!config.searchable.value || config.typeable.value) return;
    if (!parts.searchInput) return;
    env.on(parts.searchInput, "input", (e) => {
      e.stopPropagation();
      search.handleInput(e.target.value.trim());
    });
    env.on(parts.searchInput, "change", (e) => e.stopPropagation());
    env.on(parts.searchInput, "keydown", (e) => {
      if (isImeComposing(e)) return;
      const action = keyboard.getAction(e.key, e.ctrlKey, e.metaKey);
      if (["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) {
        e.preventDefault();
        keyboard.handleAction(action, e.key);
      }
    });
  });
  env.effect("input-events", () => {
    if (!config.typeable.value || !parts.input) return;
    env.on(parts.input, "input", (e) => {
      e.stopPropagation();
      focusedTagIndex.value = -1;
      highlightedTagIndex.value = -1;
      if (!open.value) open.value = true;
      search.handleInput(e.target.value.trim());
    });
    env.on(parts.input, "change", (e) => e.stopPropagation());
    env.on(parts.input, "focus", () => {
      focusedTagIndex.value = -1;
      env.attrs(parts.toggle, { "data-focused": true });
    });
    env.on(parts.input, "blur", (e) => {
      if (!e.relatedTarget || !element.contains(e.relatedTarget)) {
        env.attrs(parts.toggle, { "data-focused": false });
      }
    });
    env.on(parts.input, "keydown", (e) => {
      if (isImeComposing(e)) return;
      if (e.key === "Enter") {
        const value = e.target.value;
        if (highlighted.value !== -1) {
          e.preventDefault();
          keyboard.handleAction(keyboard.getAction(e.key), e.key);
          return;
        }
        if (config.creatable.value && value.trim() !== "") {
          e.preventDefault();
          selection.createTag(value);
          return;
        }
      }
      if (["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) {
        const action = keyboard.getAction(e.key, e.ctrlKey, e.metaKey);
        if (!action) return;
        e.preventDefault();
        keyboard.handleAction(action, e.key);
        return;
      }
      if (e.key === "ArrowLeft") {
        const pills = getTagElements();
        if (!pills.length) return;
        if (e.target.selectionStart === 0 && e.target.selectionEnd === 0) {
          e.preventDefault();
          focusedTagIndex.value = pills.length - 1;
        }
        return;
      }
      if (e.key === "Backspace" && e.target.value === "") {
        e.preventDefault();
        keyboard.handleBackspace();
        return;
      }
    });
  });
  env.effect("tag-focus-sync", () => {
    if (!config.typeable.value) return;
    const idx = focusedTagIndex.value;
    const pills = getTagElements();
    pills.forEach((pill, i) => {
      const focused = i === idx;
      env.attrs(pill, {
        "data-focused": focused,
        tabindex: focused ? "0" : "-1"
      });
      if (focused && document.activeElement !== pill) {
        pill.focus();
      }
    });
  }, { onUpdated: true });
  env.effect("tag-keyboard", () => {
    if (!config.typeable.value || !parts.tagsArea) return;
    env.on(
      parts.tagsArea,
      "keydown",
      (e, pill) => {
        const pills = getTagElements();
        const idx = pills.indexOf(pill);
        if (idx === -1) return;
        switch (e.key) {
          case "ArrowLeft":
            e.preventDefault();
            if (idx > 0) focusedTagIndex.value = idx - 1;
            return;
          case "ArrowRight":
            e.preventDefault();
            if (idx < pills.length - 1) {
              focusedTagIndex.value = idx + 1;
            } else {
              focusedTagIndex.value = -1;
              parts.input?.focus();
            }
            return;
          case "Delete":
          case "Backspace": {
            e.preventDefault();
            if (pill.getAttribute("aria-disabled") === "true") return;
            const value = pill.dataset.value;
            const nextFocus = idx >= pills.length - 1 ? idx - 1 : idx;
            selection.removeByValue(value);
            queueMicrotask(() => {
              const updated = getTagElements();
              if (updated.length === 0 || nextFocus < 0) {
                focusedTagIndex.value = -1;
                parts.input?.focus();
              } else {
                focusedTagIndex.value = Math.min(nextFocus, updated.length - 1);
              }
            });
            return;
          }
          case "Escape":
            e.preventDefault();
            focusedTagIndex.value = -1;
            parts.input?.focus();
            return;
          case "Home":
            e.preventDefault();
            focusedTagIndex.value = 0;
            return;
          case "End":
            e.preventDefault();
            focusedTagIndex.value = pills.length - 1;
            return;
        }
      },
      { delegate: '[data-part="tag"]' }
    );
  });
  env.on(parts.toggle, "click", (e) => {
    if (isComponentDisabled()) return;
    if (e.target.closest('[data-part="tag-remove"]')) return;
    if (e.target.closest('[data-part="tag"]')) return;
    if (e.target.closest('[data-part="clear"]')) return;
    if (config.typeable.value && parts.input) {
      if (document.activeElement !== parts.input) parts.input.focus();
      if (!open.value) open.value = true;
      return;
    }
    open.value = !open.value;
  });
  env.on(parts.toggle, "focus", () => {
    env.attrs(parts.toggle, { "data-focused": true });
  });
  env.on(element, "focusout", (e) => {
    if (!e.relatedTarget || !element.contains(e.relatedTarget)) {
      env.attrs(parts.toggle, { "data-focused": false });
    }
  });
  env.on(parts.toggle, "keydown", (e) => {
    if (isComponentDisabled()) return;
    if (e.target !== parts.toggle) return;
    const action = keyboard.getAction(e.key, e.ctrlKey, e.metaKey);
    if (!action) return;
    if (action === KeyboardActions2.SELECT && !open.value) return;
    e.preventDefault();
    keyboard.handleAction(action, e.key);
  });
  env.on(
    parts.toggle,
    "click",
    (e, target) => {
      e.preventDefault();
      e.stopPropagation();
      if (isComponentDisabled()) return;
      const tag = target.closest('[data-part="tag"]');
      if (!tag) return;
      if (target.getAttribute("aria-disabled") === "true") return;
      selection.removeByValue(tag.dataset.value);
    },
    { delegate: '[data-part="tag-remove"]' }
  );
  env.effect("clear-button-events", () => {
    if (!config.clearable.value || !parts.clearButton) return;
    env.on(parts.toggle, "mousedown", (e) => {
      e.preventDefault();
      e.stopPropagation();
    }, { delegate: '[data-part="clear"]', capture: true });
    env.on(parts.toggle, "click", (e) => {
      selection.clear(e);
    }, { delegate: '[data-part="clear"]', capture: true });
    env.on(parts.toggle, "keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        selection.clear(e);
      }
    }, { delegate: '[data-part="clear"]' });
  }, { onUpdated: true });
  env.effect("focusout-dismiss", () => {
    if (!open.value) return;
    env.on(element, "focusout", (e) => {
      if (!e.relatedTarget || !element.contains(e.relatedTarget)) {
        env.timeout.raf("focusout-check", () => {
          if (!element.contains(document.activeElement) && open.value) {
            open.value = false;
          }
        });
      }
    });
  });
  env.on(parts.listbox, "click", (e, target) => {
    if (!open.value) return;
    e.preventDefault();
    e.stopPropagation();
    const idx = getAllOptions().findIndex((opt) => opt.el === target);
    if (idx !== -1) selection.select(idx);
  }, { delegate: '[data-part="option"]' });
  env.on(parts.listbox, "mouseover", (e, target) => {
    if (!open.value) return;
    if (isDisabled(target) || target.hidden) return;
    const index = getOptionElements().indexOf(target);
    if (index !== -1) highlighted.value = index;
  }, { delegate: '[data-part="option"]' });
  return {
    get value() {
      return formOptions.getSelected().map((opt) => opt.value);
    },
    select(value) {
      if (isComponentDisabled()) return false;
      return selection.selectByValue(value);
    },
    deselect(value) {
      if (isComponentDisabled()) return false;
      return selection.deselectByValue(value);
    },
    addTag(text) {
      if (isComponentDisabled()) return false;
      return selection.createTag(text);
    },
    clear() {
      if (isComponentDisabled()) return false;
      return selection.clearAll();
    },
    get isOpen() {
      return open.value;
    },
    open() {
      if (isComponentDisabled()) return false;
      if (open.value) return false;
      open.value = true;
      return true;
    },
    close() {
      if (!open.value) return false;
      open.value = false;
      return true;
    },
    toggle() {
      if (isComponentDisabled()) return open.value;
      open.value = !open.value;
      return open.value;
    }
  };
});

// js/components/accordion/accordion.js
var NAV_KEYS2 = ["ArrowUp", "ArrowDown", "Home", "End"];
function setsEqualByContent(a, b) {
  if (a === b) return true;
  if (!(a instanceof Set) || !(b instanceof Set)) return false;
  if (a.size !== b.size) return false;
  for (const v of a) if (!b.has(v)) return false;
  return true;
}
var hook8 = defineComponent("accordion", (element, env) => {
  const cfg = env.config(element, {
    multiple: { type: "boolean", default: false },
    preventAllClosed: { type: "boolean", default: false }
  });
  const getItems = () => Array.from(element.children).filter((c) => c.dataset.part === "item");
  const childPart = (parent, part) => {
    for (const child of parent.children) {
      if (child.dataset.part === part) return child;
    }
    return null;
  };
  const isDisabled2 = (item) => item.hasAttribute("data-disabled");
  const findItem = (id) => getItems().find((i) => i.id === id) || null;
  const readDomState = () => {
    const ids = /* @__PURE__ */ new Set();
    for (const item of getItems()) {
      if (item.hasAttribute("data-expanded")) ids.add(item.id);
    }
    if (!cfg.multiple.value && ids.size > 1) {
      const first = ids.values().next().value;
      ids.clear();
      ids.add(first);
    }
    return ids;
  };
  const openIds = env.signal(/* @__PURE__ */ new Set(), {
    name: "openIds",
    from: readDomState,
    equals: setsEqualByContent
  });
  env.effect("apply-state", () => {
    const open = openIds.value;
    for (const item of getItems()) {
      const isOpen = open.has(item.id);
      env.attrs(item, { "data-expanded": isOpen });
      env.attrs(childPart(item, "trigger"), { "aria-expanded": String(isOpen) });
      env.attrs(childPart(item, "panel"), { "aria-hidden": String(!isOpen), inert: !isOpen });
    }
  });
  let changedInitialized = false;
  env.effect("emit-changed", () => {
    const current = openIds.value;
    if (!changedInitialized) {
      changedInitialized = true;
      return;
    }
    env.emit("changed", {
      value: new Set(current),
      previousValue: openIds.previous ? new Set(openIds.previous) : /* @__PURE__ */ new Set()
    });
  });
  const toggle = (item) => {
    if (isDisabled2(item)) return;
    const id = item.id;
    if (!id) return;
    const wasOpen = openIds.value.has(id);
    const next = new Set(openIds.value);
    if (wasOpen) {
      if (cfg.preventAllClosed.value) {
        const enabledOpenCount = [...next].filter((openId) => {
          const el = findItem(openId);
          return el && !isDisabled2(el);
        }).length;
        if (enabledOpenCount <= 1) return;
      }
      next.delete(id);
    } else {
      if (!cfg.multiple.value) next.clear();
      next.add(id);
    }
    openIds.value = next;
    env.emit(wasOpen ? "closed" : "opened", { id });
  };
  env.on(
    element,
    "click",
    (event, trigger) => {
      const item = trigger.closest('[data-part="item"]');
      if (item && getItems().includes(item)) toggle(item);
    },
    { delegate: '[data-part="trigger"]' }
  );
  env.on(element, "keydown", (event) => {
    if (!NAV_KEYS2.includes(event.key)) return;
    const triggers = getItems().filter((i) => !isDisabled2(i)).map((i) => childPart(i, "trigger"));
    const current = triggers.indexOf(document.activeElement);
    if (current === -1) return;
    event.preventDefault();
    const count = triggers.length;
    let target;
    switch (event.key) {
      case "ArrowDown":
        target = triggers[(current + 1) % count];
        break;
      case "ArrowUp":
        target = triggers[(current - 1 + count) % count];
        break;
      case "Home":
        target = triggers[0];
        break;
      case "End":
        target = triggers[count - 1];
        break;
    }
    target?.focus();
  });
  return {
    get openIds() {
      return new Set(openIds.value);
    },
    open(id) {
      const item = findItem(id);
      if (item && !openIds.value.has(id)) toggle(item);
    },
    close(id) {
      const item = findItem(id);
      if (item && openIds.value.has(id)) toggle(item);
    },
    toggle(id) {
      const item = findItem(id);
      if (item) toggle(item);
    }
  };
});

// js/components/utils/datetime.js
var import_dayjs = __toESM(require_dayjs_min(), 1);
var import_utc = __toESM(require_utc(), 1);
var import_timezone = __toESM(require_timezone(), 1);
import_dayjs.default.extend(import_utc.default);
import_dayjs.default.extend(import_timezone.default);
var STRFTIME_TO_DAYJS = /* @__PURE__ */ new Map([
  // Date
  ["%Y", "YYYY"],
  // Year with century (2024)
  ["%y", "YY"],
  // Year without century (24)
  ["%m", "MM"],
  // Month with leading zero (01-12)
  ["%-m", "M"],
  // Month without leading zero (1-12)
  ["%d", "DD"],
  // Day with leading zero (01-31)
  ["%-d", "D"],
  // Day without leading zero (1-31)
  ["%j", "DDDD"],
  // Day of year (001-366)
  ["%u", "E"],
  // Day of week, Monday is 1 (1-7)
  // Weekday names
  ["%A", "dddd"],
  // Full weekday name (Monday)
  ["%a", "ddd"],
  // Abbreviated weekday name (Mon)
  // Month names
  ["%B", "MMMM"],
  // Full month name (January)
  ["%b", "MMM"],
  // Abbreviated month name (Jan)
  // Time
  ["%H", "HH"],
  // Hour using 24-hour clock (00-23)
  ["%-H", "H"],
  // Hour using 24-hour clock without leading zero (0-23)
  ["%I", "hh"],
  // Hour using 12-hour clock (01-12)
  ["%-I", "h"],
  // Hour using 12-hour clock without leading zero (1-12)
  ["%M", "mm"],
  // Minute with leading zero (00-59)
  ["%-M", "m"],
  // Minute without leading zero (0-59)
  ["%S", "ss"],
  // Second with leading zero (00-59)
  ["%-S", "s"],
  // Second without leading zero (0-59)
  ["%f", "SSS"],
  // Microseconds (000000-999999)
  ["%p", "A"],
  // AM/PM uppercase
  ["%P", "a"],
  // am/pm lowercase
  // Time zone
  ["%z", "ZZ"],
  // UTC offset (+0300, -0530)
  ["%Z", "z"],
  // Time zone abbreviation (CET, BRST)
  // Combined formats
  ["%c", "YYYY-MM-DD HH:mm:ss"],
  // Preferred date+time representation
  ["%x", "YYYY-MM-DD"],
  // Preferred date representation
  ["%X", "HH:mm:ss"],
  // Preferred time representation
  // Special
  ["%%", "%"]
  // Literal % character
]);
var STRFTIME_PATTERNS = Array.from(STRFTIME_TO_DAYJS.keys()).sort((a, b) => b.length - a.length);
var STRFTIME_REGEX = new RegExp(
  STRFTIME_PATTERNS.map((pattern) => pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|"),
  "g"
);
var DAYJS_TOKENS_REGEX = /[YQMDWwdHhmsaAZz]/g;
function strftimeToDayjs(format) {
  if (typeof format !== "string") {
    throw new TypeError("Format must be a string");
  }
  if (!format) return "";
  const parts = [];
  let lastIndex = 0;
  let match;
  while ((match = STRFTIME_REGEX.exec(format)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: format.slice(lastIndex, match.index) });
    }
    parts.push({ type: "token", value: match[0] });
    lastIndex = STRFTIME_REGEX.lastIndex;
  }
  if (lastIndex < format.length) {
    parts.push({ type: "text", value: format.slice(lastIndex) });
  }
  return parts.map((part) => {
    if (part.type === "token") {
      return STRFTIME_TO_DAYJS.get(part.value) || part.value;
    } else {
      return part.value.replace(DAYJS_TOKENS_REGEX, "[$&]");
    }
  }).join("");
}
function parseDate(dateString, format = "YYYY-MM-DD") {
  if (!dateString) return null;
  let date;
  if (format) {
    date = import_dayjs.default.utc(dateString, format);
  } else {
    date = import_dayjs.default.utc(dateString);
  }
  return date.isValid() ? date : null;
}
function formatStrftimeDate(date, strftimeFormat, options = {}) {
  if (!date) return null;
  let formattingDate = date;
  if (options.timezone === "local") {
    formattingDate = date.local();
  } else if (options.timezone && options.timezone !== "utc") {
    formattingDate = date.tz(options.timezone);
  } else {
    formattingDate = date.utc();
  }
  if (options.locale) {
    const { monthNames, monthNamesShort, amPm } = options.locale;
    const month = formattingDate.month();
    const hour = formattingDate.hour();
    const replacements = [];
    let format = strftimeFormat;
    if (monthNames?.[month]) {
      format = format.replace(/%B/g, "__0__");
      replacements.push(["__0__", monthNames[month]]);
    }
    if (monthNamesShort?.[month]) {
      format = format.replace(/%b/g, "__1__");
      replacements.push(["__1__", monthNamesShort[month]]);
    }
    if (amPm) {
      const label = hour >= 12 ? amPm[1] : amPm[0];
      format = format.replace(/%p/g, "__2__");
      format = format.replace(/%P/g, "__3__");
      replacements.push(["__2__", label]);
      replacements.push(["__3__", label.toLowerCase()]);
    }
    const dayjsFormat2 = strftimeToDayjs(format);
    let result = formattingDate.format(dayjsFormat2);
    for (const [placeholder, value] of replacements) {
      result = result.replaceAll(placeholder, value);
    }
    return result;
  }
  const dayjsFormat = strftimeToDayjs(strftimeFormat);
  return formattingDate.format(dayjsFormat);
}

// js/components/calendar/calendar-core.js
var import_dayjs2 = __toESM(require_dayjs_min(), 1);
var import_utc2 = __toESM(require_utc(), 1);
var import_isoWeek = __toESM(require_isoWeek(), 1);
import_dayjs2.default.extend(import_utc2.default);
import_dayjs2.default.extend(import_isoWeek.default);
var GranularityMode = {
  DAY: "day",
  MONTH: "month",
  YEAR: "year"
};
var CloseMode = {
  AUTO: "auto",
  MANUAL: "manual",
  CONFIRM: "confirm"
};
function pickCanonicalDayCell(matches) {
  const arr = Array.from(matches);
  if (arr.length === 0) return void 0;
  return arr.find((el) => !el.hasAttribute("data-other-month")) || arr[0];
}
function createCalendarCore(element, config, parts, env) {
  const locale = element.dataset.locale || "en";
  const weekdayNames = element.dataset.weekdays?.split(",") || [];
  const monthNames = element.dataset.monthNames?.split(",") || [];
  const monthNamesShort = element.dataset.monthNamesShort?.split(",") || [];
  const monthYearFormat = element.dataset.monthYearFormat || "{month} {year}";
  const datesSelectedTemplate = element.dataset.datesSelected || "%{count} dates selected";
  const rawAmPm = element.dataset.amPm?.split("/");
  const amPmLabels = rawAmPm?.length === 2 ? rawAmPm : ["AM", "PM"];
  const getToday = () => {
    const raw = config.today?.value;
    return raw ? parseDate(raw) : parseDate((0, import_dayjs2.default)().format("YYYY-MM-DD"));
  };
  function visibleCalendarCount() {
    const declared = parts.calendars.length;
    if (typeof window === "undefined") return declared;
    const w = window.innerWidth;
    let cap2;
    if (w < 640) cap2 = 1;
    else if (w < 1024) cap2 = 2;
    else if (w < 1280) cap2 = 3;
    else cap2 = 4;
    return Math.min(declared, cap2);
  }
  const open = env.signal(false, "open");
  const pickedDate = env.signal(null, "pickedDate");
  const currentDate = env.signal(null, "currentDate");
  const focusedDate = env.signal(null, "focusedDate");
  const selection = env.signal({ current: [], pending: null }, "selection");
  const disabledDates = /* @__PURE__ */ (() => {
    let datesSet = null;
    let daysSet = null;
    let monthsSet = null;
    let yearsSet = null;
    let daysOfMonthSet = null;
    let weeksSet = null;
    let monthDaysSet = null;
    let weekdaysSet = null;
    let lastParsedValue = void 0;
    function hasAnyPatternSet() {
      return !!(datesSet || daysSet || monthsSet || yearsSet || daysOfMonthSet || weeksSet || monthDaysSet || weekdaysSet);
    }
    function initialize() {
      const disabledDatesValue = config.disabledDates.value;
      if (disabledDatesValue === lastParsedValue) return false;
      lastParsedValue = disabledDatesValue;
      datesSet = daysSet = monthsSet = yearsSet = null;
      daysOfMonthSet = weeksSet = monthDaysSet = weekdaysSet = null;
      if (!disabledDatesValue) return true;
      try {
        const items = JSON.parse(disabledDatesValue);
        const buckets = { dates: [], days: [], months: [], years: [], daysOfMonth: [], weeks: [], monthDays: [], weekdays: [] };
        for (const item of items) {
          if (item.startsWith("month:")) buckets.months.push(parseInt(item.slice(6)));
          else if (item.startsWith("year:")) buckets.years.push(parseInt(item.slice(5)));
          else if (item.startsWith("day:")) buckets.daysOfMonth.push(parseInt(item.slice(4)));
          else if (item.startsWith("week:")) buckets.weeks.push(parseInt(item.slice(5)));
          else if (item.startsWith("month_day:")) {
            const itemParts = item.split(":");
            buckets.monthDays.push(`${itemParts[1]}:${itemParts[2]}`);
          } else if (item.startsWith("weekday:")) buckets.weekdays.push(parseInt(item.slice(8)));
          else if (item.match(/^\d{4}-\d{2}-\d{2}$/)) buckets.dates.push(item);
          else buckets.days.push(item);
        }
        const setOrNull = (arr) => arr.length > 0 ? new Set(arr) : null;
        datesSet = setOrNull(buckets.dates);
        daysSet = setOrNull(buckets.days);
        monthsSet = setOrNull(buckets.months);
        yearsSet = setOrNull(buckets.years);
        daysOfMonthSet = setOrNull(buckets.daysOfMonth);
        weeksSet = setOrNull(buckets.weeks);
        monthDaysSet = setOrNull(buckets.monthDays);
        weekdaysSet = setOrNull(buckets.weekdays);
      } catch (e) {
      }
      return true;
    }
    function matchesPattern(date) {
      const dayOfWeek = date.day();
      const isoWeekday = dayOfWeek === 0 ? 7 : dayOfWeek;
      const month = date.month() + 1;
      const year = date.year();
      const dayOfMonth = date.date();
      const isoWeekNum = date.isoWeek();
      if (monthsSet?.has(month)) return true;
      if (yearsSet?.has(year)) return true;
      if (daysOfMonthSet?.has(dayOfMonth)) return true;
      if (weeksSet?.has(isoWeekNum)) return true;
      if (monthDaysSet?.has(`${month}:${dayOfMonth}`)) return true;
      if (weekdaysSet?.has(isoWeekday)) return true;
      if (daysSet) {
        if (daysSet.has("weekends") && (dayOfWeek === 0 || dayOfWeek === 6)) return true;
        if (daysSet.has("weekdays") && dayOfWeek >= 1 && dayOfWeek <= 5) return true;
      }
      return false;
    }
    function isOutsideBounds(date) {
      const minDate = config.min.value ? parseDate(config.min.value) : null;
      const maxDate = config.max.value ? parseDate(config.max.value) : null;
      return minDate && date.isBefore(minDate, "day") || maxDate && date.isAfter(maxDate, "day");
    }
    function isDateDisabled(date) {
      if (isOutsideBounds(date)) return true;
      if (datesSet?.has(date.format("YYYY-MM-DD"))) return true;
      if (matchesPattern(date)) return true;
      return false;
    }
    function isMonthDisabled(date) {
      const minDate = config.min.value ? parseDate(config.min.value) : null;
      const maxDate = config.max.value ? parseDate(config.max.value) : null;
      const monthStart = date.startOf("month");
      const monthEnd = date.endOf("month");
      if (minDate && monthEnd.isBefore(minDate, "day") || maxDate && monthStart.isAfter(maxDate, "day")) {
        return true;
      }
      if (hasAnyPatternSet()) {
        let current = monthStart;
        let allDisabled = true;
        while (current.isBefore(monthEnd, "day") || current.isSame(monthEnd, "day")) {
          if (!isDateDisabled(current)) {
            allDisabled = false;
            break;
          }
          current = current.add(1, "day");
        }
        if (allDisabled) return true;
      }
      return false;
    }
    function isYearDisabled(date) {
      const minDate = config.min.value ? parseDate(config.min.value) : null;
      const maxDate = config.max.value ? parseDate(config.max.value) : null;
      const yearStart = date.startOf("year");
      const yearEnd = date.endOf("year");
      if (minDate && yearEnd.isBefore(minDate, "day") || maxDate && yearStart.isAfter(maxDate, "day")) {
        return true;
      }
      if (hasAnyPatternSet()) {
        for (let month = 0; month < 12; month++) {
          const testDate = yearStart.month(month).startOf("month");
          if (!isMonthDisabled(testDate)) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
    function findNextEnabled(startDate, direction, granularity) {
      let isDisabledFn;
      if (mode.isYearMode()) isDisabledFn = isYearDisabled;
      else if (mode.isMonthMode()) isDisabledFn = isMonthDisabled;
      else isDisabledFn = isDateDisabled;
      const step = Math.abs(direction);
      let current = startDate;
      const maxAttempts = 100;
      for (let attempts = 0; attempts < maxAttempts; attempts++) {
        current = direction > 0 ? current.add(step, granularity) : current.subtract(step, granularity);
        if (!isDisabledFn(current)) return current;
      }
      return null;
    }
    return {
      initialize,
      isDateDisabled,
      isMonthDisabled,
      isYearDisabled,
      isOutsideBounds,
      findNextEnabled
    };
  })();
  const mode = {
    isDayMode: () => config.granularity.value === GranularityMode.DAY,
    isMonthMode: () => config.granularity.value === GranularityMode.MONTH,
    isYearMode: () => config.granularity.value === GranularityMode.YEAR,
    isSingleMode: () => !config.range.value && !config.multiple.value,
    isMultipleMode: () => !config.range.value && config.multiple.value,
    isRangeMode: () => config.range.value && !config.multiple.value,
    getGranularityUnit: () => config.granularity.value,
    normalizeToGranularity(date) {
      if (!date) return date;
      if (this.isMonthMode()) return date.startOf("month");
      if (this.isYearMode()) return date.startOf("year");
      return date;
    },
    hasTimePicker: () => config.timePicker?.value && mode.isDayMode(),
    getEffectiveCloseMode() {
      const closeValue = config.close?.value || CloseMode.MANUAL;
      const isComposite = config.timePicker?.value || config.multiple.value || config.range.value;
      if (isComposite && !element.hasAttribute("data-close")) {
        return CloseMode.MANUAL;
      }
      if ((config.timePicker?.value || config.multiple.value) && closeValue === CloseMode.AUTO) {
        return CloseMode.MANUAL;
      }
      return closeValue;
    },
    isConfirmMode: () => mode.getEffectiveCloseMode() === CloseMode.CONFIRM,
    shouldUsePendingSelection: () => mode.getEffectiveCloseMode() === CloseMode.CONFIRM,
    getEffectiveDisplayFormat() {
      if (mode.isMonthMode()) return "%b %Y";
      if (mode.isYearMode()) return "%Y";
      return config.displayFormat?.value || "%b %-d, %Y";
    }
  };
  const selectionController = {
    getWorking() {
      return mode.shouldUsePendingSelection() ? selection.value.pending || [...selection.value.current] : selection.value.current;
    },
    update(newDates, { isPending = false } = {}) {
      selection.value = {
        current: isPending ? selection.value.current : newDates,
        pending: isPending ? newDates : null
      };
    },
    copyTimeFromDate(targetDate, sourceDate) {
      return targetDate.hour(sourceDate.hour()).minute(sourceDate.minute()).second(sourceDate.second());
    },
    handleSinglePick(picked) {
      if (!picked) return;
      picked = mode.normalizeToGranularity(picked);
      const working = this.getWorking();
      const granularity = mode.getGranularityUnit();
      const existingDate = working.find((date) => date?.isSame(picked, granularity));
      if (existingDate) {
        if (config.allowDeselect?.value === false) return;
        this.update([], { isPending: mode.shouldUsePendingSelection() });
        return;
      }
      if (mode.isDayMode()) {
        const currentSelection = working[0];
        if (currentSelection) {
          picked = this.copyTimeFromDate(picked, currentSelection);
        }
      }
      this.update([picked], { isPending: mode.shouldUsePendingSelection() });
    },
    handleMultiplePick(picked) {
      if (!picked) return;
      picked = mode.normalizeToGranularity(picked);
      const baseSelection = this.getWorking();
      const newSelection = this.toggleDateInSelection(picked, baseSelection);
      this.update(newSelection, { isPending: mode.shouldUsePendingSelection() });
    },
    handleRangePick(picked) {
      if (!picked) return;
      picked = mode.normalizeToGranularity(picked);
      const baseSelection = this.getWorking();
      const newSelection = this.getNewRangeSelection(picked, baseSelection);
      this.update(newSelection, { isPending: mode.shouldUsePendingSelection() });
    },
    toggleDateInSelection(picked, baseSelection = []) {
      const granularity = mode.getGranularityUnit();
      const existingIndex = baseSelection.findIndex((date) => date?.isSame(picked, granularity));
      if (existingIndex >= 0) {
        if (config.allowDeselect?.value === false && baseSelection.length === 1) {
          return baseSelection;
        }
        return [...baseSelection.slice(0, existingIndex), ...baseSelection.slice(existingIndex + 1)];
      }
      return [...baseSelection, picked];
    },
    getNewRangeSelection(picked, baseSelection = null) {
      const sel = baseSelection || selection.value.current;
      const [start, end] = sel;
      const granularity = mode.getGranularityUnit();
      if (!start) return [picked];
      if (!end) {
        if (picked.isSame(start, granularity)) return [start, start];
        if (picked.isBefore(start, granularity)) return [picked, start];
        return [start, picked];
      }
      if (picked.isSame(start, granularity)) {
        return config.allowDeselect?.value === false ? [start, end] : [];
      }
      if (picked.isSame(end, granularity)) return [picked];
      if (picked.isBefore(start, granularity)) return [picked, end];
      if (picked.isAfter(end, granularity)) return [start, picked];
      return [start, picked];
    },
    shouldClose(typeableTextInput) {
      if (typeableTextInput && document.activeElement === typeableTextInput) {
        return false;
      }
      if (mode.isRangeMode()) {
        return selection.value.current.length === 2;
      }
      if (mode.isSingleMode()) {
        return pickedDate.value != null;
      }
      return false;
    },
    canApply(sel) {
      if (!sel.pending) return false;
      if (mode.isRangeMode()) {
        const hasBothDates = sel.pending.length === 2;
        const isClearingRange = sel.pending.length === 0 && sel.current.length > 0;
        const matchesCurrentSelection = this.areSelectionsEqual(sel.pending, sel.current);
        return (hasBothDates || isClearingRange) && !matchesCurrentSelection;
      }
      return !this.areSelectionsEqual(sel.pending, sel.current);
    },
    areSelectionsEqual(sel1, sel2) {
      if (!sel1 || !sel2) return false;
      if (sel1.length !== sel2.length) return false;
      return sel1.every((date, i) => date?.isSame(sel2[i]));
    },
    isDateSelected(date) {
      const sel = selection.value.pending || selection.value.current;
      return sel.some((selectedDate) => selectedDate?.isSame(date, "day"));
    },
    isMonthSelected(date) {
      const sel = selection.value.pending || selection.value.current;
      return sel.some((selectedDate) => selectedDate?.isSame(date, "month"));
    },
    isYearSelected(date) {
      const sel = selection.value.pending || selection.value.current;
      return sel.some((selectedDate) => selectedDate?.isSame(date, "year"));
    },
    getRangeState(date) {
      if (!config.range.value) return {};
      const sel = selection.value.pending || selection.value.current;
      const [start, end] = sel;
      const granularity = mode.getGranularityUnit();
      if (!start) return {};
      const isStart = start?.isSame(date, granularity);
      const isEnd = end?.isSame(date, granularity);
      let isInRange = false;
      if (end && !isStart && !isEnd) {
        const dateAtGranularity = (0, import_dayjs2.default)(date).startOf(granularity);
        const startAtGranularity = (0, import_dayjs2.default)(start).startOf(granularity);
        const endAtGranularity = (0, import_dayjs2.default)(end).startOf(granularity);
        isInRange = dateAtGranularity.isAfter(startAtGranularity) && dateAtGranularity.isBefore(endAtGranularity);
      }
      return { isStart, isEnd, isInRange };
    },
    formatDisplay(sel) {
      const displayFormat = mode.getEffectiveDisplayFormat();
      const fmt = (date2) => {
        if (mode.isMonthMode()) return monthYearFormat.replace("{month}", monthNamesShort[date2.utc().month()]).replace("{year}", date2.utc().year());
        return formatStrftimeDate(date2.utc(), displayFormat, { locale: { monthNames, monthNamesShort, amPm: amPmLabels } });
      };
      if (mode.isRangeMode()) {
        const [start, end] = sel;
        if (!start) return "";
        if (!end) return fmt(start);
        return `${fmt(start)} - ${fmt(end)}`;
      }
      if (mode.isMultipleMode()) {
        if (sel.length === 0) return "";
        if (sel.length === 1) return fmt(sel[0]);
        return datesSelectedTemplate.replace("%{count}", sel.length);
      }
      const [date] = sel;
      return date ? fmt(date) : "";
    },
    syncInputValues(dates, format = "YYYY-MM-DD") {
      const utcDates = dates.map((date) => date ? date.utc() : null);
      const effectiveFormat = mode.hasTimePicker() ? "YYYY-MM-DD HH:mm:ss" : format;
      if (mode.isRangeMode()) {
        const [start, end] = utcDates;
        this.updateInputValue(parts.inputStart, start, effectiveFormat);
        this.updateInputValue(parts.inputEnd, end, effectiveFormat);
        return;
      }
      if (mode.isMultipleMode()) {
        this.syncMultipleInputValues(utcDates, effectiveFormat);
        return;
      }
      this.updateInputValue(parts.input, utcDates[0], effectiveFormat);
      if (mode.hasTimePicker()) {
        time.updateInputs(utcDates[0]);
      }
    },
    updateInputValue(input, date, format) {
      if (!input) return;
      const newValue = date ? date.utc().format(format) : "";
      if (input.value !== newValue) {
        input.value = newValue;
        env.emitNative(input, ["change"]);
      }
    },
    syncMultipleInputValues(dates, format) {
      const inputWrapper = parts.input.parentNode;
      const existingInputs = Array.from(inputWrapper.querySelectorAll('[data-part="input"]'));
      const firstInput = parts.input;
      let valueChanged = false;
      if (existingInputs.length === 0) {
        inputWrapper.appendChild(firstInput);
        valueChanged = firstInput.value !== "";
        firstInput.value = "";
      }
      if (dates.length === 0) {
        if (existingInputs.length > 1) {
          existingInputs.slice(1).forEach((input) => input.remove());
          valueChanged = true;
        }
        if (firstInput.value !== "") {
          firstInput.value = "";
          valueChanged = true;
        }
      } else {
        if (existingInputs.length > Math.max(dates.length, 1)) {
          valueChanged = true;
        }
        dates.forEach((date, index) => {
          const formattedValue = date ? date.format(format) : "";
          let input = existingInputs[index];
          if (!input) {
            input = firstInput.cloneNode(true);
            input.value = "";
            inputWrapper.appendChild(input);
            valueChanged = true;
          }
          if (input.value !== formattedValue) {
            input.value = formattedValue;
            valueChanged = true;
          }
        });
        const inputsToRemove = existingInputs.slice(Math.max(dates.length, 1));
        inputsToRemove.forEach((input) => input.remove());
      }
      if (valueChanged) {
        env.emitNative(firstInput, ["change"]);
      }
    },
    getFromInputs() {
      if (config.range.value) {
        return [parseDate(parts.inputStart?.value), parseDate(parts.inputEnd?.value)].filter(Boolean);
      }
      if (config.multiple.value) {
        return Array.from(parts.root.querySelectorAll('[data-part="input"]')).map((input) => parseDate(input.value)).filter(Boolean);
      }
      const date = parseDate(parts.input?.value);
      return date ? [date] : [];
    },
    cancel() {
      pickedDate.value = null;
      this.update(selection.value.current);
    },
    apply() {
      pickedDate.value = null;
      const pendingSelection = selection.value.pending || [];
      this.update(pendingSelection);
    }
  };
  function periodStep() {
    if (mode.isYearMode()) return { amount: 12, unit: "year" };
    if (mode.isMonthMode()) return { amount: 1, unit: "year" };
    return { amount: 1, unit: "month" };
  }
  function shift3(fn) {
    const current = currentDate.value;
    if (current) currentDate.value = fn(current);
  }
  const navigation = {
    prevPeriod() {
      const { amount, unit } = periodStep();
      shift3((date) => date.subtract(amount, unit));
    },
    nextPeriod() {
      const { amount, unit } = periodStep();
      shift3((date) => date.add(amount, unit));
    },
    prevYear() {
      shift3((date) => date.subtract(1, "year"));
    },
    nextYear() {
      shift3((date) => date.add(1, "year"));
    },
    setYear(year) {
      shift3((date) => date.set("year", year));
    },
    setMonth(month) {
      shift3((date) => date.set("month", month));
    },
    findInitialDate() {
      const selectionDate = selection.value.current[0];
      const initialDate = selectionDate || getToday();
      if (!disabledDates.isDateDisabled(initialDate)) {
        return initialDate;
      }
      const minDate = config.min.value ? parseDate(config.min.value) : null;
      const maxDate = config.max.value ? parseDate(config.max.value) : null;
      const today = getToday();
      if (minDate && today.isBefore(minDate)) return minDate;
      if (maxDate && today.isAfter(maxDate)) return maxDate;
      return today;
    }
  };
  const calendar = {
    render() {
      this.updateWeekdayHeaders();
      this.renderHeader();
      this.renderGrid();
      this.updateNavigationButtons();
      this.updateRovingTabindex();
      this.updateWeekdaysVisibility();
      this.updateCalendarView();
    },
    renderHeader() {
      const { calendarTitles, monthSelect, yearSelect } = parts;
      const currentMonth = currentDate.value.month();
      const currentYear = currentDate.value.year();
      const formatTitle = (offset3) => {
        if (mode.isYearMode()) {
          const baseYear = currentDate.value.add(offset3, "year").year();
          const decadeStart = Math.floor(baseYear / 10) * 10;
          return `${decadeStart} - ${decadeStart + 11}`;
        }
        if (mode.isMonthMode()) {
          return String(currentDate.value.add(offset3, "year").year());
        }
        const titleDate = currentDate.value.add(offset3, "month");
        return monthYearFormat.replace("{month}", monthNames[titleDate.month()]).replace("{year}", titleDate.year());
      };
      if (calendarTitles && calendarTitles.length > 0) {
        for (const titleEl of calendarTitles) {
          const offset3 = Number(titleEl.dataset.monthOffset || 0);
          titleEl.textContent = formatTitle(offset3);
        }
      }
      if (monthSelect) {
        monthSelect.hidden = !mode.isDayMode();
        monthSelect.value = String(currentMonth);
      }
      if (yearSelect) {
        yearSelect.hidden = !mode.isDayMode();
        this.ensureYearOption(yearSelect, currentYear);
        yearSelect.value = String(currentYear);
      }
    },
    // The server lists the years it expects to be reachable, but arrows, keys, presets and
    // values can show any year. A select with no option for the visible year shows blank, so
    // add the missing one in order rather than let the header disagree with the grid.
    ensureYearOption(yearSelect, year) {
      const value = String(year);
      const options = Array.from(yearSelect.options);
      if (options.some((option2) => option2.value === value)) return;
      const option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      const next = options.find((existing) => Number(existing.value) > year);
      yearSelect.insertBefore(option, next ?? null);
    },
    renderGrid() {
      if (mode.isMonthMode()) {
        this.renderMonthGrid(parts.calendars[0]);
      } else if (mode.isYearMode()) {
        this.renderYearGrid(parts.calendars[0]);
      } else {
        for (const calendarEl of parts.calendars) {
          const offset3 = Number(calendarEl.dataset.monthOffset || 0);
          this.renderDayGrid(calendarEl, currentDate.value.add(offset3, "month"));
        }
      }
    },
    renderDayGrid(calendarEl, displayMonth) {
      const firstDay = displayMonth.startOf("month");
      const daysBefore = (firstDay.day() - config.weekStart.value + 7) % 7;
      const startDate = firstDay.subtract(daysBefore, "day");
      const hideOutsideDays = config.hideOutsideDays.value;
      const totalCells = hideOutsideDays ? Math.ceil((daysBefore + displayMonth.daysInMonth()) / 7) * 7 : 42;
      const existingButtons = Array.from(calendarEl.children);
      for (let i = 0; i < totalCells; i++) {
        const date = startDate.add(i, "day");
        const isOtherMonth = !date.isSame(displayMonth, "month");
        const isPlaceholder = isOtherMonth && hideOutsideDays;
        if (i < existingButtons.length) {
          this.updateDayButton(existingButtons[i], date, isOtherMonth, isPlaceholder);
        } else {
          calendarEl.appendChild(this.createDayButton(date, isOtherMonth, isPlaceholder));
        }
      }
      while (calendarEl.children.length > totalCells) {
        calendarEl.lastChild.remove();
      }
    },
    updateDayButton(button, date, isOtherMonth, isPlaceholder = false) {
      if (isPlaceholder) {
        const dateText2 = button.querySelector('[data-part="date-text"]');
        if (dateText2) dateText2.textContent = "";
        env.attrs(button, {
          "data-placeholder": true,
          "data-date": false,
          "data-other-month": false,
          "data-today": false,
          "data-selected": false,
          "data-highlighted": false,
          "data-disabled": false,
          "data-range-start": false,
          "data-range-end": false,
          "data-in-range": false,
          "data-weekend": false,
          "data-weekday": false,
          disabled: true,
          "aria-hidden": "true",
          "aria-disabled": false,
          "aria-selected": false,
          "aria-current": false,
          tabindex: "-1",
          // Scrub the roving-tabindex marker in case this button was the focus
          // target before being recycled into a placeholder slot.
          autofocus: false
        });
        return;
      }
      const isDisabled2 = disabledDates.isDateDisabled(date);
      const isHighlighted = focusedDate.value?.isSame(date, "day");
      const isSelected = selectionController.isDateSelected(date);
      const isToday = date.isSame(getToday(), "day");
      const { isStart, isEnd, isInRange } = selectionController.getRangeState(date);
      const isWeekend = date.day() === 0 || date.day() === 6;
      const isWeekday = !isWeekend;
      const dateText = button.querySelector('[data-part="date-text"]');
      if (dateText) {
        dateText.textContent = date.date();
      }
      env.attrs(button, {
        // Clear placeholder state in case this button was blanked on a prior render.
        "data-placeholder": false,
        "data-date": date.format("YYYY-MM-DD"),
        "data-other-month": isOtherMonth || false,
        "data-today": isToday || false,
        "data-selected": isSelected || false,
        "data-highlighted": isHighlighted || false,
        "data-disabled": isDisabled2 || false,
        "data-range-start": isStart || false,
        "data-range-end": isEnd || false,
        "data-in-range": isInRange || false,
        "data-weekend": isWeekend || false,
        "data-weekday": isWeekday || false,
        disabled: isDisabled2 || false,
        "aria-disabled": String(isDisabled2 || false),
        "aria-selected": String(isSelected || false),
        "aria-current": isToday ? "date" : false,
        // Trailing/leading other-month cells duplicate dates that live in an
        // adjacent grid in multi-month layouts. Hide them from the AT tree so
        // screen readers don't announce the same date twice.
        "aria-hidden": isOtherMonth ? "true" : false,
        tabindex: "-1"
      });
    },
    createDayButton(date, isOtherMonth = false, isPlaceholder = false) {
      const { dayTemplate } = parts;
      const dayButton = dayTemplate.content.cloneNode(true).firstElementChild;
      this.updateDayButton(dayButton, date, isOtherMonth, isPlaceholder);
      return dayButton;
    },
    renderMonthGrid(calendarEl) {
      const totalCells = 12;
      const currentYear = currentDate.value.year();
      const existingButtons = Array.from(calendarEl.children);
      for (let i = 0; i < totalCells; i++) {
        const date = import_dayjs2.default.utc().year(currentYear).month(i).startOf("month");
        if (i < existingButtons.length) {
          this.updateMonthButton(existingButtons[i], date);
        } else {
          calendarEl.appendChild(this.createMonthButton(date));
        }
      }
      while (calendarEl.children.length > totalCells) {
        calendarEl.lastChild.remove();
      }
    },
    updateMonthButton(button, date) {
      const isDisabled2 = disabledDates.isMonthDisabled(date);
      const isHighlighted = focusedDate.value?.isSame(date, "month");
      const isSelected = selectionController.isMonthSelected(date);
      const isToday = date.isSame(getToday(), "month");
      const { isStart, isEnd, isInRange } = selectionController.getRangeState(date);
      const dateText = button.querySelector('[data-part="date-text"]');
      dateText.textContent = monthNamesShort[date.month()];
      env.attrs(button, {
        "data-month": date.format("YYYY-MM"),
        "data-date": date.format("YYYY-MM-DD"),
        "data-today": isToday || false,
        "data-selected": isSelected || false,
        "data-highlighted": isHighlighted || false,
        "data-disabled": isDisabled2 || false,
        "data-range-start": isStart || false,
        "data-range-end": isEnd || false,
        "data-in-range": isInRange || false,
        "data-other-month": false,
        disabled: isDisabled2 || false,
        "aria-disabled": String(isDisabled2 || false),
        "aria-selected": String(isSelected || false),
        "aria-current": isToday ? "date" : false,
        tabindex: "-1"
      });
    },
    createMonthButton(date) {
      const { dayTemplate } = parts;
      const monthButton = dayTemplate.content.cloneNode(true).firstElementChild;
      this.updateMonthButton(monthButton, date);
      return monthButton;
    },
    renderYearGrid(calendarEl) {
      const totalCells = 12;
      const currentYear = currentDate.value.year();
      const decadeStart = Math.floor(currentYear / 10) * 10;
      const existingButtons = Array.from(calendarEl.children);
      for (let i = 0; i < totalCells; i++) {
        const date = import_dayjs2.default.utc().year(decadeStart + i).startOf("year");
        if (i < existingButtons.length) {
          this.updateYearButton(existingButtons[i], date);
        } else {
          calendarEl.appendChild(this.createYearButton(date));
        }
      }
      while (calendarEl.children.length > totalCells) {
        calendarEl.lastChild.remove();
      }
    },
    updateYearButton(button, date) {
      const isDisabled2 = disabledDates.isYearDisabled(date);
      const isHighlighted = focusedDate.value?.isSame(date, "year");
      const isSelected = selectionController.isYearSelected(date);
      const isToday = date.isSame(getToday(), "year");
      const { isStart, isEnd, isInRange } = selectionController.getRangeState(date);
      const dateText = button.querySelector('[data-part="date-text"]');
      dateText.textContent = date.format("YYYY");
      env.attrs(button, {
        "data-year": date.format("YYYY"),
        "data-date": date.format("YYYY-MM-DD"),
        "data-today": isToday || false,
        "data-selected": isSelected || false,
        "data-highlighted": isHighlighted || false,
        "data-disabled": isDisabled2 || false,
        "data-range-start": isStart || false,
        "data-range-end": isEnd || false,
        "data-in-range": isInRange || false,
        "data-other-month": false,
        disabled: isDisabled2 || false,
        "aria-disabled": String(isDisabled2 || false),
        "aria-selected": String(isSelected || false),
        "aria-current": isToday ? "date" : false,
        tabindex: "-1"
      });
    },
    createYearButton(date) {
      const { dayTemplate } = parts;
      const yearButton = dayTemplate.content.cloneNode(true).firstElementChild;
      this.updateYearButton(yearButton, date);
      return yearButton;
    },
    updateNavigationButtons() {
      const { prevMonthButton, nextMonthButton, nextYearButton, prevYearButton } = parts;
      const monthsCount = visibleCalendarCount();
      let prevPeriodCheck, nextPeriodCheck;
      if (mode.isYearMode()) {
        prevPeriodCheck = currentDate.value.subtract(12, "year").endOf("year");
        nextPeriodCheck = currentDate.value.add(12, "year").startOf("year");
      } else if (mode.isMonthMode()) {
        prevPeriodCheck = currentDate.value.subtract(1, "year").endOf("year");
        nextPeriodCheck = currentDate.value.add(1, "year").startOf("year");
      } else {
        prevPeriodCheck = currentDate.value.subtract(1, "month").endOf("month");
        nextPeriodCheck = currentDate.value.add(monthsCount, "month").startOf("month");
      }
      prevMonthButton.disabled = disabledDates.isOutsideBounds(prevPeriodCheck);
      nextMonthButton.disabled = disabledDates.isOutsideBounds(nextPeriodCheck);
      if (prevYearButton) {
        const lastDayPrevYear = currentDate.value.subtract(1, "year").endOf("month");
        prevYearButton.disabled = disabledDates.isOutsideBounds(lastDayPrevYear);
      }
      if (nextYearButton) {
        const firstDayNextYear = currentDate.value.add(1, "year").startOf("month");
        nextYearButton.disabled = disabledDates.isOutsideBounds(firstDayNextYear);
      }
    },
    updateWeekdaysVisibility() {
      const { weekdays } = parts;
      if (!weekdays || weekdays.length === 0) return;
      for (const row of weekdays) row.hidden = !mode.isDayMode();
    },
    updateWeekdayHeaders() {
      const { weekdays } = parts;
      if (!weekdays || weekdays.length === 0) return;
      const weekStart = config.weekStart.value;
      for (const row of weekdays) {
        const weekdayElements = row.querySelectorAll("[data-weekday]");
        weekdayElements.forEach((el, i) => {
          el.textContent = weekdayNames[(i + weekStart) % 7];
        });
      }
    },
    updateCalendarView() {
      const { calendars, grids } = parts;
      if (!calendars || calendars.length === 0) return;
      let viewMode = "days";
      if (mode.isMonthMode()) viewMode = "months";
      else if (mode.isYearMode()) viewMode = "years";
      for (const el of calendars) el.setAttribute("data-view", viewMode);
      if (mode.isRangeMode()) {
        const sel = selection.value.pending || selection.value.current;
        const [start, end] = sel;
        const hasCompleteRange = start && end && !start.isSame(end, mode.getGranularityUnit());
        env.attrs(grids, { "data-range-complete": hasCompleteRange || false });
      }
    },
    updateRovingTabindex() {
      const validDays = Array.from(parts.grids.querySelectorAll("button[data-date]:not([disabled])"));
      if (validDays.length === 0) return;
      const findDay = (date) => {
        if (!date) return void 0;
        const matches = validDays.filter((day) => parseDate(day.dataset.date)?.isSame(date, "day"));
        return pickCanonicalDayCell(matches);
      };
      const focusableDay = findDay(focusedDate.value) || findDay(selection.value.current[0]) || validDays.find((day) => day.hasAttribute("data-today")) || validDays[0];
      validDays.forEach((day) => {
        env.attrs(day, {
          tabindex: day === focusableDay ? "0" : "-1",
          autofocus: day === focusableDay
        });
      });
    }
  };
  const time = {
    updateInputs(date) {
      const { hourInput, minuteInput, secondInput } = parts;
      if (!hourInput) return;
      if (!date) {
        env.attrs(hourInput, { disabled: true, value: "00" });
        env.attrs(minuteInput, { disabled: true, value: "00" });
        env.attrs(secondInput, { disabled: true, value: "00" });
        this.setPeriod("am", { disabled: true });
        return;
      }
      let displayHour = date.hour();
      const hourCycle = config.hourCycle?.value || "h12";
      if (hourCycle === "h12") {
        displayHour = displayHour % 12 || 12;
      }
      env.attrs(hourInput, {
        disabled: false,
        value: String(displayHour).padStart(2, "0"),
        min: hourCycle === "h12" ? "1" : "0",
        max: hourCycle === "h12" ? "12" : "23"
      });
      env.attrs(minuteInput, { disabled: false, value: String(date.minute()).padStart(2, "0") });
      env.attrs(secondInput, { disabled: false, value: String(date.second()).padStart(2, "0") });
      this.setPeriod(date.hour() >= 12 ? "pm" : "am", { disabled: false });
    },
    // AM/PM is a segmented radiogroup of two buttons. The active button carries
    // `data-active`; reading/writing the period means flipping that attribute (plus
    // the roving `tabindex` and `aria-checked`) rather than touching a <select> value.
    getPeriod() {
      const options = parts.amPmOptions;
      if (!options?.length) return null;
      const active = options.find((btn) => btn.hasAttribute("data-active"));
      return active?.dataset.period || null;
    },
    setPeriod(period, { disabled }) {
      const options = parts.amPmOptions;
      if (!options?.length) return;
      options.forEach((btn) => {
        const active = btn.dataset.period === period;
        env.attrs(btn, {
          "data-active": active,
          "aria-checked": active,
          tabindex: active ? "0" : "-1",
          disabled
        });
      });
    },
    focusPeriod(period) {
      parts.amPmOptions?.find((btn) => btn.dataset.period === period)?.focus();
    },
    // The three H/M/S inputs in order — the source of truth for segment traversal and roving
    // tabindex below.
    segmentInputs() {
      return [parts.hourInput, parts.minuteInput, parts.secondInput].filter(Boolean);
    },
    // Currently-focusable segments for ArrowLeft/Right traversal — visible and enabled only.
    // The AM/PM toggle is reached via Tab, not arrow keys. Reuses the focus-trap visibility
    // predicate so "what is tabbable" stays consistent across the library.
    focusableSegments() {
      return this.segmentInputs().filter((el) => !el.disabled && isTabbable(el));
    },
    moveSegment(current, direction) {
      const segments = this.focusableSegments();
      const next = segments[segments.indexOf(current) + direction];
      if (next) next.focus();
    },
    // Roving tabindex: the H/M/S field is a single tab stop. Only the focused segment is
    // tabbable, so Tab leaves the field (to the AM/PM toggle) instead of stepping through each
    // segment, and Shift+Tab leaves to the day grid. Arrow keys move within (see moveSegment).
    setSegmentTabStop(target) {
      this.segmentInputs().forEach((el) => env.attrs(el, { tabindex: el === target ? "0" : "-1" }));
    },
    handleInput(type, action, value) {
      const handlers = {
        backspace: (current) => Math.floor(current / 10),
        increment: (current, max3, min3 = 0) => Math.min(current + 1, max3),
        decrement: (current, max3, min3 = 0) => Math.max(current - 1, min3),
        digit: (current, digit, max3, min3 = 0) => {
          const newValue2 = current % 10 * 10 + digit;
          return Math.min(Math.max(newValue2 > max3 ? digit : newValue2, min3), max3);
        }
      };
      const hourCycle = config.hourCycle?.value || "h12";
      const limits = {
        hour: {
          h23: { min: 0, max: 23 },
          h12: { min: 1, max: 12 }
        },
        minute: { min: 0, max: 59 },
        second: { min: 0, max: 59 }
      };
      let sel = selectionController.getWorking();
      if (!sel?.length) return;
      const [currentDateValue, ...restDates] = sel;
      let currentValue = currentDateValue[type]();
      const { min: min2, max: max2 } = type === "hour" ? limits.hour[hourCycle] : limits[type] || {};
      if (type === "hour" && hourCycle === "h12") {
        currentValue = currentValue % 12 || 12;
      }
      const handler = handlers[action];
      const newValue = action === "digit" ? handler(currentValue, value, max2, min2) : handler(currentValue, max2, min2);
      let finalValue = newValue;
      if (type === "hour" && hourCycle === "h12") {
        const isPm = this.getPeriod() === "pm";
        finalValue = newValue === 12 ? isPm ? 12 : 0 : isPm ? newValue + 12 : newValue;
      }
      const updatedDate = this.updateDateTimeValue(currentDateValue, type, finalValue);
      selectionController.update([updatedDate, ...restDates], { isPending: mode.shouldUsePendingSelection() });
    },
    updateDateTimeValue(date, type, value) {
      if (!date) return null;
      switch (type) {
        case "hour":
          return date.hour(value);
        case "minute":
          return date.minute(value);
        case "second":
          return date.second(value);
        default:
          return date;
      }
    },
    handleAmPmToggle(isPm) {
      let sel = selectionController.getWorking();
      if (!sel?.length) return;
      const [currentDateValue, ...restDates] = sel;
      const hour = currentDateValue.hour();
      const currentPm = hour >= 12;
      if (currentPm !== isPm) {
        const newHour = isPm ? hour + 12 : hour - 12;
        const updatedDate = this.updateDateTimeValue(currentDateValue, "hour", newHour);
        selectionController.update([updatedDate, ...restDates], { isPending: mode.shouldUsePendingSelection() });
      }
    }
  };
  const keyboard = {
    handleDayKeyDown(event, closeCalendarFn) {
      const { code } = event;
      const date = parseDate(event.target.dataset.date);
      if (!date) return;
      let unit, hStep, vStep, isDisabledFn;
      if (mode.isYearMode()) {
        unit = "year";
        hStep = 1;
        vStep = 3;
        isDisabledFn = disabledDates.isYearDisabled;
      } else if (mode.isMonthMode()) {
        unit = "month";
        hStep = 1;
        vStep = 3;
        isDisabledFn = disabledDates.isMonthDisabled;
      } else {
        unit = "day";
        hStep = 1;
        vStep = 7;
        isDisabledFn = disabledDates.isDateDisabled;
      }
      let newDate, navDirection;
      switch (code) {
        case "ArrowLeft":
          event.preventDefault();
          newDate = date.subtract(hStep, unit);
          navDirection = -hStep;
          break;
        case "ArrowRight":
          event.preventDefault();
          newDate = date.add(hStep, unit);
          navDirection = hStep;
          break;
        case "ArrowUp":
          event.preventDefault();
          newDate = date.subtract(vStep, unit);
          navDirection = -vStep;
          break;
        case "ArrowDown":
          event.preventDefault();
          newDate = date.add(vStep, unit);
          navDirection = vStep;
          break;
        case "Enter":
        case "Space":
          event.preventDefault();
          pickedDate.value = date;
          return;
        default:
          return;
      }
      if (isDisabledFn(newDate)) {
        const nextEnabled = disabledDates.findNextEnabled(date, navDirection, unit);
        if (!nextEnabled) return;
        newDate = nextEnabled;
      }
      if (mode.isYearMode()) {
        const currentDecade = Math.floor(currentDate.value.year() / 10) * 10;
        const newDecade = Math.floor(newDate.year() / 10) * 10;
        if (currentDecade !== newDecade) currentDate.value = newDate;
      } else if (mode.isMonthMode()) {
        if (!newDate.isSame(currentDate.value, "year")) currentDate.value = newDate;
      } else {
        const monthsCount = visibleCalendarCount();
        const firstVisible = currentDate.value.startOf("month");
        const lastVisibleEnd = currentDate.value.add(monthsCount - 1, "month").endOf("month");
        if (newDate.isBefore(firstVisible, "day")) {
          currentDate.value = newDate.startOf("month");
        } else if (newDate.isAfter(lastVisibleEnd, "day")) {
          currentDate.value = newDate.subtract(monthsCount - 1, "month").startOf("month");
        }
      }
      focusedDate.value = newDate;
    },
    handleTimeKeyDown(event, type, closeCalendarFn) {
      const { key, ctrlKey, metaKey, altKey } = event;
      if (ctrlKey || metaKey || altKey) return;
      if (key === "Tab" || key === "Escape") return;
      if (key === "Enter") {
        event.preventDefault();
        this.commitOrClose(closeCalendarFn);
        return;
      }
      if (key === "ArrowLeft" || key === "ArrowRight") {
        event.preventDefault();
        time.moveSegment(event.target, key === "ArrowLeft" ? -1 : 1);
        return;
      }
      if (!this.isTimeInputKey(key)) return;
      event.preventDefault();
      if (key === "ArrowUp") time.handleInput(type, "increment");
      else if (key === "ArrowDown") time.handleInput(type, "decrement");
      else if (key === "Backspace" || key === "Delete") time.handleInput(type, "backspace");
      else if (/^[0-9]$/.test(key)) time.handleInput(type, "digit", parseInt(key, 10));
    },
    commitOrClose(closeCalendarFn) {
      if (mode.isConfirmMode()) {
        if (parts.applyButton && !parts.applyButton.disabled) {
          selectionController.apply();
          closeCalendarFn?.();
        }
      } else {
        closeCalendarFn?.();
      }
    },
    isTimeInputKey(key) {
      return /^[0-9]$/.test(key) || key === "ArrowUp" || key === "ArrowDown" || key === "Backspace" || key === "Delete";
    },
    handleAmPmKeyDown(event, closeCalendarFn) {
      const { key } = event;
      if (key === "Enter") {
        event.preventDefault();
        this.commitOrClose(closeCalendarFn);
        return;
      }
      if (key === "Tab") return;
      const arrows = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
      let next;
      if (arrows.includes(key)) next = time.getPeriod() === "pm" ? "am" : "pm";
      else if (key.toLowerCase() === "a") next = "am";
      else if (key.toLowerCase() === "p") next = "pm";
      event.preventDefault();
      if (!next) return;
      time.handleAmPmToggle(next === "pm");
      time.focusPeriod(next);
    }
  };
  function initializeSelection() {
    let current = [];
    if (config.range.value) {
      const start = parseDate(parts.inputStart?.value);
      const end = parseDate(parts.inputEnd?.value);
      current = [start, end].filter(Boolean);
    } else if (config.multiple.value) {
      const inputs = Array.from(parts.root.querySelectorAll('[data-part="input"]'));
      current = inputs.map((input) => parseDate(input.value)).filter(Boolean);
    } else {
      const date = parseDate(parts.input?.value);
      current = date ? [date] : [];
    }
    selection.value = { current, pending: null };
  }
  const selectionKey = (dates) => dates.map((d) => d.valueOf()).join(",");
  function updateFromInputs() {
    const sel = selectionController.getFromInputs();
    const selectionChanged = selectionKey(sel) !== selectionKey(selection.value.current);
    if (!selectionChanged) return;
    selectionController.update(sel, { isPending: false });
    if (sel.length === 0) return;
    if (!currentDate.value) return;
    const selectedDate = sel[0];
    let needsNavigation;
    if (mode.isYearMode()) {
      needsNavigation = Math.floor(selectedDate.year() / 10) !== Math.floor(currentDate.value.year() / 10);
    } else if (mode.isMonthMode()) {
      needsNavigation = !selectedDate.isSame(currentDate.value, "year");
    } else {
      const monthsCount = visibleCalendarCount();
      const lastVisibleMonth = currentDate.value.add(monthsCount - 1, "month");
      needsNavigation = selectedDate.isBefore(currentDate.value, "month") || selectedDate.isAfter(lastVisibleMonth, "month");
    }
    if (needsNavigation) currentDate.value = selectedDate;
  }
  function attachCalendarEffects(options = {}) {
    const { onAutoClose, typeableInputController, onSelectionChange, onNavigate } = options;
    env.effect("sync-from-inputs", () => {
      env.untrack(() => updateFromInputs());
    }, { onUpdated: true });
    env.effect("sync-header", () => {
      if (!open.value) return;
      env.untrack(() => calendar.renderHeader());
    }, { onUpdated: true });
    env.effect("granularity-attribute", () => {
      parts.root.setAttribute("data-granularity", config.granularity.value);
    }, { onUpdated: true });
    env.effect("disabled-dates-init", () => {
      config.disabledDates.value;
      const changed = disabledDates.initialize();
      if (changed && open.value) {
        calendar.render();
      }
    }, { onUpdated: true });
    env.effect("handle-single-pick", () => {
      if (!mode.isSingleMode()) return;
      const picked = pickedDate.value;
      if (!picked) return;
      selectionController.handleSinglePick(picked);
    });
    env.effect("handle-multiple-pick", () => {
      if (!mode.isMultipleMode()) return;
      const picked = pickedDate.value;
      if (!picked) return;
      selectionController.handleMultiplePick(picked);
    });
    env.effect("handle-range-pick", () => {
      if (!mode.isRangeMode()) return;
      const picked = pickedDate.value;
      if (!picked) return;
      selectionController.handleRangePick(picked);
    });
    if (onAutoClose) {
      let prevIsComplete = null;
      env.effect("auto-close", () => {
        if (!open.value) {
          prevIsComplete = null;
          return;
        }
        const closeMode = mode.getEffectiveCloseMode();
        if (closeMode !== CloseMode.AUTO) return;
        selection.value;
        const userPicked = pickedDate.value != null;
        const typeableInput = typeableInputController?.getInput?.();
        const isComplete = selectionController.shouldClose(typeableInput);
        if (prevIsComplete === null) {
          prevIsComplete = isComplete;
          return;
        }
        if (userPicked && isComplete && !prevIsComplete) {
          prevIsComplete = null;
          onAutoClose();
          return;
        }
        prevIsComplete = isComplete;
      });
    }
    env.effect("sync-inputs", () => {
      const sel = selection.value;
      if (sel.pending !== null) return;
      selectionController.syncInputValues(sel.current);
    }, { onUpdated: true });
    if (onSelectionChange) {
      let emitInitialized = false;
      let previousDates = null;
      env.effect("emit-change", () => {
        const sel = selection.value;
        if (sel.pending !== null) return;
        const currentDates = sel.current;
        if (!emitInitialized) {
          emitInitialized = true;
          previousDates = currentDates;
          return;
        }
        const same = currentDates.length === previousDates.length && currentDates.every((d, i) => d.isSame(previousDates[i], "day"));
        if (!same) {
          const prev = previousDates;
          previousDates = currentDates;
          onSelectionChange(currentDates, prev);
        }
      });
    }
    env.effect("update-apply-button", () => {
      if (!mode.isConfirmMode()) return;
      if (!parts.applyButton) return;
      const canApply = selectionController.canApply(selection.value);
      parts.applyButton.disabled = !canApply;
    }, { onUpdated: true });
    env.effect("render-calendar", () => {
      if (!open.value) return;
      currentDate.value;
      focusedDate.value;
      selection.value;
      config.min.value;
      config.max.value;
      config.today.value;
      calendar.render();
    });
    if (onNavigate) {
      let navInitialized = false;
      let previousNav = null;
      env.effect("emit-navigate", () => {
        const date = currentDate.value;
        if (!date) return;
        if (!navInitialized) {
          navInitialized = true;
          previousNav = date;
          return;
        }
        let changed;
        if (mode.isYearMode()) {
          changed = Math.floor(date.year() / 10) !== Math.floor(previousNav.year() / 10);
        } else if (mode.isMonthMode()) {
          changed = !date.isSame(previousNav, "year");
        } else {
          changed = !date.isSame(previousNav, "month");
        }
        if (changed) {
          previousNav = date;
          onNavigate(date);
        }
      });
    }
    env.effect("render-timepicker", () => {
      if (!mode.hasTimePicker()) return;
      if (!open.value) return;
      currentDate.value;
      selection.value;
      const sel = selection.value.pending || selection.value.current;
      const date = sel[0];
      time.updateInputs(date);
    }, { onUpdated: true });
    env.effect("manage-focus", () => {
      const focused = focusedDate.value;
      if (!focused) return;
      const dateStr = focused.format("YYYY-MM-DD");
      const dayButton = pickCanonicalDayCell(parts.grids.querySelectorAll(`[data-date="${dateStr}"]`));
      if (dayButton) dayButton.focus({ preventScroll: true });
    });
    env.effect("clear-picked-date", () => {
      if (!pickedDate.value) return;
      queueMicrotask(() => {
        pickedDate.value = null;
      });
    });
  }
  function attachCalendarBindings(options = {}) {
    const { closeCalendarFn } = options;
    const form = parts.root.closest("form");
    if (form) {
      env.on(form, "reset", () => {
        env.timeout.raf("form-reset", () => updateFromInputs());
      });
    }
    env.on(parts.prevMonthButton, "click", () => navigation.prevPeriod());
    env.on(parts.nextMonthButton, "click", () => navigation.nextPeriod());
    if (parts.prevYearButton) {
      env.on(parts.prevYearButton, "click", () => navigation.prevYear());
    }
    if (parts.nextYearButton) {
      env.on(parts.nextYearButton, "click", () => navigation.nextYear());
    }
    if (parts.yearSelect) {
      env.on(parts.yearSelect, "input", (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigation.setYear(e.target.value);
      });
      env.on(parts.yearSelect, "change", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    }
    if (parts.monthSelect) {
      env.on(parts.monthSelect, "input", (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigation.setMonth(e.target.value);
      });
      env.on(parts.monthSelect, "change", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    }
    env.on(parts.grids, "click", (e, target) => {
      const date = parseDate(target.dataset.date);
      pickedDate.value = date;
    }, { delegate: "button[data-date]" });
    env.on(parts.grids, "keydown", (e, target) => {
      keyboard.handleDayKeyDown(e, closeCalendarFn);
    }, { delegate: "button[data-date]" });
    [
      [parts.hourInput, "hour"],
      [parts.minuteInput, "minute"],
      [parts.secondInput, "second"]
    ].forEach(([input, type]) => {
      if (!input) return;
      env.on(input, "keydown", (e) => keyboard.handleTimeKeyDown(e, type, closeCalendarFn));
      env.on(input, "focus", () => time.setSegmentTabStop(input));
    });
    if (parts.amPmOptions?.length) {
      parts.amPmOptions.forEach((option) => {
        env.on(option, "click", (e) => {
          e.preventDefault();
          time.handleAmPmToggle(option.dataset.period === "pm");
          option.focus();
        });
        env.on(option, "keydown", (e) => keyboard.handleAmPmKeyDown(e, closeCalendarFn));
      });
    }
    if (parts.cancelButton) {
      env.on(parts.cancelButton, "click", () => {
        selectionController.cancel();
        closeCalendarFn?.();
      });
    }
    if (parts.applyButton) {
      env.on(parts.applyButton, "click", () => {
        selectionController.apply();
        closeCalendarFn?.();
      });
    }
  }
  return {
    // Signals
    open,
    pickedDate,
    currentDate,
    focusedDate,
    selection,
    // Controllers
    disabledDates,
    mode,
    selectionController,
    navigation,
    calendar,
    time,
    keyboard,
    // Initialization
    initializeSelection,
    attachCalendarEffects,
    attachCalendarBindings,
    // API methods
    formatSelectionValue(dates) {
      if (mode.isRangeMode()) {
        return dates.length === 2 ? dates.map((d) => d.format("YYYY-MM-DD")) : null;
      }
      if (mode.isMultipleMode()) {
        return dates.map((d) => d.format("YYYY-MM-DD"));
      }
      return dates[0] ? dates[0].format("YYYY-MM-DD") : null;
    },
    getSelectedValue() {
      return this.formatSelectionValue(selection.value.current);
    },
    select(date) {
      const parsed = typeof date === "string" ? parseDate(date) : date;
      if (!parsed) return false;
      pickedDate.value = parsed;
      return true;
    },
    clear() {
      if (selection.value.current.length === 0) return false;
      selectionController.update([]);
      return true;
    },
    navigateTo(date) {
      const parsed = typeof date === "string" ? parseDate(date) : date;
      if (!parsed) return false;
      currentDate.value = parsed;
      return true;
    },
    updateFromInputs
  };
}

// js/components/calendar/calendar.js
var hook9 = defineComponent("calendar", (element, env) => {
  const config = env.config(element, {
    min: { type: "string", default: null },
    max: { type: "string", default: null },
    today: { type: "string", default: null },
    disabledDates: { type: "string", default: null },
    weekStart: { type: "number", default: 0 },
    range: { type: "boolean", default: false },
    multiple: { type: "boolean", default: false },
    granularity: { type: "enum", values: ["day", "month", "year"], default: "day" },
    hideOutsideDays: { type: "boolean", default: false },
    allowDeselect: { type: "boolean", default: true },
    locale: { type: "string", default: "en" }
  });
  const parts = env.parts(element, {
    input: { selector: '[data-part="input"]', required: false },
    inputStart: { selector: '[data-part="input-start"]', required: false },
    inputEnd: { selector: '[data-part="input-end"]', required: false },
    // Inline Calendar emits a single grid (Calendar.ex doesn't yet support
    // multi-month). The multi-shape declarations stay so the shared core can
    // treat both inputs uniformly.
    grids: { selector: '[data-part="grids"]', required: true },
    calendarTitles: { selector: '[data-part="calendar-title"]', multiple: true },
    calendars: { selector: '[data-part="calendar"]', required: true, multiple: true },
    weekdays: { selector: '[data-part="weekdays"]', required: true, multiple: true },
    prevMonthButton: { selector: '[data-part="prev-month"]', required: true },
    nextMonthButton: { selector: '[data-part="next-month"]', required: true },
    prevYearButton: { selector: '[data-part="prev-year"]', required: false },
    nextYearButton: { selector: '[data-part="next-year"]', required: false },
    yearSelect: { selector: '[data-part="year-select"]', required: false },
    monthSelect: { selector: '[data-part="month-select"]', required: false },
    dayTemplate: { selector: '[data-part="day-template"]', required: true },
    cancelButton: { selector: '[data-part="cancel-button"]', required: false },
    applyButton: { selector: '[data-part="apply-button"]', required: false }
  });
  const core = createCalendarCore(element, config, parts, env);
  core.initializeSelection();
  core.open.value = true;
  core.currentDate.value = core.navigation.findInitialDate();
  core.attachCalendarEffects({
    // No auto-close for an inline calendar.
    onAutoClose: null,
    onSelectionChange(currentDates, previousDates) {
      env.emit("changed", {
        value: core.formatSelectionValue(currentDates),
        previousValue: core.formatSelectionValue(previousDates)
      });
    },
    onNavigate(date) {
      env.emit("navigate", { date: date.format("YYYY-MM-DD") });
    }
  });
  core.attachCalendarBindings({
    // No close function for inline calendar.
    closeCalendarFn: null
  });
  return {
    get value() {
      return core.getSelectedValue();
    },
    select(date) {
      return core.select(date);
    },
    clear() {
      return core.clear();
    },
    navigateTo(date) {
      return core.navigateTo(date);
    }
  };
});

// js/components/date_picker/date_picker.js
var hook10 = defineComponent("datepicker", (element, env) => {
  const config = env.config(element, {
    min: { type: "string", default: null },
    max: { type: "string", default: null },
    today: { type: "string", default: null },
    disabledDates: { type: "string", default: null },
    displayFormat: { type: "string", default: "%b %-d, %Y" },
    weekStart: { type: "number", default: 0 },
    range: { type: "boolean", default: false },
    multiple: { type: "boolean", default: false },
    timePicker: { type: "boolean", default: false },
    close: { type: "enum", values: ["auto", "manual", "confirm"], default: "auto" },
    hourCycle: { type: "enum", values: ["h12", "h23"], default: "h12" },
    granularity: { type: "enum", values: ["day", "month", "year"], default: "day" },
    hideOutsideDays: { type: "boolean", default: false },
    typeable: { type: "boolean", default: false },
    inputFormat: { type: "string", default: "mm/dd/yyyy" },
    allowDeselect: { type: "boolean", default: true },
    clearable: { type: "boolean", default: false },
    locale: { type: "string", default: "en" }
  });
  const parts = env.parts(element, {
    toggle: { selector: '[data-part="toggle"]', required: false },
    toggleText: { selector: '[data-part="toggle-text"]', required: false },
    clear: { selector: '[data-part="clear"]', required: false },
    input: { selector: '[data-part="input"]', required: false },
    inputStart: { selector: '[data-part="input-start"]', required: false },
    inputEnd: { selector: '[data-part="input-end"]', required: false },
    typeableInput: { selector: '[data-part="typeable-input"]', required: false },
    typeableTextInput: { selector: '[data-part="typeable-text-input"]', required: false },
    wrapper: { selector: '[data-part="wrapper"]', required: true },
    // Multi-month contract: Elixir renders one calendars/weekdays/calendarTitles
    // triple per visible grid, each tagged with `data-month-offset="0..N-1"`.
    // The grids count is read from `parts.calendars.length`; the offset is read
    // off each element in the renderer to compute its display month.
    grids: { selector: '[data-part="grids"]', required: true },
    calendarTitles: { selector: '[data-part="calendar-title"]', multiple: true },
    calendars: { selector: '[data-part="calendar"]', required: true, multiple: true },
    weekdays: { selector: '[data-part="weekdays"]', required: true, multiple: true },
    prevMonthButton: { selector: '[data-part="prev-month"]', required: true },
    nextMonthButton: { selector: '[data-part="next-month"]', required: true },
    prevYearButton: { selector: '[data-part="prev-year"]', required: false },
    nextYearButton: { selector: '[data-part="next-year"]', required: false },
    yearSelect: { selector: '[data-part="year-select"]', required: false },
    monthSelect: { selector: '[data-part="month-select"]', required: false },
    dayTemplate: { selector: '[data-part="day-template"]', required: true },
    hourInput: { selector: '[data-part="hour-input"]', required: false },
    minuteInput: { selector: '[data-part="minute-input"]', required: false },
    secondInput: { selector: '[data-part="second-input"]', required: false },
    cancelButton: { selector: '[data-part="cancel-button"]', required: false },
    applyButton: { selector: '[data-part="apply-button"]', required: false },
    amPmGroup: { selector: '[data-part="am-pm"]', required: false },
    amPmOptions: { selector: '[data-part="am-pm-option"]', required: false, multiple: true },
    preset: { selector: '[data-part="preset"]', multiple: true }
  });
  const core = createCalendarCore(element, config, parts, env);
  overlayControls(env, element, core.open);
  function parseInputFormat(formatStr) {
    const format = formatStr.toLowerCase();
    const match = format.match(/^(dd|mm|yyyy)(.)(?:dd|mm|yyyy)\2(?:dd|mm|yyyy)$/);
    if (!match) return null;
    const sep = match[2];
    const segments = format.split(sep);
    if (segments.slice().sort().join() !== "dd,mm,yyyy") return null;
    const segLens = segments.map((s) => s === "yyyy" ? 4 : 2);
    const totalLength = segLens.reduce((a, b) => a + b, 0) + 2;
    const autoInsertAfter = [];
    let cum = 0;
    for (let i = 0; i < segments.length - 1; i++) {
      cum += segLens[i];
      autoInsertAfter.push(cum + i);
    }
    return { segments, sep, segLens, totalLength, autoInsertAfter };
  }
  const typeableInput = {
    parse(value) {
      if (!value) return null;
      const fmt = parseInputFormat(config.inputFormat.value);
      if (!fmt) return null;
      const inputParts = value.split(fmt.sep);
      if (inputParts.length !== 3) return null;
      const values = {};
      for (let i = 0; i < fmt.segments.length; i++) {
        values[fmt.segments[i]] = parseInt(inputParts[i], 10);
      }
      const { mm: month, dd: day, yyyy: year } = values;
      if (isNaN(month) || isNaN(day) || isNaN(year)) return null;
      if (month < 1 || month > 12) return null;
      if (day < 1 || day > 31) return null;
      if (year < 1e3 || year > 9999) return null;
      const dateString = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      const date = parseDate(dateString);
      if (!date || !date.isValid()) return null;
      if (date.month() + 1 !== month || date.date() !== day || date.year() !== year) return null;
      return date;
    },
    format(date) {
      if (!date || !date.isValid()) return "";
      const fmt = parseInputFormat(config.inputFormat.value);
      if (!fmt) return "";
      const month = String(date.month() + 1).padStart(2, "0");
      const day = String(date.date()).padStart(2, "0");
      const year = String(date.year());
      const partMap = { mm: month, dd: day, yyyy: year };
      return fmt.segments.map((s) => partMap[s]).join(fmt.sep);
    },
    syncFromCalendar(date) {
      if (!config.typeable.value || !parts.typeableTextInput) return;
      if (document.activeElement === parts.typeableTextInput) return;
      parts.typeableTextInput.value = date ? this.format(date) : "";
    },
    syncToCalendar() {
      if (!config.typeable.value || !parts.typeableTextInput) return;
      const date = this.parse(parts.typeableTextInput.value);
      const min2 = config.min.value ? parseDate(config.min.value) : null;
      const max2 = config.max.value ? parseDate(config.max.value) : null;
      const invalid = !date || min2 && date.isBefore(min2, "day") || max2 && date.isAfter(max2, "day") || core.disabledDates.isDateDisabled(date);
      if (invalid) {
        core.selectionController.update([]);
        return;
      }
      core.pickedDate.value = date;
      core.currentDate.value = date;
    },
    autoInsertSeparator() {
      const input = parts.typeableTextInput;
      if (!input) return;
      const fmt = parseInputFormat(config.inputFormat.value);
      if (!fmt) return;
      const value = input.value;
      if (input.selectionStart !== value.length) return;
      if (value.endsWith(fmt.sep)) return;
      const currentSegments = value.split(fmt.sep);
      const segIndex = currentSegments.length - 1;
      if (segIndex >= fmt.segments.length - 1) return;
      const currentSeg = currentSegments[segIndex];
      if (currentSeg.length === fmt.segLens[segIndex]) {
        input.value = value + fmt.sep;
      }
    },
    handleBlur() {
      const date = this.parse(parts.typeableTextInput.value);
      if (date) parts.typeableTextInput.value = this.format(date);
    },
    getInput() {
      return parts.typeableTextInput;
    }
  };
  const typeableKeyboard = {
    handleKeyDown(event) {
      if (isImeComposing(event)) return;
      const { key, ctrlKey, metaKey, altKey } = event;
      if (ctrlKey || metaKey || altKey) return;
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ];
      if (allowedKeys.includes(key)) return;
      const fmt = parseInputFormat(config.inputFormat.value);
      const maxLen = fmt ? fmt.totalLength : 10;
      const sep = fmt ? fmt.sep : "/";
      const input = event.target;
      if (input.value.length >= maxLen && input.selectionStart === input.selectionEnd) {
        event.preventDefault();
        return;
      }
      if (/^[0-9]$/.test(key)) return;
      if (key === sep) {
        const pos = input.selectionStart;
        if (pos > 0 && input.value[pos - 1] === sep) {
          event.preventDefault();
          return;
        }
        return;
      }
      event.preventDefault();
    }
  };
  let resolvedPlacement = config.typeable.value ? "bottom-end" : "bottom-start";
  const popper = floating(parts.toggle, parts.wrapper, {
    placement: resolvedPlacement,
    strategy: "fixed",
    // No size() clamp here, unlike the listbox panels: the calendar has no scrollable
    // region, so it cannot shrink to fit. flip() therefore measures its true height and
    // moves the popup to whichever side can hold it.
    middleware: [
      offset2(PANEL_GAP),
      flip2({ fallbackAxisSideDirection: "start", padding: VIEWPORT_PADDING }),
      shift2({ padding: VIEWPORT_PADDING, limiter: limitShift2() })
    ],
    onPlacement: (placement) => {
      resolvedPlacement = placement;
    },
    signal: env.abortSignal
  });
  const anim = transition(parts.wrapper, {
    ...slideFromPlacement(() => resolvedPlacement),
    duration: 0.15,
    easing: "ease-out",
    signal: env.abortSignal
  });
  const trap = focusTrap(parts.wrapper, {
    initial: () => parts.wrapper.querySelector("[autofocus]"),
    signal: env.abortSignal
  });
  function closeCalendar({ focusToggle = true } = {}) {
    core.open.value = false;
    if (focusToggle) parts.toggle?.focus({ preventScroll: true });
  }
  core.initializeSelection();
  if (config.typeable.value && core.selection.value.current[0]) {
    const dateToSync = core.selection.value.current[0];
    env.timeout.raf("typeable-init", () => {
      if (config.typeable.value) typeableInput.syncFromCalendar(dateToSync);
    });
  }
  env.onChange(core.open, {
    // Both phases yield to animations. A toggle during that time starts the opposite phase
    // and aborts this one, and what follows an await belongs to whichever phase is current:
    // a superseded close would otherwise hide, unposition and null the picker that just
    // reopened over it.
    async enter(signal) {
      const initialDate = core.navigation.findInitialDate();
      core.currentDate.value = initialDate;
      parts.wrapper.hidden = false;
      parts.root.dataset.open = true;
      parts.toggle?.setAttribute("aria-expanded", "true");
      await popper.attach();
      if (signal?.aborted) return;
      core.calendar.render();
      trap.activate();
      await anim.in();
      if (signal?.aborted) return;
      clearTransitionResidue(parts.wrapper);
      env.emit("opened");
    },
    async exit(signal) {
      delete parts.root.dataset.open;
      parts.toggle?.setAttribute("aria-expanded", "false");
      await anim.out();
      if (signal?.aborted) return;
      parts.wrapper.hidden = true;
      clearTransitionResidue(parts.wrapper);
      popper.detach();
      trap.deactivate();
      core.currentDate.value = null;
      core.focusedDate.value = null;
      env.emit("closed");
    }
  });
  env.effect("expanded-state", () => {
    const isOpen = core.open.value;
    if (isOpen) parts.root.dataset.open = "true";
    else delete parts.root.dataset.open;
    parts.toggle?.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }, { onUpdated: true });
  env.effect("close-when-disabled", () => {
    const disabled = parts.toggle?.disabled || parts.typeableTextInput?.disabled;
    if (!disabled || !core.open.value) return;
    if (core.mode.isConfirmMode()) core.selectionController.cancel();
    closeCalendar({ focusToggle: false });
  }, { onUpdated: true });
  core.attachCalendarEffects({
    onAutoClose: closeCalendar,
    typeableInputController: typeableInput,
    onSelectionChange(currentDates, previousDates) {
      env.emit("changed", {
        value: core.formatSelectionValue(currentDates),
        previousValue: core.formatSelectionValue(previousDates)
      });
    },
    onNavigate(date) {
      env.emit("navigate", { date: date.format("YYYY-MM-DD") });
    }
  });
  env.effect("update-toggle-display", () => {
    if (!parts.toggleText) return;
    const sel = core.selection.value;
    parts.toggleText.textContent = core.selectionController.formatDisplay(sel.current);
  }, { onUpdated: true });
  const clearHasValue = () => {
    if (core.selection.value.current.length > 0) return true;
    if (config.typeable.value && parts.typeableTextInput) {
      return parts.typeableTextInput.value.trim() !== "";
    }
    return false;
  };
  const updateClearVisibility = () => {
    if (!config.clearable.value || !parts.clear) return;
    parts.clear.hidden = !clearHasValue();
  };
  env.effect("clear-button", updateClearVisibility, { onUpdated: true });
  env.effect("sync-typeable-input", () => {
    if (!config.typeable.value) return;
    if (!parts.typeableTextInput) return;
    const sel = core.selection.value;
    const date = sel.current[0];
    typeableInput.syncFromCalendar(date);
  }, { onUpdated: true });
  env.effect("sync-preset-active", () => {
    const presetButtons2 = parts.preset;
    if (!presetButtons2 || presetButtons2.length === 0) return;
    const sel = core.selection.value;
    const current = sel.pending || sel.current;
    for (const button of presetButtons2) {
      const singleValue = button.dataset.presetValue;
      const startValue = button.dataset.presetStart;
      const endValue = button.dataset.presetEnd;
      let isActive = false;
      if (config.range.value && startValue && endValue) {
        const start = parseDate(startValue);
        const end = parseDate(endValue);
        isActive = current.length === 2 && current[0]?.isSame(start, "day") && current[1]?.isSame(end, "day");
      } else if (singleValue) {
        const date = parseDate(singleValue);
        isActive = current.length === 1 && current[0]?.isSame(date, "day");
      }
      if (isActive) button.dataset.active = "";
      else delete button.dataset.active;
    }
  }, { onUpdated: true });
  env.effect("update-popper", () => {
    if (!core.open.value) return;
    void core.currentDate.value;
    void core.focusedDate.value;
    void core.selection.value;
    popper.update();
  });
  core.attachCalendarBindings({
    closeCalendarFn: closeCalendar
  });
  if (parts.toggle) {
    const toggleOpen = () => {
      core.open.value = !core.open.value;
    };
    env.on(parts.toggle, "click", (e) => {
      if (e.target.closest('[data-part="clear"]')) return;
      toggleOpen();
    });
    env.on(parts.toggle, "keydown", (e) => {
      if (e.code === "Enter" || e.code === "Space") {
        e.preventDefault();
        toggleOpen();
      }
    });
    env.on(parts.toggle, "blur", () => {
      if (!core.open.value) return;
      env.timeout.raf("toggle-blur", () => {
        const { wrapper, root } = parts;
        const active = document.activeElement;
        if (!wrapper.contains(active) && !root.contains(active)) {
          closeCalendar({ focusToggle: false });
        }
      });
    });
  }
  if (config.clearable.value) {
    const performClear = () => {
      core.clear();
      if (config.typeable.value) {
        if (parts.typeableTextInput) parts.typeableTextInput.value = "";
        parts.typeableTextInput?.focus();
      } else {
        parts.toggle?.focus();
      }
      updateClearVisibility();
    };
    env.on(element, "mousedown", (e) => {
      e.preventDefault();
      e.stopPropagation();
    }, { delegate: '[data-part="clear"]', capture: true });
    env.on(element, "click", (e) => {
      e.preventDefault();
      performClear();
    }, { delegate: '[data-part="clear"]', capture: true });
    env.on(element, "keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation();
        performClear();
      }
    }, { delegate: '[data-part="clear"]', capture: true });
    if (config.typeable.value && parts.typeableTextInput) {
      env.on(parts.typeableTextInput, "input", updateClearVisibility);
    }
  }
  const presetButtons = parts.preset;
  function isPresetDisabled(button) {
    const singleValue = button.dataset.presetValue;
    const startValue = button.dataset.presetStart;
    const endValue = button.dataset.presetEnd;
    if (config.range.value && startValue && endValue) {
      const start = parseDate(startValue);
      const end = parseDate(endValue);
      if (!start || !end) return true;
      return core.disabledDates.isDateDisabled(start) || core.disabledDates.isDateDisabled(end);
    } else if (singleValue) {
      const date = parseDate(singleValue);
      if (!date) return true;
      return core.disabledDates.isDateDisabled(date);
    }
    return true;
  }
  function syncPresetDisabledState() {
    if (!presetButtons || presetButtons.length === 0) return;
    for (const button of presetButtons) {
      if (isPresetDisabled(button)) button.dataset.disabled = "";
      else delete button.dataset.disabled;
    }
  }
  if (presetButtons && presetButtons.length > 0) {
    syncPresetDisabledState();
    for (const button of presetButtons) {
      env.on(button, "click", () => {
        if (isPresetDisabled(button)) return;
        const startValue = button.dataset.presetStart;
        const endValue = button.dataset.presetEnd;
        const singleValue = button.dataset.presetValue;
        if (config.range.value && startValue && endValue) {
          const start = parseDate(startValue);
          const end = parseDate(endValue);
          if (!start || !end) return;
          const isPending = core.mode.isConfirmMode();
          core.selectionController.update([start, end], { isPending });
          core.currentDate.value = start;
          if (!isPending && config.close.value === "auto") {
            closeCalendar();
          }
        } else if (singleValue) {
          const date = parseDate(singleValue);
          if (!date) return;
          core.currentDate.value = date;
          core.pickedDate.value = date;
        }
      });
    }
  }
  if (parts.typeableTextInput) {
    env.on(parts.typeableTextInput, "input", (e) => {
      if (e.inputType === "insertText") typeableInput.autoInsertSeparator();
      typeableInput.syncToCalendar();
    });
    env.on(parts.typeableTextInput, "blur", () => typeableInput.handleBlur());
    env.on(parts.typeableTextInput, "keydown", (e) => typeableKeyboard.handleKeyDown(e));
  }
  dismissable(env, {
    open: core.open,
    contains: (node) => !!parts.wrapper?.contains(node) || !!parts.toggle?.contains(node) || !!parts.typeableInput?.contains(node),
    onDismiss: (reason) => {
      if (core.mode.isConfirmMode()) core.selectionController.cancel();
      closeCalendar({ focusToggle: reason === "escape" });
    }
  });
  return {
    get value() {
      return core.getSelectedValue();
    },
    get isOpen() {
      return core.open.value;
    },
    open() {
      if (core.open.value) return false;
      core.open.value = true;
      return true;
    },
    close() {
      if (!core.open.value) return false;
      closeCalendar();
      return true;
    },
    toggle() {
      if (core.open.value) {
        closeCalendar();
      } else {
        core.open.value = true;
      }
      return core.open.value;
    },
    select(date) {
      return core.select(date);
    },
    clear() {
      return core.clear();
    },
    navigateTo(date) {
      return core.navigateTo(date);
    }
  };
});

// js/components/autocomplete/autocomplete.js
var NavigationDirection3 = { NEXT: "next", PREV: "prev", FIRST: "first", LAST: "last" };
var KeyboardActions3 = {
  SELECT: "select",
  NAVIGATE_DOWN: "navigateDown",
  NAVIGATE_UP: "navigateUp",
  HOME: "home",
  END: "end"
};
var hook11 = defineComponent("autocomplete", (element, env) => {
  const config = env.config(element, {
    searchThreshold: { type: "number", default: 0 },
    searchMode: { type: "enum", default: "contains", values: ["contains", "starts-with", "exact"] },
    openOnFocus: { type: "boolean", default: false },
    noResultsText: { type: "string", default: 'No results found for "%{query}".' },
    onSearch: { type: "string", default: null },
    debounceMs: { type: "number", default: 200 },
    clearable: { type: "boolean", default: false }
  });
  const open = env.signal(false, "open");
  const highlighted = env.signal(-1, "highlighted");
  const query = env.signal(element.querySelector('[data-part="input"]')?.value || "", "query");
  const loading = env.signal(false, "loading");
  const appliedFilter = env.signal("", "appliedFilter");
  const selectedValue = env.signal(null, {
    name: "selectedValue",
    from: () => element.querySelector('[data-part="option"][data-selected]')?.dataset.value ?? null
  });
  const parts = env.parts(element, {
    fieldRoot: { selector: '[data-part="field-root"]', required: true },
    field: { selector: '[data-part="field"]', required: true },
    input: { selector: '[data-part="input"]', required: true },
    hiddenInput: { selector: '[data-part="hidden-input"]', required: true },
    listbox: { selector: '[data-part="listbox"]', required: true },
    optionsList: { selector: '[data-part="options-list"]', required: true },
    emptyMessage: { selector: '[data-part="empty-message"]', required: true },
    emptyState: { selector: '[data-part="empty-state"]', required: false },
    loading: { selector: '[data-part="loading"]', required: true },
    clearButton: { selector: '[data-part="clear-button"]', required: false }
  });
  let suppressNextFocusOpen = false;
  const getOptionElements = () => Array.from(element.querySelectorAll('[data-part="option"]'));
  const getAllOptions = () => getOptionElements().map((el, index) => ({
    el,
    index,
    value: el.dataset.value,
    label: el.dataset.label || "",
    visible: !el.hidden,
    disabled: isDisabled(el)
  }));
  const getVisibleOptions = () => getAllOptions().filter((o) => o.visible && !o.disabled);
  const findOptionByValue = (value) => getAllOptions().find((o) => o.value === value) || null;
  const ui = {
    formatNoResults(q) {
      return config.noResultsText.value.replace("%{query}", q);
    },
    setLoading(isLoading) {
      loading.value = isLoading;
      parts.loading.hidden = !isLoading;
      if (isLoading) {
        parts.optionsList.hidden = true;
        parts.emptyMessage.hidden = true;
        if (parts.emptyState) parts.emptyState.hidden = true;
      }
    },
    showEmpty(q) {
      if (parts.emptyState) {
        parts.emptyState.hidden = false;
        parts.emptyMessage.hidden = true;
      } else {
        parts.emptyMessage.hidden = false;
        parts.emptyMessage.textContent = this.formatNoResults(q);
      }
      parts.optionsList.hidden = true;
    },
    hideEmpty() {
      parts.emptyMessage.hidden = true;
      if (parts.emptyState) parts.emptyState.hidden = true;
      parts.optionsList.hidden = false;
    },
    showError(message) {
      parts.emptyMessage.hidden = false;
      parts.emptyMessage.textContent = message;
      if (parts.emptyState) parts.emptyState.hidden = true;
      parts.optionsList.hidden = true;
    },
    scrollToOption(index, { centered = false } = {}) {
      if (index < 0) return;
      const opt = getAllOptions()[index];
      if (opt?.el) {
        opt.el.scrollIntoView({ block: centered ? "center" : "nearest" });
      }
    }
  };
  const selection = {
    apply(value, label) {
      const previousValue = selectedValue.value;
      parts.input.value = label;
      parts.hiddenInput.value = value;
      query.value = label;
      selectedValue.value = value;
      env.emitNative(parts.hiddenInput, ["change"]);
      env.emit("changed", { value, previousValue, label });
      open.value = false;
      suppressNextFocusOpen = true;
      parts.input.focus();
    },
    selectByIndex(index) {
      const opt = getAllOptions()[index];
      if (!opt || opt.disabled) return false;
      this.apply(opt.value, opt.label);
      return true;
    },
    selectByValue(value) {
      const opt = findOptionByValue(value);
      if (!opt || opt.disabled) return false;
      this.apply(opt.value, opt.label);
      return true;
    },
    clear() {
      if (selectedValue.value === null && query.value === "" && parts.input.value === "") {
        return false;
      }
      const previousValue = selectedValue.value;
      parts.input.value = "";
      parts.hiddenInput.value = "";
      query.value = "";
      selectedValue.value = null;
      appliedFilter.value = "";
      getOptionElements().forEach((el) => {
        el.hidden = false;
      });
      ui.hideEmpty();
      env.emitNative(parts.hiddenInput, ["change"]);
      env.emit("changed", { value: null, previousValue, label: null });
      return true;
    }
  };
  const navigation = {
    navigate(direction) {
      const visible = getVisibleOptions();
      if (!visible.length) return;
      const currentVisibleIdx = highlighted.value === -1 ? -1 : visible.findIndex((o) => o.index === highlighted.value);
      let newVisibleIdx;
      if (currentVisibleIdx === -1) {
        const isForward = direction === NavigationDirection3.NEXT || direction === NavigationDirection3.FIRST;
        newVisibleIdx = isForward ? 0 : visible.length - 1;
      } else {
        switch (direction) {
          case NavigationDirection3.NEXT:
            newVisibleIdx = Math.min(currentVisibleIdx + 1, visible.length - 1);
            break;
          case NavigationDirection3.PREV:
            newVisibleIdx = Math.max(currentVisibleIdx - 1, 0);
            break;
          case NavigationDirection3.FIRST:
            newVisibleIdx = 0;
            break;
          case NavigationDirection3.LAST:
            newVisibleIdx = visible.length - 1;
            break;
        }
      }
      const newOptionIndex = visible[newVisibleIdx]?.index ?? -1;
      highlighted.value = newOptionIndex;
      ui.scrollToOption(newOptionIndex);
    }
  };
  const matchByMode = (text, q, mode) => {
    switch (mode) {
      case "starts-with":
        return text.startsWith(q);
      case "exact":
        return text === q;
      case "contains":
      default:
        return text.includes(q);
    }
  };
  const serverResults = {
    sent: 0,
    error: false,
    highlightPending: false,
    sync() {
      if (!config.onSearch.value || loading.value || this.error || !open.value) return;
      const all = getAllOptions();
      if (all.length === 0) {
        ui.showEmpty(query.value.trim());
        highlighted.value = -1;
        return;
      }
      ui.hideEmpty();
      if (this.highlightPending && highlighted.value === -1) {
        const firstVisible = all.find((o) => o.visible && !o.disabled);
        highlighted.value = firstVisible?.index ?? -1;
        this.highlightPending = false;
      }
    }
  };
  const search = {
    handleInput(rawValue) {
      env.timeout.cancel("search");
      if (rawValue === "") {
        if (selectedValue.value !== null) {
          selection.clear();
        } else {
          query.value = "";
        }
        open.value = false;
        ui.setLoading(false);
        return;
      }
      const trimmed = rawValue.trim();
      if (trimmed.length < config.searchThreshold.value) {
        query.value = rawValue;
        open.value = false;
        ui.setLoading(false);
        return;
      }
      query.value = rawValue;
      open.value = true;
      if (config.onSearch.value) {
        this.handleServer(trimmed);
      } else {
        this.handleClient(trimmed);
      }
    },
    // Visibility only — no highlight, no loading. The search-filter effect calls this
    // after every patch, and moving the highlight there would yank it away from wherever
    // the user had arrowed to. Returns the first selectable visible option, or -1.
    applyFilter(q) {
      const lowerQ = q.toLowerCase();
      let firstVisibleIndex = -1;
      getAllOptions().forEach((opt) => {
        const matches = matchByMode(opt.label.toLowerCase(), lowerQ, config.searchMode.value);
        if (opt.el.hidden !== !matches) opt.el.hidden = !matches;
        if (matches && !opt.disabled && firstVisibleIndex === -1) firstVisibleIndex = opt.index;
      });
      if (firstVisibleIndex === -1) ui.showEmpty(q);
      else ui.hideEmpty();
      return firstVisibleIndex;
    },
    handleClient(q) {
      appliedFilter.value = q;
      this.applyFilter(q);
      ui.setLoading(false);
      highlighted.value = getVisibleOptions()[0]?.index ?? -1;
    },
    handleServer(q) {
      ui.setLoading(true);
      highlighted.value = -1;
      serverResults.error = false;
      serverResults.highlightPending = true;
      env.timeout("search", () => this.triggerServer(q), config.debounceMs.value);
    },
    triggerServer(q) {
      const seq = ++serverResults.sent;
      env.emit("search", {
        query: q,
        id: parts.input.id,
        callback: config.onSearch.value,
        onComplete: () => this.handleSuccess(seq),
        onError: () => this.handleError(seq)
      });
    },
    // A reply for an older search must not end the loading state of a newer one.
    handleSuccess(seq) {
      if (seq !== serverResults.sent) return;
      ui.setLoading(false);
      overlayApi.reposition();
      serverResults.sync();
    },
    handleError(seq) {
      if (seq !== serverResults.sent) return;
      serverResults.error = true;
      ui.setLoading(false);
      ui.showError("Error occurred while searching. Please try again.");
    }
  };
  const keyboard = {
    getAction(key) {
      const map = {
        Enter: KeyboardActions3.SELECT,
        ArrowDown: KeyboardActions3.NAVIGATE_DOWN,
        ArrowUp: KeyboardActions3.NAVIGATE_UP,
        Home: KeyboardActions3.HOME,
        End: KeyboardActions3.END
      };
      return map[key] || null;
    },
    handle(action) {
      const handlers = {
        [KeyboardActions3.SELECT]: () => this.handleSelect(),
        [KeyboardActions3.NAVIGATE_DOWN]: () => this.handleNavigation(true),
        [KeyboardActions3.NAVIGATE_UP]: () => this.handleNavigation(false),
        [KeyboardActions3.HOME]: () => this.handleBoundary(NavigationDirection3.FIRST),
        [KeyboardActions3.END]: () => this.handleBoundary(NavigationDirection3.LAST)
      };
      handlers[action]?.();
    },
    handleSelect() {
      if (open.value && highlighted.value !== -1) {
        selection.selectByIndex(highlighted.value);
      }
    },
    handleNavigation(isDown) {
      if (query.value.length < config.searchThreshold.value) return;
      if (open.value) {
        navigation.navigate(isDown ? NavigationDirection3.NEXT : NavigationDirection3.PREV);
        return;
      }
      open.value = true;
      const visible = getVisibleOptions();
      if (!visible.length) return;
      const selectedIdx = selectedValue.value != null ? visible.findIndex((o) => o.value === selectedValue.value) : -1;
      let targetVisibleIdx;
      if (selectedIdx !== -1) targetVisibleIdx = selectedIdx;
      else targetVisibleIdx = isDown ? 0 : visible.length - 1;
      highlighted.value = visible[targetVisibleIdx].index;
      ui.scrollToOption(highlighted.value);
    },
    handleBoundary(direction) {
      if (open.value) navigation.navigate(direction);
    }
  };
  overlayControls(env, element, open);
  const panel = panelMiddleware({ hugContent: true });
  const overlayApi = overlay(env, {
    anchor: () => parts.fieldRoot,
    panel: () => parts.listbox,
    open,
    placement: "bottom-start",
    strategy: "fixed",
    middleware: panel.middleware,
    closeOnOutsideClick: true,
    refocusOnEscape: () => parts.input,
    duration: 0.15,
    easing: "ease-out",
    onBeforeOpen: () => panel.invalidateCap(),
    onShow: () => {
      if (selectedValue.value == null) return;
      const opt = findOptionByValue(selectedValue.value);
      if (opt && parts.input.value === opt.label) {
        ui.scrollToOption(opt.index, { centered: true });
      }
    },
    onOpen: () => env.emit("opened"),
    onClose: () => {
      highlighted.value = -1;
      env.emit("closed");
    }
  });
  env.on(element, "fluxon:autocomplete:search", (event) => {
    env.lv.pushEventTo(
      element,
      event.detail.callback,
      { query: event.detail.query, id: event.detail.id },
      (reply) => {
        if (reply && reply.error) event.detail.onError?.();
        else event.detail.onComplete?.();
      }
    );
  });
  env.effect("aria-expanded", () => {
    env.attrs(parts.input, { "aria-expanded": String(open.value) });
    env.attrs(element, { "data-expanded": open.value });
  }, { onUpdated: true });
  env.effect("aria-activedescendant", () => {
    const opt = highlighted.value === -1 ? null : getAllOptions()[highlighted.value];
    env.attrs(parts.input, { "aria-activedescendant": opt?.el?.id || null });
  }, { onUpdated: true });
  env.effect("search-filter", () => {
    const q = appliedFilter.value;
    if (config.onSearch.value) return;
    if (!q) return;
    if (getOptionElements().length === 0) return;
    search.applyFilter(q);
  }, { onUpdated: true });
  env.effect("server-results", () => {
    env.untrack(() => serverResults.sync());
  }, { onUpdated: true });
  env.effect("apply-highlight-attrs", () => {
    const hi = highlighted.value;
    getOptionElements().forEach((el, index) => {
      env.attrs(el, { "data-highlighted": index === hi });
    });
  }, { onUpdated: true });
  env.effect("apply-selected-attrs", () => {
    const sel = selectedValue.value;
    getAllOptions().forEach((opt) => {
      const isSelected = opt.value === sel;
      env.attrs(opt.el, {
        "data-selected": isSelected,
        "aria-selected": String(isSelected)
      });
    });
  }, { onUpdated: true });
  env.effect("clear-button-state", () => {
    if (!parts.clearButton) return;
    const enabled2 = selectedValue.value !== null;
    parts.clearButton.hidden = !enabled2;
    env.attrs(parts.clearButton, { "data-enabled": enabled2 });
  }, { onUpdated: true });
  env.attrs(parts.loading, { role: "status", "aria-live": "polite" });
  env.effect("focusout-dismiss", () => {
    if (!open.value) return;
    env.on(element, "focusout", (e) => {
      if (!e.relatedTarget || !element.contains(e.relatedTarget)) {
        env.timeout.raf("focusout-check", () => {
          if (!element.contains(document.activeElement) && open.value) {
            open.value = false;
          }
        });
      }
    });
  });
  focusFieldOnInvalid(env, {
    control: () => parts.hiddenInput,
    field: () => parts.input
  });
  env.on(parts.input, "input", (e) => {
    e.stopPropagation();
    search.handleInput(e.target.value);
  });
  env.on(parts.input, "keydown", (e) => {
    if (isImeComposing(e)) return;
    const action = keyboard.getAction(e.key);
    if (!action) return;
    if (action === KeyboardActions3.SELECT && !open.value) return;
    e.preventDefault();
    keyboard.handle(action);
  });
  env.on(parts.input, "click", () => {
    if (parts.input.disabled) return;
    if (query.value.length >= config.searchThreshold.value && !open.value) {
      open.value = true;
    }
  });
  env.on(parts.input, "focus", () => {
    if (parts.input.disabled) return;
    if (suppressNextFocusOpen) {
      suppressNextFocusOpen = false;
      return;
    }
    if (config.openOnFocus.value && query.value.length >= config.searchThreshold.value && !open.value) {
      open.value = true;
    }
  });
  env.on(parts.input, "change", (e) => {
    e.preventDefault();
    e.stopPropagation();
  });
  env.on(parts.listbox, "mousedown", (e) => {
    if (e.target === parts.listbox || e.target === parts.optionsList) {
      e.preventDefault();
    }
  });
  env.on(parts.listbox, "click", (e, target) => {
    if (!open.value) return;
    e.preventDefault();
    e.stopPropagation();
    const idx = getAllOptions().findIndex((o) => o.el === target);
    if (idx !== -1) selection.selectByIndex(idx);
  }, { delegate: '[data-part="option"]' });
  env.on(parts.listbox, "mouseover", (e, target) => {
    if (!open.value || target.hidden) return;
    if (isDisabled(target)) return;
    const index = getOptionElements().indexOf(target);
    if (index !== -1) highlighted.value = index;
  }, { delegate: '[data-part="option"]' });
  env.on(element, "mousedown", (e) => {
    e.preventDefault();
    e.stopPropagation();
  }, { delegate: '[data-part="clear-button"]' });
  env.on(element, "click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    selection.clear();
    parts.input.focus();
  }, { delegate: '[data-part="clear-button"]' });
  return {
    get value() {
      const v = selectedValue.value;
      if (v == null) return null;
      const opt = findOptionByValue(v);
      return { value: v, label: opt?.label ?? v };
    },
    select(value) {
      if (parts.input.disabled) return false;
      return selection.selectByValue(String(value));
    },
    clear() {
      if (parts.input.disabled) return false;
      return selection.clear();
    },
    setQuery(q) {
      if (parts.input.disabled) return false;
      const text = String(q ?? "");
      parts.input.value = text;
      search.handleInput(text);
      return true;
    },
    get isOpen() {
      return open.value;
    },
    open() {
      if (parts.input.disabled) return false;
      if (open.value) return false;
      open.value = true;
      return true;
    },
    close() {
      if (!open.value) return false;
      open.value = false;
      return true;
    },
    toggle() {
      if (parts.input.disabled) return open.value;
      open.value = !open.value;
      return open.value;
    },
    focus() {
      parts.input.focus();
    }
  };
});

// js/components/utils/number.js
var FORMATTER_CACHE_LIMIT = 64;
var formatterCache = /* @__PURE__ */ new Map();
function formatterFor(locale, format) {
  const key = `${locale}\0${JSON.stringify(format)}`;
  const cached = formatterCache.get(key);
  if (cached) return cached;
  const formatter = new Intl.NumberFormat(locale, format);
  if (formatterCache.size >= FORMATTER_CACHE_LIMIT) formatterCache.clear();
  formatterCache.set(key, formatter);
  return formatter;
}
function formatLocalized(value, locale, format) {
  if (value === null || value === void 0) return "";
  if (typeof value !== "number" || Number.isNaN(value)) return "";
  try {
    return formatterFor(locale, format || {}).format(value);
  } catch {
    return String(value);
  }
}
function canonicalString(value) {
  if (value === null || value === void 0) return "";
  if (typeof value !== "number" || Number.isNaN(value)) return "";
  return value.toString();
}
function clamp2(value, min2, max2) {
  if (value === null || value === void 0) return value;
  let result = value;
  if (typeof min2 === "number" && !Number.isNaN(min2) && result < min2) result = min2;
  if (typeof max2 === "number" && !Number.isNaN(max2) && result > max2) result = max2;
  return result;
}
function decimalPlaces(n) {
  if (!Number.isFinite(n)) return 0;
  const s = n.toString();
  const expMatch = s.match(/e-(\d+)$/i);
  if (expMatch) return parseInt(expMatch[1], 10);
  const dot = s.indexOf(".");
  return dot === -1 ? 0 : s.length - dot - 1;
}
function parseAttr(input, fallback = null) {
  if (input === null || input === void 0 || input === "") return fallback;
  if (input === "any") return "any";
  const n = parseFloat(input);
  return Number.isNaN(n) ? fallback : n;
}

// js/components/number_input/parse.js
var UNICODE_MINUS_SIGNS = ["\u2212", "\uFF0D", "\u2012", "\u2013", "\u2014", "\uFE63"];
var UNICODE_PLUS_SIGNS = ["\uFF0B", "\uFE62"];
var PERMILLE_SYMBOLS = ["\u2030", "\u0609"];
var MINUS_REGEX = new RegExp(`[\\-${UNICODE_MINUS_SIGNS.join("")}]`, "gu");
var PLUS_REGEX = new RegExp(`[\\+${UNICODE_PLUS_SIGNS.join("")}]`, "gu");
var ANY_SIGN_DETECT = new RegExp(`[\\-${UNICODE_MINUS_SIGNS.join("")}]`, "u");
var PERMILLE_DETECT = new RegExp(`[${PERMILLE_SYMBOLS.join("")}]`);
var SPACE_SEPARATOR = /\p{Zs}/gu;
var FORMAT_CONTROL = /\p{Cf}/gu;
var APOSTROPHE_GROUP = /['’]/g;
function getLocaleSeparators(locale) {
  try {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
    const group = parts.find((p) => p.type === "group")?.value ?? ",";
    const decimal = parts.find((p) => p.type === "decimal")?.value ?? ".";
    return { group, decimal };
  } catch {
    return { group: ",", decimal: "." };
  }
}
function parseLocalized(input, locale, format) {
  if (input === null || input === void 0) return null;
  let text = String(input).replace(FORMAT_CONTROL, "").trim();
  if (!text) return null;
  if (/^[+\-−]?Infinity$/i.test(text) || /[∞]/.test(text)) return null;
  text = text.replace(MINUS_REGEX, "-").replace(PLUS_REGEX, "+");
  let isNegative = false;
  text = text.replace(/([+\-])\s*$/, (_, sign) => {
    if (sign === "-") isNegative = true;
    return "";
  });
  text = text.replace(/^\s*([+\-])/, (_, sign) => {
    if (sign === "-") isNegative = true;
    return "";
  });
  const { group, decimal } = getLocaleSeparators(locale);
  if (group) text = text.split(group).join("");
  text = text.replace(APOSTROPHE_GROUP, "");
  text = text.replace(SPACE_SEPARATOR, "");
  if (decimal && decimal !== ".") text = text.split(decimal).join(".");
  text = text.replace(/[^\d.+-]/g, "");
  const lastDot = text.lastIndexOf(".");
  if (lastDot !== -1) {
    text = text.slice(0, lastDot).replace(/\./g, "") + "." + text.slice(lastDot + 1).replace(/\./g, "");
  }
  if (text === "" || text === "." || text === "-" || text === "-.") return null;
  let n = parseFloat((isNegative ? "-" : "") + text);
  if (Number.isNaN(n)) return null;
  if (format?.style === "percent") {
    n = n / 100;
  } else if (PERMILLE_DETECT.test(String(input))) {
    n = n / 1e3;
  }
  return n;
}
function snapToStep(value, step) {
  if (value === null || value === void 0) return value;
  if (typeof step !== "number" || !Number.isFinite(step) || step === 0) return value;
  const snapped = Math.round(value / step) * step;
  const decimals = decimalPlaces(step);
  return decimals > 0 ? Number(snapped.toFixed(decimals)) : snapped;
}
function roundForFormat(value, step, format) {
  if (typeof value !== "number" || !Number.isFinite(value)) return value;
  const stepDecimals = typeof step === "number" && Number.isFinite(step) ? decimalPlaces(step) : 0;
  const formatDecimals = Number.isFinite(format?.maximumFractionDigits) ? Math.max(0, Math.min(20, format.maximumFractionDigits)) : 0;
  const decimals = Math.max(stepDecimals, formatDecimals);
  if (decimals === 0) return value;
  return Number(value.toFixed(Math.min(decimals, 20)));
}
function getAllowedNonNumericKeys(locale, format, allowNegative) {
  const keys = /* @__PURE__ */ new Set();
  const { group, decimal } = getLocaleSeparators(locale);
  keys.add(".");
  keys.add(",");
  if (decimal) keys.add(decimal);
  if (group) {
    keys.add(group);
    if (/\p{Zs}/u.test(group)) keys.add(" ");
  }
  keys.add("'");
  keys.add("\u2019");
  keys.add("+");
  UNICODE_PLUS_SIGNS.forEach((s) => keys.add(s));
  if (allowNegative) {
    keys.add("-");
    UNICODE_MINUS_SIGNS.forEach((s) => keys.add(s));
  }
  if (format?.style === "percent") {
    PERMILLE_SYMBOLS.forEach((s) => keys.add(s));
    keys.add("%");
    keys.add("\uFF05");
  }
  if (format?.style === "currency") {
    try {
      const parts = new Intl.NumberFormat(locale, format).formatToParts(0);
      parts.filter((p) => p.type === "currency" || p.type === "literal").forEach((p) => Array.from(p.value).forEach((c) => keys.add(c)));
    } catch {
      keys.add("$");
    }
  }
  return keys;
}

// js/components/number_input/number_input.js
var HOLD_INITIAL_DELAY_MS = 380;
var HOLD_ACCEL_FACTOR = 0.85;
var HOLD_MIN_DELAY_MS = 40;
var HOLD_SCROLL_DISTANCE_PX = 8;
var NAVIGATION_KEYS = /* @__PURE__ */ new Set([
  "Backspace",
  "Delete",
  "Tab",
  "Enter",
  "Escape",
  "ArrowLeft",
  "ArrowRight"
]);
var hook12 = defineComponent("numberinput", (element, env) => {
  const config = env.config(element, {
    // Numeric attrs are strings here because the framework's "number" parser is
    // integer-only (parseInt). We parse with parseFloat at use sites.
    locale: { type: "string", default: "en" },
    format: { type: "json", default: {} },
    min: { type: "string", default: null },
    max: { type: "string", default: null },
    step: { type: "string", default: "1" },
    smallStep: { type: "string", default: null },
    largeStep: { type: "string", default: null },
    snapOnStep: { type: "boolean", default: false },
    allowOutOfRange: { type: "boolean", default: false },
    allowWheelScrub: { type: "boolean", default: false },
    controls: { type: "string", default: "flanking" },
    value: { type: "string", default: null }
  });
  const parts = env.parts(element, {
    fieldRoot: { selector: '[data-part="field-root"]', required: true },
    display: { selector: '[data-part="display"]', required: true },
    hidden: { selector: '[data-part="hidden"]', required: true },
    increment: { selector: '[data-part="increment"]', required: false },
    decrement: { selector: '[data-part="decrement"]', required: false }
  });
  const value = env.signal(parseAttr(config.value.value, null), "value");
  const isFocused = env.signal(false, "focused");
  function getMin() {
    const n = parseAttr(config.min.value, null);
    return typeof n === "number" ? n : -Infinity;
  }
  function getMax2() {
    const n = parseAttr(config.max.value, null);
    return typeof n === "number" ? n : Infinity;
  }
  function getStep() {
    const s = parseAttr(config.step.value, 1);
    return s === "any" ? 1 : typeof s === "number" ? s : 1;
  }
  function getSmallStep() {
    const n = parseAttr(config.smallStep.value, null);
    return typeof n === "number" ? n : getStep() / 10;
  }
  function getLargeStep() {
    const n = parseAttr(config.largeStep.value, null);
    return typeof n === "number" ? n : getStep() * 10;
  }
  function effectiveStep(event) {
    if (event?.shiftKey) return getLargeStep();
    if (event?.altKey) return getSmallStep();
    return getStep();
  }
  function isReadOnly() {
    return parts.display?.readOnly === true;
  }
  function commit(nextValue, { snap = false } = {}) {
    let n = nextValue;
    if (typeof n === "number") {
      if (snap && config.snapOnStep.value && config.step.value !== "any") {
        n = snapToStep(n, getStep());
      }
      n = clamp2(n, getMin(), getMax2());
    }
    value.value = n;
  }
  function stepBy(direction, event, reason) {
    const current = typeof value.value === "number" ? value.value : 0;
    const step = effectiveStep(event);
    const next = roundForFormat(current + direction * step, step, config.format.value);
    const previous = value.value;
    commit(next, { snap: true });
    if (!Object.is(previous, value.value)) {
      emit(reason, previous);
    }
  }
  function payload(reason, previous) {
    return {
      value: value.value,
      previousValue: previous === void 0 ? value.previous : previous,
      reason
    };
  }
  function emit(reason, previous) {
    env.emit("changed", payload(reason, previous));
  }
  function emitCommit(reason, previous) {
    env.emit("committed", payload(reason, previous));
  }
  function resolveParsed(parsed) {
    if (parsed === null) return null;
    if (config.allowOutOfRange.value) return parsed;
    return clamp2(parsed, getMin(), getMax2());
  }
  function withCommit(action, reason, { alsoChange = false } = {}) {
    const previous = value.value;
    action();
    if (Object.is(previous, value.value)) return;
    if (alsoChange) emit(reason, previous);
    emitCommit(reason, previous);
  }
  env.effect("sync-display", () => {
    const v = value.value;
    const display = parts.display;
    if (!display) return;
    if (isFocused.value && !isReadOnly()) {
      const editable = editableString(v, config.format.value);
      if (display.value !== editable) display.value = editable;
    } else {
      const formatted = formatLocalized(v, config.locale.value, config.format.value);
      if (display.value !== formatted) display.value = formatted;
    }
    if (v === null || v === void 0) {
      display.removeAttribute("aria-valuenow");
      display.removeAttribute("aria-valuetext");
    } else {
      const canon = canonicalString(v);
      display.setAttribute("aria-valuenow", canon);
      const valueText = formatLocalized(v, config.locale.value, config.format.value);
      if (valueText && valueText !== canon) {
        display.setAttribute("aria-valuetext", valueText);
      } else {
        display.removeAttribute("aria-valuetext");
      }
    }
  });
  function editableString(v, format) {
    if (v === null || v === void 0 || typeof v !== "number" || Number.isNaN(v)) return "";
    if (format?.style === "percent") {
      const scaled = Number((v * 100).toFixed(10));
      return canonicalString(scaled);
    }
    return canonicalString(v);
  }
  env.effect("sync-hidden", () => {
    const hidden = parts.hidden;
    if (!hidden) return;
    const canonical = canonicalString(value.value);
    if (hidden.value !== canonical) {
      hidden.value = canonical;
      env.emitNative(hidden, ["input", "change"]);
    }
  });
  env.effect("sync-aria-bounds", () => {
    const display = parts.display;
    if (!display) return;
    const min2 = config.min.value;
    const max2 = config.max.value;
    if (min2 === null || min2 === void 0 || min2 === "") display.removeAttribute("aria-valuemin");
    else display.setAttribute("aria-valuemin", min2);
    if (max2 === null || max2 === void 0 || max2 === "") display.removeAttribute("aria-valuemax");
    else display.setAttribute("aria-valuemax", max2);
  });
  let lastConfigValueAttr = element.getAttribute("data-value");
  env.effect("sync-from-server", () => {
    const incoming = element.getAttribute("data-value");
    if (incoming === lastConfigValueAttr) return;
    lastConfigValueAttr = incoming;
    value.value = parseAttr(incoming, null);
  }, { onUpdated: true });
  env.on(parts.display, "focus", () => {
    isFocused.value = true;
    const display = parts.display;
    if (display && typeof display.select === "function") display.select();
  });
  env.on(parts.display, "blur", () => {
    const display = parts.display;
    if (!display) {
      isFocused.value = false;
      return;
    }
    const parsed = parseLocalized(display.value, config.locale.value, config.format.value);
    const previous = value.value;
    value.value = resolveParsed(parsed);
    isFocused.value = false;
    if (!Object.is(previous, value.value)) {
      emit("input-blur", previous);
      emitCommit("input-blur", previous);
    }
  });
  env.on(parts.display, "input", () => {
    if (!isFocused.value) return;
    const display = parts.display;
    const parsed = parseLocalized(display.value, config.locale.value, config.format.value);
    if (parsed === null) {
      display.removeAttribute("aria-valuenow");
    } else {
      display.setAttribute("aria-valuenow", canonicalString(parsed));
    }
  });
  env.on(parts.display, "keydown", (event) => {
    if (isReadOnly()) return;
    const key = event.key;
    if (key === "ArrowUp") {
      event.preventDefault();
      withCommit(() => stepBy(1, event, "keyboard"), "keyboard");
      return;
    }
    if (key === "ArrowDown") {
      event.preventDefault();
      withCommit(() => stepBy(-1, event, "keyboard"), "keyboard");
      return;
    }
    if (key === "PageUp") {
      event.preventDefault();
      withCommit(() => stepBy(1, { shiftKey: true }, "keyboard"), "keyboard");
      return;
    }
    if (key === "PageDown") {
      event.preventDefault();
      withCommit(() => stepBy(-1, { shiftKey: true }, "keyboard"), "keyboard");
      return;
    }
    if (key === "Home") {
      const min2 = getMin();
      if (Number.isFinite(min2)) {
        event.preventDefault();
        withCommit(() => {
          value.value = min2;
        }, "keyboard", { alsoChange: true });
        return;
      }
    }
    if (key === "End") {
      const max2 = getMax2();
      if (Number.isFinite(max2)) {
        event.preventDefault();
        withCommit(() => {
          value.value = max2;
        }, "keyboard", { alsoChange: true });
        return;
      }
    }
    if (key === "Enter") {
      const parsed = parseLocalized(parts.display.value, config.locale.value, config.format.value);
      withCommit(() => {
        value.value = resolveParsed(parsed);
      }, "keyboard", { alsoChange: true });
      return;
    }
    if (isImeComposing(event)) return;
    if (event.ctrlKey || event.metaKey) return;
    if (NAVIGATION_KEYS.has(key)) return;
    if (key.length === 1 && key >= "0" && key <= "9") return;
    const allowed = getAllowedNonNumericKeys(
      config.locale.value,
      config.format.value,
      getMin() < 0
    );
    if (key.length === 1 && allowed.has(key)) return;
    if (key.length > 1) return;
    event.preventDefault();
  });
  env.on(parts.display, "paste", (event) => {
    if (isReadOnly()) {
      event.preventDefault();
      return;
    }
    const clipboard = event.clipboardData;
    if (!clipboard) return;
    const pasted = clipboard.getData("text/plain");
    const parsedRaw = parseLocalized(pasted, config.locale.value, config.format.value);
    if (parsedRaw === null) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const display = parts.display;
    if (!display) return;
    const start = display.selectionStart ?? display.value.length;
    const end = display.selectionEnd ?? display.value.length;
    const merged = display.value.slice(0, start) + pasted + display.value.slice(end);
    const previous = value.value;
    value.value = resolveParsed(parsedRaw);
    display.value = merged;
    display.setAttribute("aria-valuenow", canonicalString(value.value));
    if (!Object.is(previous, value.value)) {
      emit("input-paste", previous);
      emitCommit("input-paste", previous);
    }
  });
  function startHold(direction, originatingEvent) {
    const modifierSnapshot = {
      shiftKey: originatingEvent.shiftKey,
      altKey: originatingEvent.altKey
    };
    const reason = direction > 0 ? "increment-press" : "decrement-press";
    const holdStartValue = value.value;
    stepBy(direction, modifierSnapshot, reason);
    let delay = HOLD_INITIAL_DELAY_MS;
    const tick = () => {
      stepBy(direction, modifierSnapshot, reason);
      delay = Math.max(HOLD_MIN_DELAY_MS, delay * HOLD_ACCEL_FACTOR);
      env.timeout("stepper-hold", tick, delay);
    };
    env.timeout("stepper-hold", tick, delay);
    const session = new AbortController();
    let stopped = false;
    const stop = () => {
      if (stopped) return;
      stopped = true;
      env.timeout.cancel("stepper-hold");
      session.abort();
      if (!Object.is(holdStartValue, value.value)) {
        emitCommit(reason, holdStartValue);
      }
    };
    env.on(window, "pointerup", stop, { once: true, signal: session.signal });
    env.on(window, "pointercancel", stop, { once: true, signal: session.signal });
    env.on(window, "blur", stop, { once: true, signal: session.signal });
    env.on(document, "visibilitychange", () => {
      if (document.hidden) stop();
    }, { signal: session.signal });
    const startX = originatingEvent.clientX;
    const startY = originatingEvent.clientY;
    if (typeof startX === "number" && typeof startY === "number") {
      env.on(window, "pointermove", (moveEvent) => {
        const dx = (moveEvent.clientX ?? startX) - startX;
        const dy = (moveEvent.clientY ?? startY) - startY;
        if (dx * dx + dy * dy > HOLD_SCROLL_DISTANCE_PX * HOLD_SCROLL_DISTANCE_PX) {
          stop();
        }
      }, { signal: session.signal });
    }
  }
  function bindStepperButton(button, direction) {
    if (!button) return;
    env.on(button, "pointerdown", (event) => {
      if (event.button !== 0 || isReadOnly()) return;
      event.preventDefault();
      if (parts.display) parts.display.focus({ preventScroll: true });
      startHold(direction, event);
    });
  }
  bindStepperButton(parts.increment, 1);
  bindStepperButton(parts.decrement, -1);
  env.on(parts.display, "wheel", (event) => {
    if (!config.allowWheelScrub.value) return;
    if (!isFocused.value) return;
    if (!event.altKey) return;
    if (isReadOnly()) return;
    event.preventDefault();
    const direction = event.deltaY < 0 ? 1 : -1;
    withCommit(() => stepBy(direction, null, "wheel"), "wheel");
  }, { passive: false });
  return {
    get value() {
      return value.value;
    },
    setValue(next) {
      if (next === null || next === void 0) return false;
      const parsed = typeof next === "number" ? Number.isFinite(next) ? next : null : parseAttr(String(next), null);
      if (parsed === null) return false;
      const previous = value.value;
      const resolved = resolveParsed(parsed);
      if (resolved === previous) return false;
      withCommit(() => {
        value.value = resolved;
      }, "api", { alsoChange: true });
      return true;
    },
    clear() {
      if (value.value === null) return false;
      withCommit(() => {
        value.value = null;
      }, "api", { alsoChange: true });
      return true;
    }
  };
});

// js/components/input/input.js
var hook13 = defineComponent("input", (element, env) => {
  const parts = env.parts(element, {
    input: { selector: '[data-part="input"]', required: true },
    clearButton: { selector: '[data-part="clear-button"]', required: false }
  });
  function canClear() {
    const input = parts.input;
    return input.value !== "" && !input.disabled && !input.readOnly;
  }
  function syncClearButton() {
    const button = parts.clearButton;
    if (!button) return;
    button.hidden = !canClear();
  }
  function clear() {
    const input = parts.input;
    if (!canClear()) {
      input.focus();
      return false;
    }
    input.value = "";
    syncClearButton();
    env.emitNative(input, ["input", "change"]);
    input.focus();
    return true;
  }
  env.effect("clear-button-state", syncClearButton, { onUpdated: true });
  env.on(parts.input, "input", syncClearButton);
  env.on(
    element,
    "mousedown",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
    },
    { delegate: '[data-part="clear-button"]' }
  );
  env.on(
    element,
    "click",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      clear();
    },
    { delegate: '[data-part="clear-button"]' }
  );
  return {
    clear,
    get value() {
      return parts.input.value;
    }
  };
});

// js/components/toast/toast.js
var VALID_COLORS = /* @__PURE__ */ new Set(["info", "success", "warning", "danger", "loading"]);
var FLASH_TOASTS_KEY = "__fluxon_toasts__";
var SAFE_HREF_SCHEMES = /* @__PURE__ */ new Set(["http", "https", "mailto", "tel", "sms"]);
var ACTION_TYPES = /* @__PURE__ */ new Set(["event", "link", "dismiss"]);
var ACTION_COLORS = /* @__PURE__ */ new Set(["info", "success", "warning", "danger"]);
var VALID_EVENT_NAME = /^[\w:.-]+$/;
var GAP = 14;
var SWIPE_DISTANCE_THRESHOLD = 45;
var SWIPE_VELOCITY_THRESHOLD = 0.11;
function isRenderableAction(action, data) {
  if (!action || !ACTION_TYPES.has(action.type)) return false;
  if (action.type === "event") {
    if (data.fromFlash) return false;
    if (typeof action.event !== "string" || !VALID_EVENT_NAME.test(action.event)) return false;
  }
  if (action.type === "link") {
    const target = action.href || action.navigate || action.patch;
    if (!isSafeHref(target)) return false;
  }
  return true;
}
function actionList(data) {
  return data.actions || (data.action ? [data.action] : []);
}
function isSafeHref(href) {
  if (typeof href !== "string" || href === "") return false;
  if (href[0] === "/" || href[0] === "#" || href[0] === "?") return true;
  if (href.startsWith("//")) return true;
  const colon = href.indexOf(":");
  if (colon === -1) return true;
  const scheme = href.slice(0, colon).trim().toLowerCase();
  return SAFE_HREF_SCHEMES.has(scheme);
}
var prefersReducedMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
function cap(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
function applyFriction(delta, dismissSign) {
  if (delta === 0) return 0;
  if (Math.sign(delta) === dismissSign) return delta;
  return delta / (1.5 + Math.abs(delta) / 20);
}
var SHOWN_IDS_KEY = "fluxon:toast:shown";
var SHOWN_IDS_TTL = 10 * 60 * 1e3;
var SHOWN_IDS_MAX = 50;
function readShownIds() {
  try {
    const raw = sessionStorage.getItem(SHOWN_IDS_KEY);
    if (!raw) return {};
    const map = JSON.parse(raw);
    if (!map || typeof map !== "object" || Array.isArray(map)) return {};
    const cutoff = Date.now() - SHOWN_IDS_TTL;
    const fresh = {};
    for (const [id, at] of Object.entries(map)) {
      if (typeof at === "number" && at > cutoff) fresh[id] = at;
    }
    return fresh;
  } catch {
    return {};
  }
}
function recordShownIds(ids) {
  if (ids.length === 0) return;
  try {
    const map = readShownIds();
    for (const id of ids) map[id] = Date.now();
    const entries = Object.entries(map).sort((a, b) => a[1] - b[1]);
    while (entries.length > SHOWN_IDS_MAX) entries.shift();
    sessionStorage.setItem(SHOWN_IDS_KEY, JSON.stringify(Object.fromEntries(entries)));
  } catch {
  }
}
function parseFlashPayload(raw) {
  if (!raw) return [];
  try {
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}
function isPrimaryToaster(element) {
  if (typeof document === "undefined") return true;
  const all = document.querySelectorAll('[data-part="toaster"]');
  if (all.length <= 1) return true;
  if (all[0] === element) {
    console.warn(
      "[Fluxon.Toast] More than one <.toaster> is mounted on this page. Toasts will render in only one and flash will be consumed unpredictably. Place <.toaster /> exactly once, in your root layout."
    );
    return true;
  }
  return false;
}
var hook14 = defineComponent("toast", (element, env) => {
  const standalone = element.__fluxonToastStandalone;
  const tookOver = standalone != null;
  const wasExpanded = tookOver && standalone.expanded === true;
  if (tookOver) {
    delete element.__fluxonToastStandalone;
    standalone.destroy?.();
  }
  const config = env.config(element, {
    position: {
      type: "enum",
      values: ["bottom-right", "top-right", "top-center", "bottom-center", "top-left", "bottom-left"],
      default: "top-right"
    },
    maxToasts: { type: "number", default: 5 },
    dismissAfter: { type: "number", default: 4e3 }
  });
  const parts = env.parts(element, {
    template: { selector: '[data-part="toast-template"]', required: true }
  });
  const toasts = env.signal([], "toasts");
  const activeToasts = /* @__PURE__ */ new Map();
  const primary = isPrimaryToaster(element);
  function dismissSign() {
    return config.position.value.startsWith("top") ? -1 : 1;
  }
  function recompute() {
    const list = toasts.value;
    const len = list.length;
    const frontEntry = len > 0 ? activeToasts.get(list[len - 1].id) : null;
    element.style.setProperty("--front-toast-height", `${frontEntry?.height || 0}px`);
    let offset3 = 0;
    for (let i = len - 1; i >= 0; i--) {
      const entry = activeToasts.get(list[i].id);
      if (!entry) continue;
      const el = entry.element;
      const toastsBefore = len - 1 - i;
      el.style.setProperty("--z-index", String(i + 1));
      el.style.setProperty("--offset", `${offset3}px`);
      el.style.setProperty("--initial-height", `${entry.height || 0}px`);
      el.style.setProperty("--toasts-before", String(toastsBefore));
      el.dataset.front = toastsBefore === 0 ? "true" : "false";
      offset3 += (entry.height || 0) + GAP;
    }
  }
  function measureHeight(id) {
    const entry = activeToasts.get(id);
    if (!entry) return 0;
    const el = entry.element;
    const prevInline = el.style.height;
    el.style.height = "auto";
    const h = el.offsetHeight || 0;
    if (prevInline) el.style.height = prevInline;
    else el.style.removeProperty("height");
    entry.height = h;
    return h;
  }
  function actionPosition(action) {
    return action.position === "inline" ? "inline" : "below";
  }
  function clearActionSlots(toastEl) {
    const inlineSlot = toastEl.querySelector('[data-part="toast-actions-inline"]');
    const belowSlot = toastEl.querySelector('[data-part="toast-actions"]');
    if (inlineSlot) inlineSlot.replaceChildren();
    if (belowSlot) belowSlot.replaceChildren();
    delete toastEl.dataset.hasActionsInline;
    delete toastEl.dataset.hasActionsBelow;
  }
  function renderActions(toastEl, data) {
    const actions = actionList(data);
    if (actions.length === 0) return;
    const inlineSlot = toastEl.querySelector('[data-part="toast-actions-inline"]');
    const belowSlot = toastEl.querySelector('[data-part="toast-actions"]');
    const btnTpl = toastEl.querySelector('[data-part="action-button-tpl"]');
    const linkTpl = toastEl.querySelector('[data-part="action-link-tpl"]');
    let renderedInline = 0;
    let renderedBelow = 0;
    for (const action of actions) {
      if (!isRenderableAction(action, data)) continue;
      const tpl = action.type === "link" ? linkTpl : btnTpl;
      if (!tpl) continue;
      const el = tpl.content.cloneNode(true).firstElementChild;
      populateActionContent(el, action, data);
      applyVariantClasses(el, action.variant);
      applyActionColor(el, action, data);
      applyDisabled(el, action.disabled);
      bindActionHandler(el, action, data.id);
      const slot = actionPosition(action) === "inline" ? inlineSlot : belowSlot;
      if (!slot) continue;
      slot.appendChild(el);
      if (slot === inlineSlot) renderedInline++;
      else renderedBelow++;
    }
    if (renderedInline > 0) toastEl.dataset.hasActionsInline = "";
    if (renderedBelow > 0) toastEl.dataset.hasActionsBelow = "";
  }
  function populateActionContent(el, action, data) {
    const label = action.label || "Action";
    if (action.icon && !data.fromFlash) {
      const iconSpan = document.createElement("span");
      iconSpan.setAttribute("data-part", "action-icon");
      iconSpan.className = "inline-flex items-center shrink-0";
      iconSpan.innerHTML = action.icon;
      el.appendChild(iconSpan);
      const labelSpan = document.createElement("span");
      labelSpan.textContent = label;
      el.appendChild(labelSpan);
    } else {
      el.textContent = label;
    }
  }
  function applyVariantClasses(el, variant) {
    const v = variant || "surface";
    const classes = element.dataset[`variant${cap(v)}`];
    if (classes) el.classList.add(...classes.split(" "));
  }
  function applyActionColor(el, action, data) {
    const effective = action.color || data.color;
    if (effective && ACTION_COLORS.has(effective)) {
      el.dataset.color = effective;
    }
  }
  function applyDisabled(el, disabled) {
    if (disabled !== true) return;
    if (el.tagName === "BUTTON") el.disabled = true;
    el.setAttribute("aria-disabled", "true");
  }
  function applyLinkTarget(el, action) {
    if (action.href) {
      el.href = action.href;
    } else if (action.navigate) {
      el.href = action.navigate;
      el.setAttribute("data-phx-link", "redirect");
      el.setAttribute("data-phx-link-state", "push");
    } else if (action.patch) {
      el.href = action.patch;
      el.setAttribute("data-phx-link", "patch");
      el.setAttribute("data-phx-link-state", "push");
    }
  }
  function bindActionHandler(el, action, toastId) {
    switch (action.type) {
      case "link":
        applyLinkTarget(el, action);
        if (action.dismiss !== false) {
          env.on(el, "click", () => dismiss(toastId));
        }
        return;
      case "event":
        env.on(el, "click", () => {
          if (action.disabled === true) return;
          env.emit("action", {
            id: toastId,
            event: action.event,
            value: action.value || {}
          });
          if (action.dismiss !== false) dismiss(toastId);
        });
        return;
      case "dismiss":
        env.on(el, "click", () => {
          if (action.disabled === true) return;
          dismiss(toastId);
        });
        return;
    }
  }
  function rebindActions(toastEl, data) {
    const actions = actionList(data);
    if (actions.length === 0) return;
    const inlineBtns = Array.from(
      toastEl.querySelectorAll('[data-part="toast-actions-inline"] [data-part="toast-action"]')
    );
    const belowBtns = Array.from(
      toastEl.querySelectorAll('[data-part="toast-actions"] [data-part="toast-action"]')
    );
    let inlineIdx = 0;
    let belowIdx = 0;
    for (const action of actions) {
      if (!isRenderableAction(action, data)) continue;
      const slotIsInline = actionPosition(action) === "inline";
      const btn = slotIsInline ? inlineBtns[inlineIdx++] : belowBtns[belowIdx++];
      if (!btn) continue;
      bindActionHandler(btn, action, data.id);
    }
  }
  function createToastElement(data) {
    const tpl = parts.template;
    const clone = tpl.content.cloneNode(true);
    const toastEl = clone.querySelector('[data-part="toast"]');
    if (!toastEl) return null;
    const safeColor = VALID_COLORS.has(data.color) ? data.color : "default";
    toastEl.dataset.toastId = data.id;
    toastEl.dataset.color = safeColor;
    toastEl.dataset.mounted = "false";
    try {
      toastEl.dataset.toastData = JSON.stringify(data);
    } catch {
    }
    if (safeColor === "danger") {
      toastEl.setAttribute("role", "alert");
      toastEl.setAttribute("aria-live", "assertive");
    }
    const iconContainer = toastEl.querySelector('[data-part="toast-icon"]');
    if (iconContainer && data.icon !== false) {
      if (typeof data.icon === "string" && !data.fromFlash) {
        iconContainer.innerHTML = data.icon;
        toastEl.dataset.hasIcon = "";
      } else if (safeColor !== "default") {
        toastEl.dataset.hasIcon = "";
      }
    }
    const titleEl = toastEl.querySelector('[data-part="toast-title"]');
    if (titleEl) titleEl.textContent = data.title || "";
    const descEl = toastEl.querySelector('[data-part="toast-description"]');
    if (descEl && data.description) {
      descEl.textContent = data.description;
      toastEl.dataset.hasDescription = "";
    }
    const contentEl = toastEl.querySelector('[data-part="toast-content"]');
    if (contentEl && data.content && !data.fromFlash) {
      contentEl.innerHTML = data.content;
      toastEl.dataset.hasContent = "";
    }
    renderActions(toastEl, data);
    if (data.dismissible === false) {
      toastEl.dataset.dismissible = "false";
    }
    const closeBtn = toastEl.querySelector('[data-part="toast-close"]');
    if (closeBtn) {
      env.on(closeBtn, "click", () => {
        if (toastEl.dataset.dismissible === "false") return;
        dismiss(data.id);
      });
    }
    return toastEl;
  }
  function show(data) {
    if (activeToasts.has(data.id)) return;
    const currentToasts = toasts.value;
    if (currentToasts.length >= config.maxToasts.value) {
      dismiss(currentToasts[0].id, true);
    }
    const toastEl = createToastElement(data);
    if (!toastEl) return;
    element.appendChild(toastEl);
    activeToasts.set(data.id, {
      element: toastEl,
      data,
      timer: false,
      height: 0
    });
    toasts.value = [...toasts.value, data];
    measureHeight(data.id);
    recompute();
    if (prefersReducedMotion()) {
      toastEl.dataset.mounted = "true";
    } else {
      void toastEl.offsetHeight;
      toastEl.dataset.mounted = "true";
    }
    const duration = "dismiss_after" in data ? data.dismiss_after : config.dismissAfter.value;
    startTimer(data.id, duration);
  }
  async function dismiss(id, skipAnimation = false) {
    const entry = activeToasts.get(id);
    if (!entry) return;
    if (entry.timer) {
      env.timeout.cancel(timerName(id));
      entry.timer = false;
    }
    const el = entry.element;
    activeToasts.delete(id);
    toasts.value = toasts.value.filter((t) => t.id !== id);
    recompute();
    if (skipAnimation || prefersReducedMotion()) {
      el.remove();
      env.emit("dismissed", { id });
      return;
    }
    el.dataset.removed = "true";
    try {
      await animateMini(el, { opacity: [1, 0] }, { duration: 0.2, easing: [0.4, 0, 1, 1] }).finished;
    } catch {
    }
    if (el.parentNode) el.remove();
    env.emit("dismissed", { id });
  }
  function update(data) {
    const entry = activeToasts.get(data.id);
    if (!entry) {
      show(data);
      return;
    }
    if (data.color == null) data = { ...data, color: entry.data.color };
    if (entry.timer) {
      env.timeout.cancel(timerName(data.id));
      entry.timer = false;
    }
    const colorChanged = entry.data.color !== data.color;
    if (colorChanged) {
      const oldEl = entry.element;
      const newEl = createToastElement(data);
      if (!newEl) return;
      oldEl.replaceWith(newEl);
      activeToasts.set(data.id, {
        element: newEl,
        data,
        timer: false,
        height: 0
      });
      toasts.value = toasts.value.map((t) => t.id === data.id ? data : t);
      measureHeight(data.id);
      recompute();
      void newEl.offsetHeight;
      newEl.dataset.mounted = "true";
    } else {
      const el = entry.element;
      const titleEl = el.querySelector('[data-part="toast-title"]');
      if (titleEl) titleEl.textContent = data.title || "";
      const descEl = el.querySelector('[data-part="toast-description"]');
      if (descEl) {
        if (data.description) {
          descEl.textContent = data.description;
          el.dataset.hasDescription = "";
        } else {
          descEl.textContent = "";
          delete el.dataset.hasDescription;
        }
      }
      const contentEl = el.querySelector('[data-part="toast-content"]');
      if (contentEl) {
        if (data.content && !data.fromFlash) {
          contentEl.innerHTML = data.content;
          el.dataset.hasContent = "";
        } else {
          contentEl.replaceChildren();
          delete el.dataset.hasContent;
        }
      }
      if (entry.data.dismissible !== data.dismissible) {
        if (data.dismissible === false) {
          el.dataset.dismissible = "false";
        } else {
          delete el.dataset.dismissible;
        }
      }
      clearActionSlots(el);
      renderActions(el, data);
      entry.data = data;
      toasts.value = toasts.value.map((t) => t.id === data.id ? data : t);
      measureHeight(data.id);
      recompute();
    }
    const updatedEntry = activeToasts.get(data.id);
    if (updatedEntry) updatedEntry.totalDuration = null;
    const updatedDuration = "dismiss_after" in data ? data.dismiss_after : config.dismissAfter.value;
    startTimer(data.id, updatedDuration);
  }
  function timerName(id) {
    return `dismiss:${id}`;
  }
  function startTimer(id, duration) {
    const entry = activeToasts.get(id);
    if (!entry) return;
    if (duration == null || duration <= 0) {
      delete entry.element.dataset.toastExpiresAt;
      return;
    }
    env.timeout.cancel(timerName(id));
    entry.timer = true;
    entry.remainingTime = duration;
    entry.timerStart = Date.now();
    entry.totalDuration = entry.totalDuration || duration;
    entry.element.dataset.toastExpiresAt = String(Date.now() + duration);
    env.timeout(timerName(id), () => {
      const e = activeToasts.get(id);
      if (e) e.timer = false;
      dismiss(id);
    }, duration);
    startProgress(entry, duration);
  }
  function pauseAllTimers() {
    for (const [id, entry] of activeToasts) {
      if (entry.timer) {
        env.timeout.cancel(timerName(id));
        entry.timer = false;
        const elapsed = Date.now() - (entry.timerStart || Date.now());
        entry.remainingTime = Math.max(0, (entry.remainingTime || 0) - elapsed);
        delete entry.element.dataset.toastExpiresAt;
      }
      pauseProgress(entry);
    }
  }
  function resumeAllTimers() {
    for (const [id, entry] of activeToasts) {
      if (entry.remainingTime > 0 && !entry.timer) {
        startTimer(id, entry.remainingTime);
      }
    }
  }
  function startProgress(entry, duration) {
    const progressEl = entry.element.querySelector('[data-part="toast-progress"]');
    if (!progressEl) return;
    progressEl.dataset.active = "";
    progressEl.style.transition = "none";
    progressEl.style.width = `${duration / entry.totalDuration * 100}%`;
    void progressEl.offsetWidth;
    progressEl.style.transition = `width ${duration}ms linear`;
    progressEl.style.width = "0%";
  }
  function pauseProgress(entry) {
    const progressEl = entry.element.querySelector('[data-part="toast-progress"]');
    if (!progressEl || !progressEl.hasAttribute("data-active")) return;
    const computed = getComputedStyle(progressEl).width;
    progressEl.style.transition = "none";
    progressEl.style.width = computed;
  }
  function adopt() {
    const orphans = element.querySelectorAll('[data-part="toast"][data-toast-id]');
    if (orphans.length === 0) return 0;
    let adopted = 0;
    for (const toastEl of orphans) {
      const id = toastEl.dataset.toastId;
      if (!id || activeToasts.has(id)) continue;
      let data;
      try {
        data = JSON.parse(toastEl.dataset.toastData || "");
      } catch {
        data = { id, dismissible: toastEl.dataset.dismissible !== "false" };
      }
      const duration = "dismiss_after" in data ? data.dismiss_after : config.dismissAfter.value;
      const expiresAt = Number.parseInt(toastEl.dataset.toastExpiresAt || "", 10);
      const remaining = Number.isFinite(expiresAt) ? expiresAt - Date.now() : null;
      if (remaining != null && remaining <= 0) {
        toastEl.remove();
        env.emit("dismissed", { id });
        continue;
      }
      activeToasts.set(id, {
        element: toastEl,
        data,
        timer: false,
        height: toastEl.offsetHeight || 0
      });
      toasts.value = [...toasts.value, data];
      toastEl.dataset.mounted = "true";
      delete toastEl.dataset.removed;
      const closeBtn = toastEl.querySelector('[data-part="toast-close"]');
      if (closeBtn) {
        env.on(closeBtn, "click", () => {
          if (toastEl.dataset.dismissible === "false") return;
          dismiss(id);
        });
      }
      rebindActions(toastEl, data);
      if (duration != null && duration > 0) {
        if (remaining != null) {
          activeToasts.get(id).totalDuration = duration;
          startTimer(id, remaining);
        } else {
          startTimer(id, duration);
        }
      }
      adopted++;
    }
    if (adopted > 0) recompute();
    return adopted;
  }
  function consumeFlashToasts(parsed) {
    const list = parsed ?? parseFlashPayload(element.dataset.flashToasts);
    delete element.dataset.flashToasts;
    if (list.length === 0) return [];
    const shown = readShownIds();
    const newlyShown = [];
    for (const data of list) {
      if (!data || typeof data.id !== "string") continue;
      if (activeToasts.has(data.id)) continue;
      if (data.id in shown) continue;
      data.fromFlash = true;
      show(data);
      newlyShown.push(data.id);
    }
    recordShownIds(newlyShown);
    return newlyShown;
  }
  function consumeFlashAndClear() {
    const list = parseFlashPayload(element.dataset.flashToasts);
    consumeFlashToasts(list);
    if (list.some((data) => data && typeof data.id === "string")) {
      env.lv.pushEvent("lv:clear-flash", { key: FLASH_TOASTS_KEY });
    }
  }
  const api = {};
  env.lv.handleEvent("fluxon:toast:show", (data) => api.show(data));
  env.lv.handleEvent("fluxon:toast:update", (data) => api.update(data));
  env.lv.handleEvent("fluxon:toast:dismiss", (data) => api.dismiss(data.id));
  env.on(element, "fluxon:toast:action", (e) => {
    const { event, value } = e.detail;
    if (event && VALID_EVENT_NAME.test(event)) {
      env.lv.pushEvent(event, value || {});
    }
  });
  env.on(element, "fluxon:toast:show", (e) => {
    if (!primary) return;
    if (!e?.detail || typeof e.detail !== "object") return;
    api.show(e.detail);
  });
  env.on(element, "fluxon:toast:update", (e) => {
    if (!primary) return;
    if (!e?.detail || typeof e.detail !== "object") return;
    api.update(e.detail);
  });
  env.on(element, "fluxon:toast:dismiss", (e) => {
    if (!primary) return;
    const id = e?.detail?.id;
    if (typeof id === "string") api.dismiss(id);
  });
  let expanded = false;
  function setExpanded(value) {
    expanded = value;
    element.dataset.expanded = value ? "true" : "false";
  }
  env.on(element, "mouseenter", () => {
    setExpanded(true);
    pauseAllTimers();
  });
  env.on(element, "mouseleave", () => {
    setExpanded(false);
    resumeAllTimers();
  });
  env.effect("restore-expanded", () => {
    env.untrack(() => {
      element.dataset.expanded = expanded ? "true" : "false";
    });
  }, { onUpdated: true });
  env.on(document, "visibilitychange", () => {
    if (document.hidden) pauseAllTimers();
    else resumeAllTimers();
  });
  env.on(window, "phx:page-loading-start", (e) => {
    if (e.detail?.kind !== "redirect") return;
    for (const entry of activeToasts.values()) {
      entry.element.dataset.removed = "true";
    }
  });
  env.on(window, "phx:page-loading-stop", () => {
    for (const entry of activeToasts.values()) {
      delete entry.element.dataset.removed;
    }
  });
  let dragState = null;
  env.on(element, "pointerdown", (e) => {
    if (e.button !== 0 || e.pointerType === "mouse") return;
    if (prefersReducedMotion()) return;
    const toastEl = e.target.closest('[data-part="toast"]');
    if (!toastEl) return;
    if (toastEl.dataset.dismissible === "false") return;
    toastEl.setPointerCapture(e.pointerId);
    dragState = {
      element: toastEl,
      id: toastEl.dataset.toastId,
      pointerId: e.pointerId,
      startX: e.clientX,
      startY: e.clientY,
      deltaY: 0,
      startTime: performance.now(),
      locked: false
    };
  });
  env.on(element, "pointermove", (e) => {
    if (!dragState || e.pointerId !== dragState.pointerId) return;
    const dx = e.clientX - dragState.startX;
    const dy = e.clientY - dragState.startY;
    const adx = Math.abs(dx);
    const ady = Math.abs(dy);
    if (!dragState.locked) {
      if (adx > ady && adx > 5) {
        dragState = null;
        return;
      }
      if (ady > 5) {
        dragState.locked = true;
        dragState.element.dataset.swiping = "true";
      } else {
        return;
      }
    }
    const sign = dismissSign();
    const dampened = applyFriction(dy, sign);
    dragState.deltaY = dampened;
    dragState.element.style.setProperty("--swipe-y", `${dampened}px`);
    if (Math.sign(dy) === sign) {
      const opacity = Math.max(0, 1 - Math.abs(dy) / 200);
      dragState.element.style.opacity = String(opacity);
    } else {
      dragState.element.style.opacity = "";
    }
  });
  env.on(element, "pointerup", (e) => {
    if (!dragState || e.pointerId !== dragState.pointerId) return;
    const state = dragState;
    dragState = null;
    delete state.element.dataset.swiping;
    const sign = dismissSign();
    const finalDelta = e.clientY - state.startY;
    const elapsed = performance.now() - state.startTime;
    const velocity = elapsed > 0 ? Math.abs(finalDelta) / elapsed : 0;
    const correctDirection = Math.sign(finalDelta) === sign;
    const overDistance = Math.abs(finalDelta) > SWIPE_DISTANCE_THRESHOLD;
    const fastEnough = elapsed > 30 && velocity > SWIPE_VELOCITY_THRESHOLD;
    if (correctDirection && (overDistance || fastEnough)) {
      dismiss(state.id);
    } else {
      state.element.style.removeProperty("--swipe-y");
      state.element.style.opacity = "";
    }
  });
  env.on(element, "pointercancel", (e) => {
    if (!dragState || e.pointerId !== dragState.pointerId) return;
    delete dragState.element.dataset.swiping;
    dragState.element.style.removeProperty("--swipe-y");
    dragState.element.style.opacity = "";
    dragState = null;
  });
  const escapeTarget = () => {
    const newest = toasts.value[toasts.value.length - 1];
    return newest && newest.dismissible !== false ? newest : null;
  };
  env.effect("escape-availability", () => {
    element.dataset.escapeDismissible = escapeTarget() ? "true" : "false";
  });
  env.on(element, "keydown", (e) => {
    if (e.key !== "Escape") return;
    const target = escapeTarget();
    if (target) dismiss(target.id);
  });
  if (tookOver) {
    adopt();
    if (wasExpanded) {
      setExpanded(true);
      pauseAllTimers();
    }
  }
  consumeFlashAndClear();
  env.effect("consume-flash", () => {
    env.untrack(() => consumeFlashAndClear());
  }, { onUpdated: true });
  Object.assign(api, {
    show,
    dismiss,
    update,
    adopt,
    toasts,
    config,
    consumeFlashToasts,
    consumeFlashAndClear,
    get activeToasts() {
      return activeToasts;
    }
  });
  Object.defineProperty(api, "expanded", {
    get: () => expanded
  });
  return api;
}, {
  // Reconnected: the toaster's container is phx-update="ignore" so JS state was lost on
  // disconnect but DOM toasts survive. Reset the component (which clears activeToasts)
  // and re-adopt the orphan DOM, restoring timers and event listeners.
  reconnected(api) {
    if (!api) return;
    api.adopt();
    api.consumeFlashAndClear();
  }
});

// js/components/scroll_area/scroll_area.js
var MIN_THUMB_SIZE = 18;
var SCROLL_END_DEBOUNCE_MS = 100;
var hook15 = defineComponent("scrollarea", (element, env) => {
  const cfg = env.config(element, {
    type: { type: "string", default: "hover" },
    scrollHideDelay: { type: "number", default: 600 },
    keyboardScrolling: { type: "boolean", default: true }
  });
  const parts = env.parts(element, {
    viewport: { selector: ':scope > [data-part="viewport"]', required: true },
    content: { selector: ':scope > [data-part="viewport"] > [data-part="content"]', required: true },
    scrollbarY: { selector: ':scope > [data-part="scrollbar-y"]' },
    scrollbarX: { selector: ':scope > [data-part="scrollbar-x"]' },
    thumbY: { selector: ':scope > [data-part="scrollbar-y"] > [data-part="thumb-y"]' },
    thumbX: { selector: ':scope > [data-part="scrollbar-x"] > [data-part="thumb-x"]' },
    corner: { selector: ':scope > [data-part="corner"]' }
  });
  const isHovering = env.signal(false, "isHovering");
  const isScrolling = env.signal(false, "isScrolling");
  const isDraggingY = env.signal(false, "isDraggingY");
  const isDraggingX = env.signal(false, "isDraggingX");
  const hasOverflowY = env.signal(false, "hasOverflowY");
  const hasOverflowX = env.signal(false, "hasOverflowX");
  const hasMeasured = env.signal(false, "hasMeasured");
  let programmaticScroll = true;
  function syncAxes() {
    const v = parts.viewport;
    const scrollHeight = v.scrollHeight;
    const clientHeight = v.clientHeight;
    const scrollTop = v.scrollTop;
    const scrollWidth = v.scrollWidth;
    const clientWidth = v.clientWidth;
    const scrollLeft = v.scrollLeft;
    const trackHeight = parts.scrollbarY ? parts.scrollbarY.clientHeight : 0;
    const trackWidth = parts.scrollbarX ? parts.scrollbarX.clientWidth : 0;
    const overflowY = scrollHeight - clientHeight > 1;
    const overflowX = scrollWidth - clientWidth > 1;
    hasOverflowY.value = overflowY;
    hasOverflowX.value = overflowX;
    writeAxis({
      axis: "y",
      thumb: parts.thumbY,
      track: parts.scrollbarY,
      overflow: overflowY,
      scrollSize: scrollHeight,
      clientSize: clientHeight,
      // Clamp scroll into [0, max]; Safari rubber-band can produce values outside this
      // range and we'd render thumbs past the track end.
      scroll: clamp3(scrollTop, 0, Math.max(0, scrollHeight - clientHeight)),
      trackSize: trackHeight
    });
    writeAxis({
      axis: "x",
      thumb: parts.thumbX,
      track: parts.scrollbarX,
      overflow: overflowX,
      scrollSize: scrollWidth,
      clientSize: clientWidth,
      scroll: clamp3(scrollLeft, 0, Math.max(0, scrollWidth - clientWidth)),
      trackSize: trackWidth
    });
    if (!hasMeasured.value) hasMeasured.value = true;
  }
  const AXIS = {
    y: {
      sizeProp: "height",
      offsetTpl: (px) => `translate3d(0, ${px}px, 0)`,
      thumbVar: "--scroll-area-thumb-height",
      startVar: "--scroll-area-overflow-y-start",
      endVar: "--scroll-area-overflow-y-end",
      startAttr: "data-overflow-y-start",
      endAttr: "data-overflow-y-end"
    },
    x: {
      sizeProp: "width",
      offsetTpl: (px) => `translate3d(${px}px, 0, 0)`,
      thumbVar: "--scroll-area-thumb-width",
      startVar: "--scroll-area-overflow-x-start",
      endVar: "--scroll-area-overflow-x-end",
      startAttr: "data-overflow-x-start",
      endAttr: "data-overflow-x-end"
    }
  };
  function writeAxis({ axis, thumb, track, overflow, scrollSize, clientSize, scroll, trackSize }) {
    if (!thumb || !track) return;
    const a = AXIS[axis];
    if (!overflow) {
      const fullSize = `${trackSize}px`;
      thumb.style[a.sizeProp] = fullSize;
      thumb.style.transform = a.offsetTpl(0);
      track.style.setProperty(a.thumbVar, fullSize);
      parts.viewport.style.setProperty(a.startVar, "0px");
      parts.viewport.style.setProperty(a.endVar, "0px");
      env.attrs(element, { [a.startAttr]: false, [a.endAttr]: false });
      return;
    }
    const ratio = clientSize / scrollSize;
    const thumbSize = Math.max(MIN_THUMB_SIZE, Math.floor(trackSize * ratio));
    const maxScroll = scrollSize - clientSize;
    const maxThumb = trackSize - thumbSize;
    const offset3 = maxScroll > 0 ? scroll / maxScroll * maxThumb : 0;
    thumb.style[a.sizeProp] = `${thumbSize}px`;
    thumb.style.transform = a.offsetTpl(offset3);
    track.style.setProperty(a.thumbVar, `${thumbSize}px`);
    const fromStart = scroll;
    const fromEnd = maxScroll - scroll;
    parts.viewport.style.setProperty(a.startVar, `${fromStart}px`);
    parts.viewport.style.setProperty(a.endVar, `${fromEnd}px`);
    env.attrs(element, { [a.startAttr]: fromStart > 0, [a.endAttr]: fromEnd > 0 });
  }
  env.effect("apply-state", () => {
    const measured = hasMeasured.value;
    const type = cfg.type.value;
    const overflowY = hasOverflowY.value;
    const overflowX = hasOverflowX.value;
    const hovering = isHovering.value;
    const scrolling = isScrolling.value;
    const dragging = isDraggingY.value || isDraggingX.value;
    const yVisible = measured && shouldShow(type, overflowY, hovering, scrolling, dragging);
    const xVisible = measured && shouldShow(type, overflowX, hovering, scrolling, dragging);
    if (parts.scrollbarY) {
      env.attrs(parts.scrollbarY, {
        "data-state": yVisible ? "visible" : "hidden",
        "data-hovering": hovering
      });
    }
    if (parts.scrollbarX) {
      env.attrs(parts.scrollbarX, {
        "data-state": xVisible ? "visible" : "hidden",
        "data-hovering": hovering
      });
    }
    if (parts.corner) {
      env.attrs(parts.corner, {
        "data-state": measured && overflowY && overflowX ? "visible" : "hidden"
      });
    }
    env.attrs(element, {
      "data-overflow-y": overflowY,
      "data-overflow-x": overflowX,
      "data-hovering": hovering,
      "data-scrolling": scrolling
    });
    if (parts.viewport) {
      const allowKeyboardScrolling = cfg.keyboardScrolling.value;
      parts.viewport.tabIndex = allowKeyboardScrolling && (overflowY || overflowX) ? 0 : -1;
    }
  }, { onUpdated: true });
  function shouldShow(type, overflow, hovering, scrolling, dragging) {
    if (type === "always") return true;
    if (!overflow) return false;
    if (dragging) return true;
    switch (type) {
      case "auto":
        return true;
      case "scroll":
        return scrolling;
      case "hover":
      default:
        return hovering || scrolling;
    }
  }
  function onScroll() {
    env.timeout.raf("sync-axes", syncAxes);
    if (!programmaticScroll) {
      isScrolling.value = true;
      env.timeout("scroll-end", () => {
        isScrolling.value = false;
        programmaticScroll = true;
      }, SCROLL_END_DEBOUNCE_MS + cfg.scrollHideDelay.value);
    }
  }
  env.on(parts.viewport, "scroll", onScroll, { passive: true });
  const heldPointers = /* @__PURE__ */ new Set();
  function expireIntent() {
    if (heldPointers.size > 0 || isScrolling.value) return;
    programmaticScroll = true;
  }
  function markIntent() {
    programmaticScroll = false;
    env.timeout("intent-expiry", expireIntent, SCROLL_END_DEBOUNCE_MS);
  }
  function ownInput(event) {
    if (!(event.target instanceof Element)) return false;
    return event.target.closest('[data-part="viewport"]') === parts.viewport;
  }
  for (const evt of ["wheel", "keydown", "touchstart"]) {
    env.on(parts.viewport, evt, (event) => {
      if (ownInput(event)) markIntent();
    }, { passive: true });
  }
  env.on(parts.viewport, "pointerdown", (event) => {
    if (!ownInput(event)) return;
    heldPointers.add(event.pointerId);
    markIntent();
  }, { passive: true });
  function releasePointer(event) {
    if (!heldPointers.delete(event.pointerId)) return;
    env.timeout("intent-expiry", expireIntent, SCROLL_END_DEBOUNCE_MS);
  }
  env.on(document, "pointerup", releasePointer, { capture: true });
  env.on(document, "pointercancel", releasePointer, { capture: true });
  env.effect("resize-observer", () => {
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(() => syncAxes());
    observer.observe(parts.viewport);
    observer.observe(parts.content);
    return () => observer.disconnect();
  });
  env.effect("sync-on-mount-and-patch", () => {
    syncAxes();
  }, { onUpdated: true });
  if (typeof element.getAnimations === "function") {
    env.timeout("wait-animations", async () => {
      try {
        const animations = element.getAnimations({ subtree: true });
        if (animations.length === 0) return;
        await Promise.allSettled(animations.map((a) => a.finished));
        syncAxes();
      } catch (_e) {
      }
    }, 0);
  }
  env.on(element, "pointerenter", (e) => {
    if (e.pointerType === "touch") return;
    isHovering.value = true;
  });
  env.on(element, "pointerleave", () => {
    isHovering.value = false;
  });
  let dragStateY = null;
  let dragStateX = null;
  function onDragPointerDown(axis) {
    const isY = axis === "y";
    const thumb = isY ? parts.thumbY : parts.thumbX;
    const track = isY ? parts.scrollbarY : parts.scrollbarX;
    if (!thumb || !track) return;
    return (event) => {
      if (event.button !== 0) return;
      event.preventDefault();
      try {
        thumb.setPointerCapture(event.pointerId);
      } catch (_) {
      }
      const v = parts.viewport;
      const trackRect = track.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const trackSize = isY ? trackRect.height : trackRect.width;
      const thumbSize = isY ? thumbRect.height : thumbRect.width;
      const maxThumb = trackSize - thumbSize;
      const maxScroll = isY ? v.scrollHeight - v.clientHeight : v.scrollWidth - v.clientWidth;
      const state = {
        pointerId: event.pointerId,
        startCursor: isY ? event.clientY : event.clientX,
        startScroll: isY ? v.scrollTop : v.scrollLeft,
        maxThumb,
        maxScroll
      };
      if (isY) {
        dragStateY = state;
        isDraggingY.value = true;
      } else {
        dragStateX = state;
        isDraggingX.value = true;
      }
    };
  }
  function dragEffect(axis) {
    const isY = axis === "y";
    const sig = isY ? isDraggingY : isDraggingX;
    const thumb = isY ? parts.thumbY : parts.thumbX;
    return () => {
      if (!sig.value || !thumb) return;
      const state = isY ? dragStateY : dragStateX;
      if (!state) return;
      const v = parts.viewport;
      const onMove = (e) => {
        const cursor = isY ? e.clientY : e.clientX;
        const deltaCursor = cursor - state.startCursor;
        const ratio = state.maxThumb > 0 ? deltaCursor / state.maxThumb : 0;
        const target = clamp3(state.startScroll + ratio * state.maxScroll, 0, state.maxScroll);
        markIntent();
        if (isY) v.scrollTop = target;
        else v.scrollLeft = target;
      };
      const onUp = (_e) => {
        try {
          thumb.releasePointerCapture(state.pointerId);
        } catch (_) {
        }
        sig.value = false;
      };
      thumb.addEventListener("pointermove", onMove);
      thumb.addEventListener("pointerup", onUp);
      thumb.addEventListener("pointercancel", onUp);
      return () => {
        thumb.removeEventListener("pointermove", onMove);
        thumb.removeEventListener("pointerup", onUp);
        thumb.removeEventListener("pointercancel", onUp);
        if (isY) dragStateY = null;
        else dragStateX = null;
      };
    };
  }
  if (parts.thumbY) env.on(parts.thumbY, "pointerdown", onDragPointerDown("y"));
  if (parts.thumbX) env.on(parts.thumbX, "pointerdown", onDragPointerDown("x"));
  env.effect("drag-y-listeners", dragEffect("y"));
  env.effect("drag-x-listeners", dragEffect("x"));
  function trackClick(axis) {
    const isY = axis === "y";
    return (event) => {
      const thumbSelector = isY ? '[data-part="thumb-y"]' : '[data-part="thumb-x"]';
      if (event.target.closest && event.target.closest(thumbSelector)) return;
      if (event.button !== 0) return;
      const v = parts.viewport;
      const track = isY ? parts.scrollbarY : parts.scrollbarX;
      const trackRect = track.getBoundingClientRect();
      const cursor = isY ? event.clientY - trackRect.top : event.clientX - trackRect.left;
      const trackSize = isY ? trackRect.height : trackRect.width;
      const clientSize = isY ? v.clientHeight : v.clientWidth;
      const scrollSize = isY ? v.scrollHeight : v.scrollWidth;
      const ratio = cursor / trackSize;
      const target = clamp3(ratio * scrollSize - clientSize / 2, 0, scrollSize - clientSize);
      markIntent();
      if (isY) v.scrollTop = target;
      else v.scrollLeft = target;
    };
  }
  if (parts.scrollbarY) env.on(parts.scrollbarY, "click", trackClick("y"));
  if (parts.scrollbarX) env.on(parts.scrollbarX, "click", trackClick("x"));
  function wheelForward(axis) {
    const isY = axis === "y";
    return (event) => {
      if (event.ctrlKey) return;
      const v = parts.viewport;
      const delta = isY ? event.deltaY : event.deltaX;
      const current = isY ? v.scrollTop : v.scrollLeft;
      const max2 = isY ? v.scrollHeight - v.clientHeight : v.scrollWidth - v.clientWidth;
      if (current <= 0 && delta < 0 || current >= max2 && delta > 0) return;
      event.preventDefault();
      markIntent();
      if (isY) v.scrollTop = current + delta;
      else v.scrollLeft = current + delta;
    };
  }
  if (parts.scrollbarY) {
    env.on(parts.scrollbarY, "wheel", wheelForward("y"), { passive: false });
  }
  if (parts.scrollbarX) {
    env.on(parts.scrollbarX, "wheel", wheelForward("x"), { passive: false });
  }
  return {
    sync: syncAxes,
    get isScrolling() {
      return isScrolling.value;
    },
    get isHovering() {
      return isHovering.value;
    },
    get hasOverflowY() {
      return hasOverflowY.value;
    },
    get hasOverflowX() {
      return hasOverflowX.value;
    },
    get hasMeasured() {
      return hasMeasured.value;
    }
  };
});
function clamp3(value, min2, max2) {
  return Math.max(min2, Math.min(max2, value));
}

// js/components/slider/math.js
var RATIO_DECIMALS = 6;
function valueToRatio(value, min2, max2) {
  if (max2 === min2) return 0;
  return clamp2((value - min2) / (max2 - min2), 0, 1);
}
function ratioToValue(ratio, min2, max2) {
  return (max2 - min2) * ratio + min2;
}
function formatRatio(ratio) {
  if (!Number.isFinite(ratio)) return "0";
  return String(Number(ratio.toFixed(RATIO_DECIMALS)));
}
function roundValueToStep(value, step, min2) {
  if (!Number.isFinite(step) || step <= 0) return value;
  const nearest = Math.round((value - min2) / step) * step + min2;
  const decimals = Math.max(decimalPlaces(step), decimalPlaces(min2));
  return Number(nearest.toFixed(Math.min(decimals, 20)));
}
function closestThumbIndex(ratios, pressRatio) {
  let index = -1;
  let minDistance;
  for (let i = 0; i < ratios.length; i += 1) {
    const distance = Math.abs(pressRatio - ratios[i]);
    if (minDistance === void 0 || distance <= minDistance) {
      index = i;
      minDistance = distance;
    }
  }
  while (index > 0 && ratios[index] === 1 && ratios[index - 1] === 1) {
    index -= 1;
  }
  return index;
}
function getPushedThumbValues({
  values,
  index,
  nextValue,
  minValueDifference,
  min: min2,
  max: max2,
  initialValues
}) {
  const lastIndex = values.length - 1;
  const baseline = initialValues ?? values;
  const next = values.slice();
  next[index] = clamp2(
    nextValue,
    min2 + index * minValueDifference,
    max2 - (lastIndex - index) * minValueDifference
  );
  for (let i = index + 1; i <= lastIndex; i += 1) {
    const minAllowed = next[i - 1] + minValueDifference;
    const maxAllowed = max2 - (lastIndex - i) * minValueDifference;
    let candidate = Math.max(next[i], minAllowed);
    const initial = baseline[i];
    if (Number.isFinite(initial) && initial < candidate) {
      candidate = Math.max(initial, minAllowed);
    }
    next[i] = clamp2(candidate, minAllowed, maxAllowed);
  }
  for (let i = index - 1; i >= 0; i -= 1) {
    const maxAllowed = next[i + 1] - minValueDifference;
    const minAllowed = min2 + i * minValueDifference;
    let candidate = Math.min(next[i], maxAllowed);
    const initial = baseline[i];
    if (Number.isFinite(initial) && initial > candidate) {
      candidate = Math.min(initial, maxAllowed);
    }
    next[i] = clamp2(candidate, minAllowed, maxAllowed);
  }
  return next.map((v) => Number(v.toFixed(12)));
}
function resolveThumbCollision({
  behavior,
  values,
  index,
  nextValue,
  minValueDifference,
  min: min2,
  max: max2,
  initialValues
}) {
  if (values.length === 1) {
    return [clamp2(nextValue, min2, max2)];
  }
  if (behavior === "push") {
    return getPushedThumbValues({
      values,
      index,
      nextValue,
      minValueDifference,
      min: min2,
      max: max2,
      initialValues
    });
  }
  const lower = index > 0 ? values[index - 1] + minValueDifference : min2;
  const upper = index < values.length - 1 ? values[index + 1] - minValueDifference : max2;
  const next = values.slice();
  next[index] = clamp2(nextValue, Math.max(lower, min2), Math.min(upper, max2));
  return next;
}

// js/components/slider/slider.js
var hook16 = defineComponent("slider", (element, env) => {
  const config = env.config(element, {
    // Numeric attrs are strings here because the framework's "number" parser is
    // integer-only (parseInt). We parse with parseFloat at use sites, same as
    // number_input.js:48-50.
    min: { type: "string", default: "0" },
    max: { type: "string", default: "100" },
    step: { type: "string", default: "1" },
    largeStep: { type: "string", default: "10" },
    minStepsBetweenValues: { type: "string", default: "0" },
    orientation: { type: "enum", values: ["horizontal", "vertical"], default: "horizontal" },
    thumbCollision: { type: "enum", values: ["push", "none"], default: "push" },
    range: { type: "boolean", default: false },
    locale: { type: "string", default: "en" },
    format: { type: "json", default: {} }
  });
  const parts = env.parts(element, {
    control: { selector: '[data-part="control"]', required: true },
    track: { selector: '[data-part="track"]', required: true },
    thumbs: { selector: '[data-part="thumb"]', multiple: true },
    hidden: { selector: '[data-part="hidden"]', multiple: true },
    ticks: { selector: '[data-part="tick"]', multiple: true }
  });
  const values = env.signal(readServerValues(), { name: "values", equals: arraysShallowEqual });
  const activeIndex = env.signal(-1, "activeIndex");
  function isDragging() {
    return activeIndex.value >= 0;
  }
  function toFiniteNumber(input) {
    const n = typeof input === "number" ? input : parseAttr(String(input), null);
    return Number.isFinite(n) ? n : null;
  }
  function readServerValues() {
    const raw = element.getAttribute("data-value");
    try {
      const parsed = JSON.parse(raw);
      const list = (Array.isArray(parsed) ? parsed : [parsed]).map(toFiniteNumber).filter((v) => v !== null);
      return list.length > 0 ? list : [getMin()];
    } catch {
      return [getMin()];
    }
  }
  function numberFrom(signalValue, fallback) {
    const n = toFiniteNumber(signalValue);
    return n === null ? fallback : n;
  }
  function getMin() {
    return numberFrom(config.min.value, 0);
  }
  function getMax2() {
    return numberFrom(config.max.value, 100);
  }
  function getStep() {
    const step = numberFrom(config.step.value, 1);
    return step > 0 ? step : 1;
  }
  function getLargeStep() {
    return numberFrom(config.largeStep.value, 10);
  }
  function getMinValueDifference() {
    return getStep() * numberFrom(config.minStepsBetweenValues.value, 0);
  }
  function isVertical() {
    return config.orientation.value === "vertical";
  }
  function roundDecimals(value, ...refs) {
    const decimals = Math.max(0, ...refs.map((r) => decimalPlaces(r)));
    if (decimals === 0) return value;
    return Number(value.toFixed(Math.min(decimals, 20)));
  }
  function setProp(el, name, value) {
    if (!el) return;
    if (el.style.getPropertyValue(name).trim() === value) return;
    el.style.setProperty(name, value);
  }
  function outward(list) {
    return config.range.value ? list.slice() : list[0];
  }
  function payload(reason, previous) {
    return {
      value: outward(values.value),
      previousValue: outward(previous),
      reason
    };
  }
  function emitChanged(reason, previous) {
    env.emit("changed", payload(reason, previous));
  }
  function emitCommitted(reason, previous) {
    notifyForm();
    env.emit("committed", payload(reason, previous));
  }
  function notifyForm() {
    const input = parts.hidden[0];
    if (!input) return;
    env.emitNative(input, ["input", "change"]);
  }
  function applyValue(index, nextValue, reason, { initialValues, commit = false } = {}) {
    if (index < 0) return false;
    const previous = values.value;
    const next = resolveThumbCollision({
      behavior: config.thumbCollision.value,
      values: previous,
      index,
      nextValue,
      minValueDifference: getMinValueDifference(),
      min: getMin(),
      max: getMax2(),
      initialValues
    });
    if (arraysShallowEqual(next, previous)) return false;
    values.value = next;
    emitChanged(reason, previous);
    if (commit) emitCommitted(reason, previous);
    return true;
  }
  env.effect("sync-positions", () => {
    const list = values.value;
    const min2 = getMin();
    const max2 = getMax2();
    const ratios = list.map((v) => valueToRatio(v, min2, max2));
    const thumbs = parts.thumbs;
    ratios.forEach((ratio, index) => {
      setProp(thumbs[index], "--fluxon-slider-thumb", formatRatio(ratio));
    });
    setProp(element, "--fluxon-slider-start", formatRatio(ratios[0] ?? 0));
    setProp(element, "--fluxon-slider-end", formatRatio(ratios[ratios.length - 1] ?? 0));
  });
  env.effect("sync-ticks", () => {
    const list = values.value;
    const ticks = parts.ticks;
    if (ticks.length === 0) return;
    const isRange = config.range.value && list.length > 1;
    const lower = isRange ? Math.min(...list) : -Infinity;
    const upper = isRange ? Math.max(...list) : list[0];
    ticks.forEach((tick) => {
      const tickValue = parseAttr(tick.getAttribute("data-value"), null);
      if (tickValue === null) return;
      env.attrs(tick, { "data-active": tickValue >= lower && tickValue <= upper });
    });
  });
  env.effect("sync-aria", () => {
    const list = values.value;
    const locale = config.locale.value;
    const format = config.format.value;
    parts.thumbs.forEach((thumb, index) => {
      const value = list[index];
      if (value === void 0) return;
      const canonical = canonicalString(value);
      env.attrs(thumb, { "aria-valuenow": canonical });
      const valueText = formatLocalized(value, locale, format);
      env.attrs(thumb, { "aria-valuetext": valueText && valueText !== canonical ? valueText : null });
    });
  });
  env.effect(
    "sync-hidden",
    () => {
      const list = values.value;
      parts.hidden.forEach((input, index) => {
        const value = list[index];
        if (value === void 0) return;
        const canonical = canonicalString(value);
        if (input.value === canonical) return;
        input.value = canonical;
      });
    },
    { onUpdated: true }
  );
  env.effect("sync-state", () => {
    const active = activeIndex.value;
    env.attrs(element, { "data-dragging": active >= 0 });
    parts.thumbs.forEach((thumb, index) => {
      env.attrs(thumb, { "data-dragging": active === index });
    });
  });
  let lastValueAttr = element.getAttribute("data-value");
  env.effect(
    "sync-from-server",
    () => {
      const incoming = element.getAttribute("data-value");
      if (incoming === lastValueAttr) return;
      lastValueAttr = incoming;
      if (isDragging()) return;
      values.value = readServerValues();
    },
    { onUpdated: true }
  );
  function thumbIndexOf(el) {
    const index = Number(el?.getAttribute("data-index"));
    return Number.isInteger(index) ? index : -1;
  }
  function thumbSize() {
    const thumb = parts.thumbs[0];
    if (!thumb) return 0;
    const rect = thumb.getBoundingClientRect();
    return isVertical() ? rect.height : rect.width;
  }
  function valueFromPointer(event, { grabOffset = 0, inset }) {
    const rect = parts.track.getBoundingClientRect();
    const min2 = getMin();
    const max2 = getMax2();
    const size3 = (isVertical() ? rect.height : rect.width) - inset;
    if (size3 <= 0) return null;
    const position = isVertical() ? (
      // Vertical runs bottom-up: the bottom of the track is the minimum.
      rect.bottom - (event.clientY - grabOffset)
    ) : event.clientX - grabOffset - rect.left;
    const ratio = clampRatio((position - inset / 2) / size3);
    return clamp2(roundValueToStep(ratioToValue(ratio, min2, max2), getStep(), min2), min2, max2);
  }
  function clampRatio(ratio) {
    if (!Number.isFinite(ratio)) return 0;
    return clamp2(ratio, 0, 1);
  }
  function centreOf(thumb) {
    const rect = thumb.getBoundingClientRect();
    return isVertical() ? rect.top + rect.height / 2 : rect.left + rect.width / 2;
  }
  let focusFromPointer = false;
  function setKeyboardFocus(thumb, on2) {
    if (thumb) env.attrs(thumb, { "data-keyboard-focus": on2 });
  }
  env.on(parts.control, "focusin", (event) => {
    const thumb = event.target.closest?.('[data-part="thumb"]');
    if (!thumb) return;
    setKeyboardFocus(thumb, !focusFromPointer);
    focusFromPointer = false;
  });
  env.on(parts.control, "focusout", (event) => {
    setKeyboardFocus(event.target.closest?.('[data-part="thumb"]'), false);
    focusFromPointer = false;
  });
  env.on(parts.control, "pointerdown", (event) => {
    if (isDisabled(parts.control)) return;
    if (event.button !== 0) return;
    const pressedThumb = event.target.closest?.('[data-part="thumb"]');
    const pressedIndex = thumbIndexOf(pressedThumb);
    const inset = thumbSize();
    let index = pressedIndex;
    let grabOffset = 0;
    let pressValue = null;
    if (pressedIndex >= 0) {
      const pointer = isVertical() ? event.clientY : event.clientX;
      grabOffset = pointer - centreOf(pressedThumb);
    } else {
      pressValue = valueFromPointer(event, { inset });
      if (pressValue === null) return;
      const min2 = getMin();
      const max2 = getMax2();
      const ratios = values.value.map((v) => valueToRatio(v, min2, max2));
      index = closestThumbIndex(ratios, valueToRatio(pressValue, min2, max2));
    }
    if (index < 0) return;
    focusFromPointer = true;
    setKeyboardFocus(parts.thumbs[index], false);
    event.preventDefault();
    parts.thumbs[index]?.focus({ preventScroll: true });
    activeIndex.value = index;
    const initialValues = values.value.slice();
    if (pressValue !== null) {
      applyValue(index, pressValue, "track-press", { initialValues });
    }
    if (event.pointerId !== void 0 && parts.control.setPointerCapture) {
      try {
        parts.control.setPointerCapture(event.pointerId);
      } catch {
      }
    }
    startDrag({ index, grabOffset, initialValues, inset, pointerId: event.pointerId });
  });
  function startDrag({ index, grabOffset, initialValues, inset, pointerId }) {
    const session = new AbortController();
    let stopped = false;
    const stop = () => {
      if (stopped) return;
      stopped = true;
      session.abort();
      activeIndex.value = -1;
      if (pointerId !== void 0 && parts.control?.hasPointerCapture?.(pointerId)) {
        parts.control.releasePointerCapture(pointerId);
      }
      if (!arraysShallowEqual(initialValues, values.value)) {
        emitCommitted("drag", initialValues);
      }
    };
    env.on(
      document,
      "pointermove",
      (moveEvent) => {
        if (moveEvent.buttons === 0) {
          stop();
          return;
        }
        const next = valueFromPointer(moveEvent, { grabOffset, inset });
        if (next !== null) applyValue(index, next, "drag", { initialValues });
      },
      { signal: session.signal }
    );
    env.on(document, "pointerup", stop, { once: true, signal: session.signal });
    env.on(document, "pointercancel", stop, { once: true, signal: session.signal });
    env.on(window, "blur", stop, { once: true, signal: session.signal });
    env.on(
      document,
      "visibilitychange",
      () => {
        if (document.hidden) stop();
      },
      { signal: session.signal }
    );
  }
  env.on(
    parts.control,
    "keydown",
    (event, thumb) => {
      if (isDisabled(parts.control)) return;
      const index = thumbIndexOf(thumb);
      if (index < 0) return;
      const min2 = getMin();
      const max2 = getMax2();
      const step = getStep();
      const gap = getMinValueDifference();
      const list = values.value;
      const current = roundValueToStep(list[index], step, min2);
      let next;
      switch (event.key) {
        case "ArrowUp":
        case "ArrowRight":
          next = current + (event.shiftKey ? getLargeStep() : step);
          break;
        case "ArrowDown":
        case "ArrowLeft":
          next = current - (event.shiftKey ? getLargeStep() : step);
          break;
        case "PageUp":
          next = current + getLargeStep();
          break;
        case "PageDown":
          next = current - getLargeStep();
          break;
        case "Home":
          next = Number.isFinite(list[index - 1]) ? list[index - 1] + gap : min2;
          break;
        case "End":
          next = Number.isFinite(list[index + 1]) ? list[index + 1] - gap : max2;
          break;
        default:
          return;
      }
      event.preventDefault();
      event.stopPropagation();
      setKeyboardFocus(thumb, true);
      const amount = event.shiftKey ? getLargeStep() : step;
      applyValue(index, roundDecimals(next, current, amount, min2), "keyboard", { commit: true });
    },
    { delegate: '[data-part="thumb"]' }
  );
  return {
    get value() {
      return outward(values.value);
    },
    setValue(next) {
      if (next === null || next === void 0) return false;
      const incoming = Array.isArray(next) ? next : [next];
      const parsed = incoming.map(toFiniteNumber);
      if (parsed.some((v) => v === null)) return false;
      if (parsed.length !== values.value.length) return false;
      const previous = values.value;
      const min2 = getMin();
      const max2 = getMax2();
      let list = previous;
      parsed.forEach((value, index) => {
        list = resolveThumbCollision({
          behavior: config.thumbCollision.value,
          values: list,
          index,
          nextValue: value,
          minValueDifference: getMinValueDifference(),
          min: min2,
          max: max2
        });
      });
      if (arraysShallowEqual(list, previous)) return false;
      values.value = list;
      emitChanged("api", previous);
      emitCommitted("api", previous);
      return true;
    }
  };
});

// js/components/textarea/textarea.js
var hook17 = defineComponent("textarea", (element, env) => {
  const wrapper = element.closest('[data-part="autogrow"]');
  if (!wrapper) return;
  const nativeValue = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value");
  const sync = () => {
    wrapper.dataset.autogrowValue = element.value;
  };
  sync();
  const observer = new MutationObserver(() => {
    if (wrapper.dataset.autogrowValue !== element.value) sync();
  });
  observer.observe(wrapper, { attributeFilter: ["data-autogrow-value"] });
  env.cleanup(() => observer.disconnect());
  if (nativeValue && !Object.prototype.hasOwnProperty.call(element, "value")) {
    Object.defineProperty(element, "value", {
      configurable: true,
      enumerable: false,
      get() {
        return nativeValue.get.call(this);
      },
      set(next) {
        nativeValue.set.call(this, next);
        sync();
      }
    });
    env.cleanup(() => {
      delete element.value;
    });
  }
  env.on(document, "reset", (event) => {
    if (event.target === element.form) env.timeout.raf("reset-sync", sync);
  });
});

// js/hooks.js
var hooks_default = {
  "Fluxon.Tooltip": hook,
  "Fluxon.Popover": hook2,
  "Fluxon.Tabs": hook3,
  "Fluxon.Dropdown": hook4,
  "Fluxon.Dialog": hook5,
  "Fluxon.Select": hook6,
  "Fluxon.TagsInput": hook7,
  "Fluxon.Accordion": hook8,
  "Fluxon.Calendar": hook9,
  "Fluxon.DatePicker": hook10,
  "Fluxon.Autocomplete": hook11,
  "Fluxon.NumberInput": hook12,
  "Fluxon.Input": hook13,
  "Fluxon.Toast": hook14,
  "Fluxon.ScrollArea": hook15,
  "Fluxon.Slider": hook16,
  "Fluxon.Textarea": hook17
};

// js/fluxon.js
var globalListeners = /* @__PURE__ */ new Map();
function on(event, selectorOrHandler, maybeHandler) {
  const hasSelector = typeof selectorOrHandler === "string";
  const selector = hasSelector ? selectorOrHandler : null;
  const handler = hasSelector ? maybeHandler : selectorOrHandler;
  if (typeof handler !== "function") {
    throw new Error("Fluxon.on requires a handler function");
  }
  const wrappedHandler = (e) => {
    if (selector) {
      const target = e.target.closest(selector);
      if (!target) return;
      handler(e, target);
    } else {
      handler(e);
    }
  };
  if (!globalListeners.has(handler)) {
    globalListeners.set(handler, /* @__PURE__ */ new Map());
  }
  const handlerMap = globalListeners.get(handler);
  const key = `${event}:${selector || ""}`;
  handlerMap.set(key, wrappedHandler);
  document.addEventListener(event, wrappedHandler);
  return () => off(event, handler, selector);
}
function off(event, handler, selector = null) {
  const handlerMap = globalListeners.get(handler);
  if (!handlerMap) return false;
  const key = `${event}:${selector || ""}`;
  const wrappedHandler = handlerMap.get(key);
  if (wrappedHandler) {
    document.removeEventListener(event, wrappedHandler);
    handlerMap.delete(key);
    if (handlerMap.size === 0) {
      globalListeners.delete(handler);
    }
    return true;
  }
  return false;
}
function get(selectorOrElement) {
  if (selectorOrElement instanceof Element) {
    return getComponentByElement(selectorOrElement);
  }
  if (typeof selectorOrElement === "string") {
    const element = document.querySelector(selectorOrElement);
    return getComponentByElement(element);
  }
  return null;
}
function enableLogging() {
  logger_default.enable();
}
function disableLogging() {
  logger_default.disable();
}
var Fluxon = {
  on,
  off,
  get,
  enableLogging,
  disableLogging
};
if (typeof window !== "undefined") {
  window.Fluxon = Fluxon;
}
var fluxon_default = Fluxon;

// js/components/toast/standalone.js
function mountStandaloneToasters(root = document) {
  if (typeof document === "undefined") return;
  for (const el of root.querySelectorAll('[data-part="toaster"]')) {
    if (getComponentByElement(el)) continue;
    el.__fluxonToastStandalone = hook14.mount(el);
  }
}
if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => mountStandaloneToasters(), { once: true });
  } else {
    mountStandaloneToasters();
  }
}

// js/index.js
var DOM = {
  // Preserve attributes from `from` to `to` during LiveView DOM patches.
  // Elements opt in by adding a `keep-` prefix, e.g.:
  // <div keep-data-highlighted data-highlighted> preserves the data-highlighted attribute
  // <div keep-aria-selected aria-selected> preserves the aria-selected attribute
  copyDataAttributes(from, to) {
    const keepAttributes = Array.from(from.attributes).filter((attr) => attr.name.startsWith("keep-")).map((attr) => attr.name.replace("keep-", ""));
    keepAttributes.forEach((attrName) => {
      if (from.hasAttribute(attrName)) {
        to.setAttribute(attrName, from.getAttribute(attrName));
      }
    });
  },
  // Preserve client-managed visual state during LiveView DOM patches.
  // Elements opt in declaratively:
  // - `keep-hidden`: preserves the `hidden` property (animations toggling visibility)
  // - `keep-style`: preserves inline styles (Floating UI position, motion transforms)
  // - `keep-class`: preserves className (animation classes added by motion)
  onBeforeElUpdated(from, to) {
    if (from.hasAttribute("keep-hidden")) to.hidden = from.hidden;
    if (from.hasAttribute("keep-style")) to.style.cssText = from.style.cssText;
    if (from.hasAttribute("keep-class")) to.className = from.className;
    this.copyDataAttributes(from, to);
    if (/^(OPTION|SELECT|INPUT|TEXTAREA)$/.test(from.nodeName)) resyncAfterPatch(from);
  }
};
export {
  DOM,
  fluxon_default as Fluxon,
  hooks_default as Hooks
};
